export const Logo = ({ className, ...rest }) => (
  <svg
    width="196"
    height="57"
    viewBox="0 0 196 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <g clip-path="url(#clip0_2667_586)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#1D1D1B"
      />
      <path
        d="M20.2315 14.0957C16.9187 14.0957 14.2343 16.7801 14.2343 20.0929C14.2343 23.4057 16.9187 26.0901 20.2315 26.0901C23.5443 26.0901 26.2287 23.4057 26.2287 20.0929C26.2247 16.7801 23.5403 14.0957 20.2315 14.0957ZM20.2315 23.0557C18.593 23.0557 17.2687 21.7274 17.2687 20.0929C17.2687 18.4544 18.5969 17.1301 20.2315 17.1301C21.866 17.1301 23.1943 18.4584 23.1943 20.0929C23.1943 21.7274 21.866 23.0557 20.2315 23.0557Z"
        fill="#E43625"
      />
      <path
        d="M25.1355 2.60539C23.8867 1.33675 22.1528 0.549316 20.2319 0.549316C18.3111 0.549316 16.5771 1.33675 15.3284 2.60539H25.1355Z"
        fill="#EE7F25"
      />
      <path
        d="M37.4214 24.8843C38.69 23.6355 39.4775 21.9016 39.4775 19.9807C39.4775 18.0598 38.69 16.3259 37.4214 15.0771V24.8843Z"
        fill="#FFCE1B"
      />
      <path
        d="M2.80437 15.0771C1.53572 16.3259 0.748291 18.0598 0.748291 19.9807C0.748291 21.9016 1.53572 23.6355 2.80437 24.8843V15.0771Z"
        fill="#6F368B"
      />
      <path
        d="M15.3253 37.2744C16.5741 38.5431 18.308 39.3305 20.2289 39.3305C22.1497 39.3305 23.8837 38.5431 25.1324 37.2744H15.3253Z"
        fill="#3091D0"
      />
      <path
        d="M26.0405 6.09457C24.8196 4.16973 22.676 2.88916 20.2302 2.88916C17.7844 2.88916 15.6408 4.16973 14.4199 6.09457H26.0405Z"
        fill="#3091D0"
      />
      <path
        d="M33.9384 25.791C35.8632 24.5701 37.1438 22.4265 37.1438 19.9807C37.1438 17.5349 35.8632 15.3913 33.9384 14.1704V25.791Z"
        fill="#6F368B"
      />
      <path
        d="M6.30197 14.1704C4.37713 15.3913 3.09656 17.5349 3.09656 19.9807C3.09656 22.4265 4.37713 24.5701 6.30197 25.791V14.1704Z"
        fill="#FFCE1B"
      />
      <path
        d="M14.4199 33.7769C15.6408 35.7017 17.7844 36.9823 20.2302 36.9823C22.676 36.9823 24.8196 35.7017 26.0405 33.7769H14.4199Z"
        fill="#54AD47"
      />
      <path
        d="M13.4067 29.7006C11.7562 29.6012 10.424 28.3325 10.2331 26.71H6.74927C6.95209 30.2455 9.82344 33.0611 13.3828 33.1804L13.4067 29.7006Z"
        fill="#6F368B"
      />
      <path
        d="M29.9051 26.6084C29.8057 28.2588 28.537 29.5911 26.9144 29.782V33.2658C30.4499 33.063 33.2656 30.1916 33.3849 26.6323L29.9051 26.6084Z"
        fill="#EE7F25"
      />
      <path
        d="M26.729 10.0404C28.3794 10.1398 29.7117 11.4084 29.9026 13.031H33.3864C33.1836 9.49552 30.3122 6.67985 26.7529 6.56055L26.729 10.0404Z"
        fill="#FFCE1B"
      />
      <path
        d="M10.2291 13.1256C10.3285 11.4752 11.5972 10.1429 13.2197 9.95205V6.46826C9.68425 6.67109 6.86858 9.54243 6.74927 13.1018L10.2291 13.1256Z"
        fill="#E43625"
      />
      <path
        d="M6.49209 7.35156L6.35687 12.9789L3.11169 13.0982L3.1793 11.4438C3.1793 11.4438 4.31273 8.82303 6.49209 7.35156Z"
        fill="#FFCE1B"
      />
      <path
        d="M33.7545 7.31104L33.8897 12.9384L37.1349 13.0577L37.0673 11.4033C37.0673 11.3993 35.9339 8.7825 33.7545 7.31104Z"
        fill="#3091D0"
      />
      <path
        d="M33.7545 32.1065L33.8897 26.4792L37.1349 26.3599L37.0673 28.0143C37.0673 28.0182 35.9339 30.639 33.7545 32.1065Z"
        fill="#FFCE1B"
      />
      <path
        d="M6.49209 32.1563L6.35687 26.529L3.11169 26.4097L3.1793 28.0641C3.1793 28.0641 4.31273 30.6849 6.49209 32.1563Z"
        fill="#3091D0"
      />
      <path
        d="M7.69177 6.11822C7.69177 6.11822 10.2251 3.2946 11.8477 2.87305H13.7248L13.7089 6.11822H7.69177Z"
        fill="#54AD47"
      />
      <path
        d="M32.8736 6.21051C32.8736 6.21051 30.3403 3.38689 28.7177 2.96533H26.8446L26.8605 6.21051H32.8736Z"
        fill="#6F368B"
      />
      <path
        d="M32.8736 33.5122C32.8736 33.5122 30.3403 36.3358 28.7177 36.7574H26.8446L26.8605 33.5122H32.8736Z"
        fill="#E43625"
      />
      <path
        d="M7.69177 33.4219C7.69177 33.4219 10.2251 36.2455 11.8477 36.6671H13.7248L13.7089 33.4219H7.69177Z"
        fill="#EE7F25"
      />
      <path
        d="M17.2194 20.3398H14.2765V32.04H17.2194V20.3398Z"
        fill="#E43625"
      />
      <path
        d="M16.8488 13.0092C16.9443 11.2156 18.4237 9.79183 20.2412 9.79183C22.0586 9.79183 23.538 11.2156 23.6335 13.0092H27.1133C27.0139 9.29471 23.9795 6.31201 20.2412 6.31201C16.5028 6.31201 13.4684 9.29471 13.369 13.0092H16.8488Z"
        fill="#EE7F25"
      />
      <path
        d="M27.0294 16.5872C28.823 16.6827 30.2468 18.1621 30.2468 19.9796C30.2468 21.797 28.823 23.2764 27.0294 23.3719V26.8517C30.7439 26.7523 33.7266 23.7179 33.7266 19.9796C33.7266 16.2412 30.7439 13.2068 27.0294 13.1074V16.5872Z"
        fill="#54AD47"
      />
      <path
        d="M13.223 23.3719C11.4294 23.2764 10.0057 21.797 10.0057 19.9796C10.0057 18.1621 11.4294 16.6827 13.223 16.5872V13.1074C9.50858 13.2068 6.52588 16.2412 6.52588 19.9796C6.52588 23.7179 9.50858 26.7523 13.223 26.8517V23.3719Z"
        fill="#3091D0"
      />
      <path
        d="M23.4838 26.6108C23.3844 28.2613 22.1158 29.5935 20.4932 29.7844V33.2682C24.0287 33.0654 26.8443 30.1941 26.9636 26.6347L23.4838 26.6108Z"
        fill="#FFCE1B"
      />
      <path
        d="M62.4455 18.993C62.4455 23.2395 59.8171 26.0617 55.9812 26.0617C54.6212 26.0617 53.4443 25.6292 52.4853 24.8515V31.3611H48V12.1427H52.1759L52.2979 13.165C53.2569 12.3262 54.4948 11.8325 55.9769 11.8325C59.8171 11.8631 62.4455 14.8383 62.4455 18.993ZM57.934 18.993C57.934 17.1625 56.8225 15.7076 55.1487 15.7076C53.1697 15.7076 52.3023 16.979 52.3023 18.9624C52.3023 20.9764 53.3528 22.1866 55.1487 22.1866C56.8181 22.1866 57.934 20.9153 57.934 18.993Z"
        fill="#1D1D1B"
      />
      <path
        d="M74.7881 11.9548L74.5092 15.5809C74.3566 15.5504 74.1997 15.5198 73.6723 15.5198C71.2923 15.5198 69.6533 16.7911 69.6533 18.5867V25.7777H65.168V12.1427H69.3438L69.5313 13.816C70.3377 12.5752 71.6671 11.8325 73.6461 11.8325C74.1038 11.8325 74.5397 11.8937 74.7881 11.9548Z"
        fill="#1D1D1B"
      />
      <path
        d="M90.4103 18.9318C90.4103 23.0865 87.4419 26.0923 83.0786 26.0923C78.6848 26.0923 75.7773 23.0865 75.7773 18.9318C75.7773 14.8383 78.6848 11.8325 83.0786 11.8325C87.4419 11.8325 90.4103 14.8383 90.4103 18.9318ZM85.8944 18.9318C85.8944 17.0401 84.7829 15.7076 83.0786 15.7076C81.3481 15.7076 80.2932 17.0401 80.2932 18.9318C80.2932 20.8847 81.3437 22.2172 83.0786 22.2172C84.7786 22.2172 85.8944 20.8847 85.8944 18.9318Z"
        fill="#1D1D1B"
      />
      <path
        d="M103.396 25.2537C102.529 25.7474 101.138 26.0925 99.4992 26.0925C96.1297 26.0925 93.9328 24.2926 93.9328 21.1033V15.7996H91.9844V12.1429H93.9328V8.63916H98.4182V12.1429H102.625V15.769H98.4182V20.5136C98.4182 21.7543 99.1592 22.1868 100.245 22.1868C100.894 22.1868 101.513 22.0951 102.315 21.7543L103.396 25.2537Z"
        fill="#1D1D1B"
      />
      <path
        d="M118.428 20.1726H109.148C109.579 21.4745 110.756 22.3438 112.613 22.3438C114.099 22.3438 114.932 22.0337 115.673 21.5356L117.499 24.4496C116.449 25.2229 114.871 26.0923 112.303 26.0923C107.57 26.0923 104.571 23.0865 104.571 18.9318C104.571 14.6853 107.387 11.8325 111.593 11.8325C115.86 11.8325 118.55 14.3752 118.55 18.9624C118.554 19.3687 118.493 19.9279 118.428 20.1726ZM109.152 17.5076H114.439C114.16 16.2057 113.358 15.5242 111.872 15.5242C110.542 15.5242 109.522 16.1139 109.152 17.5076Z"
        fill="#1D1D1B"
      />
      <path
        d="M133.241 17.8484V25.7821H128.973L128.943 24.9739C128.014 25.686 126.776 26.0879 125.477 26.0879C122.382 26.0879 120.129 24.3535 120.129 21.5618C120.129 18.5867 122.448 17.0052 125.974 17.0052C127.055 17.0052 128.08 17.2542 128.882 17.7785V17.6255C128.882 16.1052 127.892 15.2402 125.416 15.2402C123.869 15.2402 123.006 15.5504 122.23 15.83L122.6 12.2956C123.219 12.1078 124.488 11.8325 126.436 11.8325C130.983 11.8369 133.241 14.3795 133.241 17.8484ZM128.882 21.5706C128.882 20.889 128.354 19.9891 126.746 19.9891C125.477 19.9891 124.645 20.6094 124.645 21.5706C124.645 22.5317 125.482 23.1215 126.746 23.1215C128.075 23.1171 128.882 22.4662 128.882 21.5706Z"
        fill="#1D1D1B"
      />
      <path
        d="M149.879 17.4726V25.7821H145.363V17.6605C145.363 16.577 144.622 15.6771 143.135 15.6771C141.867 15.6771 140.938 16.4853 140.938 17.6911V25.7821H136.453V12.1427H140.659L140.782 13.3223C141.492 12.4223 142.669 11.8325 144.46 11.8325C148.026 11.8325 149.879 13.9383 149.879 17.4726Z"
        fill="#1D1D1B"
      />
    </g>
    <path
      d="M0.307617 51L1.66553 44.5752H5.08008L4.89551 45.4629H2.51807L2.09619 47.4712H4.31543L4.12207 48.3589H1.90283L1.34473 51H0.307617ZM6.79395 51.0791C6.4248 51.0791 6.10254 51.0029 5.82715 50.8506C5.55176 50.6982 5.33789 50.4829 5.18555 50.2046C5.03613 49.9233 4.96143 49.5908 4.96143 49.207C4.96143 48.8818 4.99512 48.5654 5.0625 48.2578C5.13281 47.9502 5.23535 47.6631 5.37012 47.3965C5.50488 47.1299 5.67334 46.897 5.87549 46.6978C6.07764 46.4956 6.31201 46.3389 6.57861 46.2275C6.84521 46.1133 7.14404 46.0562 7.4751 46.0562C7.85303 46.0562 8.17822 46.1323 8.45068 46.2847C8.72314 46.437 8.93262 46.6553 9.0791 46.9395C9.22559 47.2236 9.29883 47.5635 9.29883 47.959C9.29883 48.2754 9.26514 48.5845 9.19775 48.8862C9.1333 49.188 9.03516 49.4722 8.90332 49.7388C8.77148 50.0024 8.60449 50.2354 8.40234 50.4375C8.20312 50.6367 7.96875 50.7935 7.69922 50.9077C7.43262 51.022 7.13086 51.0791 6.79395 51.0791ZM6.86865 50.2354C7.03271 50.2354 7.18506 50.1987 7.32568 50.1255C7.46924 50.0493 7.59814 49.9424 7.7124 49.8047C7.82666 49.6641 7.92334 49.4985 8.00244 49.3081C8.08447 49.1147 8.14746 48.9009 8.19141 48.6665C8.23535 48.4321 8.25732 48.1816 8.25732 47.915C8.25732 47.7363 8.23096 47.5708 8.17822 47.4185C8.12549 47.2632 8.0376 47.1387 7.91455 47.0449C7.79443 46.9482 7.6333 46.8999 7.43115 46.8999C7.24951 46.8999 7.08252 46.9438 6.93018 47.0317C6.78076 47.1167 6.64746 47.2354 6.53027 47.3877C6.41602 47.54 6.31934 47.7158 6.24023 47.915C6.16113 48.1113 6.10107 48.3223 6.06006 48.5479C6.01904 48.7705 5.99854 48.9961 5.99854 49.2246C5.99854 49.5498 6.07178 49.8003 6.21826 49.9761C6.36768 50.1489 6.58447 50.2354 6.86865 50.2354ZM9.92285 51L10.9556 46.1353H11.7598L11.6543 47.0537H11.7026C11.8286 46.8662 11.9648 46.6963 12.1113 46.5439C12.2607 46.3916 12.4263 46.27 12.6079 46.1792C12.7896 46.0884 12.9917 46.043 13.2144 46.043C13.2935 46.043 13.3755 46.0488 13.4604 46.0605C13.5483 46.0693 13.6245 46.0825 13.689 46.1001L13.4648 47.0669C13.4004 47.0493 13.3301 47.0347 13.2539 47.0229C13.1777 47.0112 13.0972 47.0054 13.0122 47.0054C12.8188 47.0054 12.6372 47.0508 12.4673 47.1416C12.2974 47.2324 12.1436 47.3584 12.0059 47.5195C11.8682 47.6807 11.7495 47.8696 11.6499 48.0864C11.5503 48.3003 11.4727 48.5332 11.417 48.7852L10.9512 51H9.92285ZM13.5967 51L14.6294 46.1353H15.4336L15.3281 47.0537H15.3721C15.4863 46.8809 15.6182 46.7183 15.7676 46.5659C15.9199 46.4106 16.0913 46.2847 16.2817 46.188C16.4751 46.0913 16.6919 46.043 16.9321 46.043C17.272 46.043 17.5312 46.1367 17.71 46.3242C17.8916 46.5117 18.0044 46.7681 18.0483 47.0933H18.0835C18.2036 46.9058 18.3428 46.7329 18.501 46.5747C18.6621 46.4165 18.8423 46.2891 19.0415 46.1924C19.2437 46.0928 19.4634 46.043 19.7007 46.043C20.0933 46.043 20.3906 46.1572 20.5928 46.3857C20.7949 46.6143 20.896 46.9336 20.896 47.3438C20.896 47.4668 20.8872 47.5928 20.8696 47.7217C20.855 47.8506 20.8315 47.9839 20.7993 48.1216L20.1929 51H19.1646L19.793 48.0469C19.8164 47.9326 19.834 47.8301 19.8457 47.7393C19.8604 47.6455 19.8677 47.5576 19.8677 47.4756C19.8677 47.2852 19.8223 47.1401 19.7314 47.0405C19.6436 46.938 19.5088 46.8867 19.3271 46.8867C19.1748 46.8867 19.0239 46.9321 18.8745 47.0229C18.728 47.1138 18.5889 47.2456 18.457 47.4185C18.3252 47.5913 18.208 47.8008 18.1055 48.0469C18.0029 48.29 17.9194 48.5654 17.855 48.873L17.4067 51H16.3828L17.0024 48.0557C17.0288 47.9385 17.0479 47.833 17.0596 47.7393C17.0713 47.6455 17.0771 47.5635 17.0771 47.4932C17.0771 47.2969 17.0347 47.1475 16.9497 47.0449C16.8677 46.9395 16.7358 46.8867 16.5542 46.8867C16.4019 46.8867 16.251 46.9321 16.1016 47.0229C15.9521 47.1138 15.8115 47.2471 15.6797 47.4229C15.5479 47.5986 15.4292 47.8125 15.3237 48.0645C15.2183 48.3135 15.1318 48.5991 15.0645 48.9214L14.625 51H13.5967ZM23.647 51.0879C23.2749 51.0879 22.9497 51.0176 22.6714 50.877C22.396 50.7334 22.1821 50.5239 22.0298 50.2485C21.8804 49.9702 21.8057 49.6304 21.8057 49.229C21.8057 48.8306 21.8628 48.4424 21.9771 48.0645C22.0913 47.6836 22.2598 47.3408 22.4824 47.0361C22.7051 46.7314 22.9761 46.4897 23.2954 46.311C23.6147 46.1323 23.978 46.043 24.3853 46.043C24.8833 46.043 25.2568 46.1558 25.5059 46.3813C25.7578 46.604 25.8838 46.8999 25.8838 47.269C25.8838 47.521 25.8267 47.751 25.7124 47.959C25.5981 48.167 25.4238 48.3472 25.1895 48.4995C24.958 48.6489 24.6636 48.7646 24.3062 48.8467C23.9517 48.9287 23.5342 48.9697 23.0537 48.9697H22.856C22.853 49.0137 22.8501 49.0591 22.8472 49.106C22.8442 49.1499 22.8428 49.1938 22.8428 49.2378C22.8428 49.563 22.9277 49.8193 23.0977 50.0068C23.2676 50.1914 23.5151 50.2837 23.8403 50.2837C24.0864 50.2837 24.3135 50.2529 24.5215 50.1914C24.7295 50.1299 24.9624 50.0376 25.2202 49.9146V50.7275C24.9829 50.8418 24.7427 50.9312 24.4995 50.9956C24.2563 51.0571 23.9722 51.0879 23.647 51.0879ZM22.9834 48.2227H23.1328C23.4902 48.2227 23.8008 48.189 24.0645 48.1216C24.3281 48.0513 24.5317 47.9487 24.6753 47.814C24.8188 47.6763 24.8906 47.5093 24.8906 47.313C24.8906 47.1606 24.8423 47.042 24.7456 46.957C24.6519 46.8691 24.5112 46.8252 24.3237 46.8252C24.1392 46.8252 23.9575 46.8823 23.7788 46.9966C23.6001 47.1079 23.4404 47.269 23.2998 47.48C23.1592 47.688 23.0537 47.9355 22.9834 48.2227ZM26.3496 51L27.3823 46.1353H28.1865L28.0811 47.0537H28.1294C28.2554 46.8662 28.3916 46.6963 28.5381 46.5439C28.6875 46.3916 28.853 46.27 29.0347 46.1792C29.2163 46.0884 29.4185 46.043 29.6411 46.043C29.7202 46.043 29.8022 46.0488 29.8872 46.0605C29.9751 46.0693 30.0513 46.0825 30.1157 46.1001L29.8916 47.0669C29.8271 47.0493 29.7568 47.0347 29.6807 47.0229C29.6045 47.0112 29.5239 47.0054 29.439 47.0054C29.2456 47.0054 29.064 47.0508 28.894 47.1416C28.7241 47.2324 28.5703 47.3584 28.4326 47.5195C28.2949 47.6807 28.1763 47.8696 28.0767 48.0864C27.9771 48.3003 27.8994 48.5332 27.8438 48.7852L27.3779 51H26.3496ZM30.019 51L31.4736 44.1621H32.4976L31.0474 51H30.019ZM32.1768 53.1621C32.0273 53.1621 31.9058 53.1533 31.812 53.1357C31.7153 53.1182 31.6274 53.0977 31.5483 53.0742V52.2524C31.6274 52.27 31.7109 52.2847 31.7988 52.2964C31.8867 52.311 31.9834 52.3184 32.0889 52.3184C32.3496 52.3184 32.5679 52.2393 32.7437 52.0811C32.9224 51.9258 33.0864 51.7104 33.2358 51.4351L33.46 51.0264L32.7305 46.1353H33.75L34.04 48.5083C34.0605 48.6724 34.0767 48.8481 34.0884 49.0356C34.103 49.2231 34.1133 49.4048 34.1191 49.5806C34.125 49.7534 34.1279 49.8999 34.1279 50.02H34.1587C34.1997 49.9204 34.251 49.7944 34.3125 49.6421C34.374 49.4897 34.4429 49.3271 34.519 49.1543C34.5952 48.9814 34.6714 48.8203 34.7476 48.6709L36.0396 46.1353H37.1514L34.1147 51.769C33.9478 52.0796 33.7676 52.3389 33.5742 52.5469C33.3838 52.7549 33.1743 52.9087 32.9458 53.0083C32.7173 53.1108 32.4609 53.1621 32.1768 53.1621ZM39.3442 51L40.7021 44.5752H41.8755L43.6421 49.6289H43.6685C43.689 49.4941 43.7153 49.3286 43.7476 49.1323C43.7798 48.9331 43.8164 48.7266 43.8574 48.5127C43.8984 48.2988 43.938 48.1011 43.9761 47.9194L44.688 44.5752H45.6416L44.2837 51H43.1411L41.335 45.8716H41.3042C41.2954 45.939 41.2808 46.0415 41.2603 46.1792C41.2397 46.314 41.2148 46.4692 41.1855 46.645C41.1592 46.8208 41.1299 46.9995 41.0977 47.1812C41.0654 47.3628 41.0317 47.5312 40.9966 47.6865L40.2979 51H39.3442ZM47.3203 51.0879C46.998 51.0879 46.7095 51.0586 46.4546 51C46.2026 50.9414 45.9785 50.8564 45.7822 50.7451V49.7783C46.0078 49.8984 46.2466 49.9995 46.4985 50.0815C46.7534 50.1606 47.0303 50.2002 47.3291 50.2002C47.5049 50.2002 47.6704 50.1826 47.8257 50.1475C47.981 50.1094 48.1187 50.0508 48.2388 49.9717C48.3589 49.8926 48.4526 49.793 48.52 49.6729C48.5874 49.5498 48.6211 49.4048 48.6211 49.2378C48.6211 49.0679 48.5859 48.9214 48.5156 48.7983C48.4453 48.6753 48.3413 48.5596 48.2036 48.4512C48.0659 48.3398 47.8931 48.2197 47.6851 48.0908C47.4858 47.9619 47.2998 47.8198 47.127 47.6646C46.9541 47.5093 46.8149 47.3291 46.7095 47.124C46.604 46.916 46.5513 46.6699 46.5513 46.3857C46.5513 46.0928 46.604 45.8291 46.7095 45.5947C46.8179 45.3604 46.9688 45.1611 47.1621 44.9971C47.3584 44.8301 47.5869 44.7026 47.8477 44.6147C48.1113 44.5269 48.397 44.4829 48.7046 44.4829C49.0386 44.4829 49.3389 44.5181 49.6055 44.5884C49.8721 44.6558 50.1299 44.7554 50.3789 44.8872L49.9966 45.7134C49.8003 45.6167 49.5923 45.5376 49.3726 45.4761C49.1558 45.4116 48.9331 45.3794 48.7046 45.3794C48.5522 45.3794 48.4102 45.3999 48.2783 45.4409C48.1494 45.4819 48.0366 45.542 47.9399 45.6211C47.8433 45.7002 47.7671 45.7983 47.7114 45.9155C47.6587 46.0298 47.6323 46.1616 47.6323 46.311C47.6323 46.481 47.666 46.6245 47.7334 46.7417C47.8008 46.8589 47.8989 46.9673 48.0278 47.0669C48.1567 47.1636 48.3135 47.269 48.498 47.3833C48.7471 47.5386 48.9609 47.6982 49.1396 47.8623C49.3184 48.0264 49.4546 48.2095 49.5483 48.4116C49.6421 48.6138 49.689 48.8525 49.689 49.1279C49.689 49.459 49.6289 49.7476 49.5088 49.9937C49.3916 50.2368 49.2246 50.4404 49.0078 50.6045C48.7939 50.7656 48.5435 50.8872 48.2563 50.9692C47.9692 51.0483 47.6572 51.0879 47.3203 51.0879ZM50.5723 51L51.9302 44.5752H53.5474C54.3325 44.5752 54.9434 44.7847 55.3799 45.2036C55.8164 45.6196 56.0347 46.2422 56.0347 47.0713C56.0347 47.5342 55.9819 47.9663 55.8765 48.3677C55.7739 48.769 55.6216 49.1323 55.4194 49.4575C55.2173 49.7798 54.9668 50.0566 54.668 50.2881C54.3691 50.5166 54.0249 50.6924 53.6353 50.8154C53.2456 50.9385 52.8135 51 52.3389 51H50.5723ZM51.7983 50.1167H52.3916C52.7314 50.1167 53.0376 50.0654 53.3101 49.9629C53.5854 49.8604 53.8257 49.7168 54.0308 49.5322C54.2358 49.3447 54.4072 49.125 54.5449 48.873C54.6826 48.6211 54.7852 48.3457 54.8525 48.0469C54.9229 47.7451 54.958 47.4302 54.958 47.1021C54.958 46.5308 54.8203 46.1133 54.5449 45.8496C54.2725 45.583 53.9033 45.4497 53.4375 45.4497H52.7871L51.7983 50.1167ZM56.6279 51L57.9858 44.5752H59.0273L57.854 50.1035H60.2358L60.0469 51H56.6279ZM65.4126 51.0879C65.0405 51.0879 64.7153 51.0176 64.437 50.877C64.1616 50.7334 63.9478 50.5239 63.7954 50.2485C63.646 49.9702 63.5713 49.6304 63.5713 49.229C63.5713 48.8306 63.6284 48.4424 63.7427 48.0645C63.8569 47.6836 64.0254 47.3408 64.248 47.0361C64.4707 46.7314 64.7417 46.4897 65.061 46.311C65.3804 46.1323 65.7437 46.043 66.1509 46.043C66.6489 46.043 67.0225 46.1558 67.2715 46.3813C67.5234 46.604 67.6494 46.8999 67.6494 47.269C67.6494 47.521 67.5923 47.751 67.478 47.959C67.3638 48.167 67.1895 48.3472 66.9551 48.4995C66.7236 48.6489 66.4292 48.7646 66.0718 48.8467C65.7173 48.9287 65.2998 48.9697 64.8193 48.9697H64.6216C64.6187 49.0137 64.6157 49.0591 64.6128 49.106C64.6099 49.1499 64.6084 49.1938 64.6084 49.2378C64.6084 49.563 64.6934 49.8193 64.8633 50.0068C65.0332 50.1914 65.2808 50.2837 65.606 50.2837C65.8521 50.2837 66.0791 50.2529 66.2871 50.1914C66.4951 50.1299 66.728 50.0376 66.9858 49.9146V50.7275C66.7485 50.8418 66.5083 50.9312 66.2651 50.9956C66.022 51.0571 65.7378 51.0879 65.4126 51.0879ZM64.749 48.2227H64.8984C65.2559 48.2227 65.5664 48.189 65.8301 48.1216C66.0938 48.0513 66.2974 47.9487 66.4409 47.814C66.5845 47.6763 66.6562 47.5093 66.6562 47.313C66.6562 47.1606 66.6079 47.042 66.5112 46.957C66.4175 46.8691 66.2769 46.8252 66.0894 46.8252C65.9048 46.8252 65.7231 46.8823 65.5444 46.9966C65.3657 47.1079 65.2061 47.269 65.0654 47.48C64.9248 47.688 64.8193 47.9355 64.749 48.2227ZM68.1196 49.0312L68.3086 48.1436H70.519L70.3301 49.0312H68.1196ZM73.7578 51.0879C73.0049 51.0879 72.4175 50.8755 71.9956 50.4507C71.5737 50.0229 71.3628 49.4136 71.3628 48.6226C71.3628 48.1685 71.4155 47.7349 71.521 47.3218C71.6265 46.9058 71.7803 46.5249 71.9824 46.1792C72.1846 45.8335 72.4321 45.5332 72.7251 45.2783C73.021 45.0234 73.3564 44.8271 73.7314 44.6895C74.1094 44.5488 74.5239 44.4785 74.9751 44.4785C75.3325 44.4785 75.6562 44.5137 75.9463 44.584C76.2393 44.6514 76.5249 44.751 76.8032 44.8828L76.4077 45.7617C76.188 45.6504 75.958 45.5596 75.7178 45.4893C75.4775 45.4189 75.2183 45.3838 74.9399 45.3838C74.5532 45.3838 74.2061 45.4688 73.8984 45.6387C73.5908 45.8057 73.3271 46.0356 73.1074 46.3286C72.8906 46.6216 72.7251 46.9585 72.6108 47.3394C72.4966 47.7202 72.4395 48.123 72.4395 48.5479C72.4395 48.8818 72.4922 49.1719 72.5977 49.418C72.7031 49.6641 72.8672 49.8545 73.0898 49.9893C73.3125 50.1211 73.5952 50.187 73.938 50.187C74.1313 50.187 74.3057 50.1738 74.4609 50.1475C74.6191 50.1182 74.7656 50.0845 74.9004 50.0464L75.2607 48.4072H74.0127L74.2061 47.5151H76.4736L75.7793 50.7451C75.498 50.8447 75.1978 50.9268 74.8784 50.9912C74.562 51.0557 74.1885 51.0879 73.7578 51.0879ZM79.1807 51.0791C78.8115 51.0791 78.4893 51.0029 78.2139 50.8506C77.9385 50.6982 77.7246 50.4829 77.5723 50.2046C77.4229 49.9233 77.3481 49.5908 77.3481 49.207C77.3481 48.8818 77.3818 48.5654 77.4492 48.2578C77.5195 47.9502 77.6221 47.6631 77.7568 47.3965C77.8916 47.1299 78.0601 46.897 78.2622 46.6978C78.4644 46.4956 78.6987 46.3389 78.9653 46.2275C79.2319 46.1133 79.5308 46.0562 79.8618 46.0562C80.2397 46.0562 80.5649 46.1323 80.8374 46.2847C81.1099 46.437 81.3193 46.6553 81.4658 46.9395C81.6123 47.2236 81.6855 47.5635 81.6855 47.959C81.6855 48.2754 81.6519 48.5845 81.5845 48.8862C81.52 49.188 81.4219 49.4722 81.29 49.7388C81.1582 50.0024 80.9912 50.2354 80.7891 50.4375C80.5898 50.6367 80.3555 50.7935 80.0859 50.9077C79.8193 51.022 79.5176 51.0791 79.1807 51.0791ZM79.2554 50.2354C79.4194 50.2354 79.5718 50.1987 79.7124 50.1255C79.856 50.0493 79.9849 49.9424 80.0991 49.8047C80.2134 49.6641 80.3101 49.4985 80.3892 49.3081C80.4712 49.1147 80.5342 48.9009 80.5781 48.6665C80.6221 48.4321 80.644 48.1816 80.644 47.915C80.644 47.7363 80.6177 47.5708 80.5649 47.4185C80.5122 47.2632 80.4243 47.1387 80.3013 47.0449C80.1812 46.9482 80.02 46.8999 79.8179 46.8999C79.6362 46.8999 79.4692 46.9438 79.3169 47.0317C79.1675 47.1167 79.0342 47.2354 78.917 47.3877C78.8027 47.54 78.7061 47.7158 78.627 47.915C78.5479 48.1113 78.4878 48.3223 78.4468 48.5479C78.4058 48.7705 78.3853 48.9961 78.3853 49.2246C78.3853 49.5498 78.4585 49.8003 78.605 49.9761C78.7544 50.1489 78.9712 50.2354 79.2554 50.2354ZM83.1313 51L82.5381 46.1353H83.5576L83.8037 48.8071C83.8154 48.9214 83.8257 49.0576 83.8345 49.2158C83.8433 49.374 83.8506 49.5293 83.8564 49.6816C83.8652 49.8311 83.8696 49.9541 83.8696 50.0508H83.9048C83.9546 49.9307 84.0117 49.7944 84.0762 49.6421C84.1436 49.4868 84.2109 49.3359 84.2783 49.1895C84.3457 49.04 84.4058 48.9141 84.4585 48.8115L85.8516 46.1353H86.9546L84.3135 51H83.1313ZM88.7388 51.0879C88.3667 51.0879 88.0415 51.0176 87.7632 50.877C87.4878 50.7334 87.2739 50.5239 87.1216 50.2485C86.9722 49.9702 86.8975 49.6304 86.8975 49.229C86.8975 48.8306 86.9546 48.4424 87.0688 48.0645C87.1831 47.6836 87.3516 47.3408 87.5742 47.0361C87.7969 46.7314 88.0679 46.4897 88.3872 46.311C88.7065 46.1323 89.0698 46.043 89.4771 46.043C89.9751 46.043 90.3486 46.1558 90.5977 46.3813C90.8496 46.604 90.9756 46.8999 90.9756 47.269C90.9756 47.521 90.9185 47.751 90.8042 47.959C90.6899 48.167 90.5156 48.3472 90.2812 48.4995C90.0498 48.6489 89.7554 48.7646 89.3979 48.8467C89.0435 48.9287 88.626 48.9697 88.1455 48.9697H87.9478C87.9448 49.0137 87.9419 49.0591 87.939 49.106C87.936 49.1499 87.9346 49.1938 87.9346 49.2378C87.9346 49.563 88.0195 49.8193 88.1895 50.0068C88.3594 50.1914 88.6069 50.2837 88.9321 50.2837C89.1782 50.2837 89.4053 50.2529 89.6133 50.1914C89.8213 50.1299 90.0542 50.0376 90.312 49.9146V50.7275C90.0747 50.8418 89.8345 50.9312 89.5913 50.9956C89.3481 51.0571 89.064 51.0879 88.7388 51.0879ZM88.0752 48.2227H88.2246C88.582 48.2227 88.8926 48.189 89.1562 48.1216C89.4199 48.0513 89.6235 47.9487 89.7671 47.814C89.9106 47.6763 89.9824 47.5093 89.9824 47.313C89.9824 47.1606 89.9341 47.042 89.8374 46.957C89.7437 46.8691 89.603 46.8252 89.4155 46.8252C89.231 46.8252 89.0493 46.8823 88.8706 46.9966C88.6919 47.1079 88.5322 47.269 88.3916 47.48C88.251 47.688 88.1455 47.9355 88.0752 48.2227ZM91.4414 51L92.4741 46.1353H93.2783L93.1729 47.0537H93.2212C93.3472 46.8662 93.4834 46.6963 93.6299 46.5439C93.7793 46.3916 93.9448 46.27 94.1265 46.1792C94.3081 46.0884 94.5103 46.043 94.7329 46.043C94.812 46.043 94.894 46.0488 94.979 46.0605C95.0669 46.0693 95.1431 46.0825 95.2075 46.1001L94.9834 47.0669C94.9189 47.0493 94.8486 47.0347 94.7725 47.0229C94.6963 47.0112 94.6157 47.0054 94.5308 47.0054C94.3374 47.0054 94.1558 47.0508 93.9858 47.1416C93.8159 47.2324 93.6621 47.3584 93.5244 47.5195C93.3867 47.6807 93.2681 47.8696 93.1685 48.0864C93.0688 48.3003 92.9912 48.5332 92.9355 48.7852L92.4697 51H91.4414ZM95.0977 51L96.1348 46.1221H96.9653L96.8599 47.0405H96.8862C97.0034 46.8677 97.1396 46.7051 97.2949 46.5527C97.4502 46.3975 97.626 46.2715 97.8223 46.1748C98.0215 46.0781 98.2441 46.0298 98.4902 46.0298C98.7598 46.0298 98.9883 46.0825 99.1758 46.188C99.3633 46.2935 99.5054 46.4443 99.6021 46.6406C99.6987 46.8369 99.7471 47.0713 99.7471 47.3438C99.7471 47.4639 99.7368 47.5928 99.7163 47.7305C99.6987 47.8652 99.6753 47.9971 99.646 48.126L99.0352 51H97.9849L98.6089 48.0425C98.6353 47.9282 98.6543 47.8257 98.666 47.7349C98.6807 47.644 98.688 47.5591 98.688 47.48C98.688 47.2866 98.6396 47.1416 98.543 47.0449C98.4492 46.9482 98.3086 46.8999 98.1211 46.8999C97.916 46.8999 97.7139 46.979 97.5146 47.1372C97.3154 47.2954 97.1353 47.5254 96.9741 47.8271C96.813 48.1289 96.6855 48.4937 96.5918 48.9214L96.1523 51H95.0977ZM101.984 51.0879C101.735 51.0879 101.508 51.0278 101.303 50.9077C101.101 50.7847 100.939 50.5972 100.819 50.3452C100.699 50.0903 100.639 49.7666 100.639 49.374C100.639 49.0342 100.674 48.7031 100.745 48.3809C100.818 48.0586 100.92 47.7568 101.052 47.4756C101.187 47.1943 101.35 46.9468 101.54 46.7329C101.73 46.5161 101.946 46.3477 102.186 46.2275C102.426 46.1045 102.686 46.043 102.964 46.043C103.175 46.043 103.359 46.0796 103.518 46.1528C103.676 46.2231 103.809 46.3184 103.917 46.4385C104.026 46.5586 104.114 46.6919 104.181 46.8384H104.221L104.484 46.1353H105.275L104.243 51H103.456L103.553 50.2134H103.518C103.392 50.3745 103.251 50.521 103.096 50.6528C102.943 50.7847 102.775 50.8901 102.59 50.9692C102.406 51.0483 102.204 51.0879 101.984 51.0879ZM102.362 50.2485C102.567 50.2485 102.763 50.1724 102.951 50.02C103.138 49.8647 103.304 49.6597 103.447 49.4048C103.594 49.1499 103.702 48.8701 103.772 48.5654C103.808 48.4189 103.831 48.2798 103.843 48.1479C103.857 48.0161 103.865 47.8843 103.865 47.7524C103.865 47.4976 103.797 47.2896 103.663 47.1284C103.528 46.9673 103.343 46.8867 103.109 46.8867C102.948 46.8867 102.794 46.9321 102.647 47.0229C102.504 47.1138 102.374 47.2397 102.256 47.4009C102.139 47.5591 102.037 47.7422 101.949 47.9502C101.864 48.1582 101.798 48.3823 101.751 48.6226C101.707 48.8599 101.685 49.1016 101.685 49.3477C101.685 49.6436 101.744 49.8677 101.861 50.02C101.981 50.1724 102.148 50.2485 102.362 50.2485ZM105.636 51L106.673 46.1221H107.503L107.398 47.0405H107.424C107.542 46.8677 107.678 46.7051 107.833 46.5527C107.988 46.3975 108.164 46.2715 108.36 46.1748C108.56 46.0781 108.782 46.0298 109.028 46.0298C109.298 46.0298 109.526 46.0825 109.714 46.188C109.901 46.2935 110.043 46.4443 110.14 46.6406C110.237 46.8369 110.285 47.0713 110.285 47.3438C110.285 47.4639 110.275 47.5928 110.254 47.7305C110.237 47.8652 110.213 47.9971 110.184 48.126L109.573 51H108.523L109.147 48.0425C109.173 47.9282 109.192 47.8257 109.204 47.7349C109.219 47.644 109.226 47.5591 109.226 47.48C109.226 47.2866 109.178 47.1416 109.081 47.0449C108.987 46.9482 108.847 46.8999 108.659 46.8999C108.454 46.8999 108.252 46.979 108.053 47.1372C107.854 47.2954 107.673 47.5254 107.512 47.8271C107.351 48.1289 107.224 48.4937 107.13 48.9214L106.69 51H105.636ZM112.983 51.0879C112.635 51.0879 112.324 51.0234 112.052 50.8945C111.779 50.7656 111.565 50.5679 111.41 50.3013C111.255 50.0347 111.177 49.6948 111.177 49.2817C111.177 48.9331 111.214 48.5991 111.287 48.2798C111.363 47.9575 111.473 47.6616 111.617 47.3921C111.76 47.1196 111.936 46.8838 112.144 46.6846C112.352 46.4824 112.589 46.3257 112.856 46.2144C113.123 46.1001 113.417 46.043 113.739 46.043C113.991 46.043 114.227 46.0679 114.447 46.1177C114.667 46.1646 114.869 46.2305 115.053 46.3154L114.746 47.1284C114.605 47.064 114.454 47.0083 114.293 46.9614C114.135 46.9116 113.96 46.8867 113.77 46.8867C113.533 46.8867 113.319 46.9512 113.128 47.0801C112.938 47.2061 112.775 47.3804 112.641 47.603C112.506 47.8228 112.402 48.0718 112.329 48.3501C112.258 48.6284 112.223 48.9199 112.223 49.2246C112.223 49.4414 112.26 49.626 112.333 49.7783C112.406 49.9307 112.512 50.0479 112.649 50.1299C112.79 50.209 112.958 50.2485 113.155 50.2485C113.372 50.2485 113.575 50.2178 113.766 50.1562C113.956 50.0918 114.146 50.0127 114.337 49.9189V50.7715C114.155 50.8682 113.953 50.9443 113.73 51C113.508 51.0586 113.259 51.0879 112.983 51.0879ZM117.242 51.0879C116.87 51.0879 116.544 51.0176 116.266 50.877C115.991 50.7334 115.777 50.5239 115.625 50.2485C115.475 49.9702 115.4 49.6304 115.4 49.229C115.4 48.8306 115.458 48.4424 115.572 48.0645C115.686 47.6836 115.854 47.3408 116.077 47.0361C116.3 46.7314 116.571 46.4897 116.89 46.311C117.209 46.1323 117.573 46.043 117.98 46.043C118.478 46.043 118.852 46.1558 119.101 46.3813C119.353 46.604 119.479 46.8999 119.479 47.269C119.479 47.521 119.421 47.751 119.307 47.959C119.193 48.167 119.019 48.3472 118.784 48.4995C118.553 48.6489 118.258 48.7646 117.901 48.8467C117.546 48.9287 117.129 48.9697 116.648 48.9697H116.451C116.448 49.0137 116.445 49.0591 116.442 49.106C116.439 49.1499 116.438 49.1938 116.438 49.2378C116.438 49.563 116.522 49.8193 116.692 50.0068C116.862 50.1914 117.11 50.2837 117.435 50.2837C117.681 50.2837 117.908 50.2529 118.116 50.1914C118.324 50.1299 118.557 50.0376 118.815 49.9146V50.7275C118.578 50.8418 118.337 50.9312 118.094 50.9956C117.851 51.0571 117.567 51.0879 117.242 51.0879ZM116.578 48.2227H116.728C117.085 48.2227 117.396 48.189 117.659 48.1216C117.923 48.0513 118.126 47.9487 118.27 47.814C118.414 47.6763 118.485 47.5093 118.485 47.313C118.485 47.1606 118.437 47.042 118.34 46.957C118.247 46.8691 118.106 46.8252 117.918 46.8252C117.734 46.8252 117.552 46.8823 117.374 46.9966C117.195 47.1079 117.035 47.269 116.895 47.48C116.754 47.688 116.648 47.9355 116.578 48.2227ZM122.375 51L123.741 44.5752H124.778L123.407 51H122.375ZM124.928 51L125.965 46.1221H126.795L126.69 47.0405H126.716C126.833 46.8677 126.97 46.7051 127.125 46.5527C127.28 46.3975 127.456 46.2715 127.652 46.1748C127.852 46.0781 128.074 46.0298 128.32 46.0298C128.59 46.0298 128.818 46.0825 129.006 46.188C129.193 46.2935 129.335 46.4443 129.432 46.6406C129.529 46.8369 129.577 47.0713 129.577 47.3438C129.577 47.4639 129.567 47.5928 129.546 47.7305C129.529 47.8652 129.505 47.9971 129.476 48.126L128.865 51H127.815L128.439 48.0425C128.465 47.9282 128.484 47.8257 128.496 47.7349C128.511 47.644 128.518 47.5591 128.518 47.48C128.518 47.2866 128.47 47.1416 128.373 47.0449C128.279 46.9482 128.139 46.8999 127.951 46.8999C127.746 46.8999 127.544 46.979 127.345 47.1372C127.146 47.2954 126.965 47.5254 126.804 47.8271C126.643 48.1289 126.516 48.4937 126.422 48.9214L125.982 51H124.928ZM129.727 53.1621C129.601 53.1621 129.479 53.1519 129.362 53.1313C129.242 53.1108 129.141 53.0874 129.059 53.061V52.2173C129.146 52.2495 129.231 52.2729 129.313 52.2876C129.393 52.3052 129.476 52.314 129.564 52.314C129.763 52.314 129.926 52.2407 130.052 52.0942C130.181 51.9507 130.277 51.731 130.342 51.4351L131.295 46.9175H130.518L130.614 46.4429L131.462 46.1221L131.555 45.7046C131.619 45.4058 131.701 45.1553 131.801 44.9531C131.903 44.748 132.023 44.584 132.161 44.4609C132.302 44.3379 132.463 44.25 132.645 44.1973C132.829 44.1416 133.037 44.1138 133.269 44.1138C133.444 44.1138 133.613 44.1313 133.774 44.1665C133.938 44.2017 134.08 44.2471 134.2 44.3027L133.928 45.0762C133.843 45.041 133.752 45.0103 133.655 44.9839C133.559 44.9575 133.452 44.9443 133.334 44.9443C133.126 44.9443 132.961 45.0088 132.838 45.1377C132.715 45.2666 132.624 45.4731 132.565 45.7573L132.486 46.1353H133.484L133.326 46.9175H132.319L131.335 51.5757C131.268 51.8862 131.169 52.1602 131.041 52.3975C130.915 52.6377 130.745 52.8252 130.531 52.96C130.317 53.0947 130.049 53.1621 129.727 53.1621ZM133.348 51L134.38 46.1353H135.185L135.079 47.0537H135.127C135.253 46.8662 135.39 46.6963 135.536 46.5439C135.686 46.3916 135.851 46.27 136.033 46.1792C136.214 46.0884 136.417 46.043 136.639 46.043C136.718 46.043 136.8 46.0488 136.885 46.0605C136.973 46.0693 137.049 46.0825 137.114 46.1001L136.89 47.0669C136.825 47.0493 136.755 47.0347 136.679 47.0229C136.603 47.0112 136.522 47.0054 136.437 47.0054C136.244 47.0054 136.062 47.0508 135.892 47.1416C135.722 47.2324 135.568 47.3584 135.431 47.5195C135.293 47.6807 135.174 47.8696 135.075 48.0864C134.975 48.3003 134.897 48.5332 134.842 48.7852L134.376 51H133.348ZM138.573 51.0879C138.324 51.0879 138.097 51.0278 137.892 50.9077C137.689 50.7847 137.528 50.5972 137.408 50.3452C137.288 50.0903 137.228 49.7666 137.228 49.374C137.228 49.0342 137.263 48.7031 137.333 48.3809C137.407 48.0586 137.509 47.7568 137.641 47.4756C137.776 47.1943 137.938 46.9468 138.129 46.7329C138.319 46.5161 138.535 46.3477 138.775 46.2275C139.015 46.1045 139.274 46.043 139.553 46.043C139.764 46.043 139.948 46.0796 140.106 46.1528C140.265 46.2231 140.398 46.3184 140.506 46.4385C140.615 46.5586 140.703 46.6919 140.77 46.8384H140.81L141.073 46.1353H141.864L140.832 51H140.045L140.142 50.2134H140.106C139.98 50.3745 139.84 50.521 139.685 50.6528C139.532 50.7847 139.364 50.8901 139.179 50.9692C138.995 51.0483 138.792 51.0879 138.573 51.0879ZM138.951 50.2485C139.156 50.2485 139.352 50.1724 139.54 50.02C139.727 49.8647 139.893 49.6597 140.036 49.4048C140.183 49.1499 140.291 48.8701 140.361 48.5654C140.396 48.4189 140.42 48.2798 140.432 48.1479C140.446 48.0161 140.454 47.8843 140.454 47.7524C140.454 47.4976 140.386 47.2896 140.251 47.1284C140.117 46.9673 139.932 46.8867 139.698 46.8867C139.537 46.8867 139.383 46.9321 139.236 47.0229C139.093 47.1138 138.962 47.2397 138.845 47.4009C138.728 47.5591 138.625 47.7422 138.538 47.9502C138.453 48.1582 138.387 48.3823 138.34 48.6226C138.296 48.8599 138.274 49.1016 138.274 49.3477C138.274 49.6436 138.333 49.8677 138.45 50.02C138.57 50.1724 138.737 50.2485 138.951 50.2485ZM143.521 51.0879C143.216 51.0879 142.95 51.0615 142.721 51.0088C142.496 50.959 142.292 50.8857 142.11 50.7891V49.9058C142.298 50.0171 142.509 50.1108 142.743 50.187C142.98 50.2603 143.224 50.2969 143.473 50.2969C143.666 50.2969 143.834 50.2705 143.978 50.2178C144.122 50.165 144.233 50.0903 144.312 49.9937C144.394 49.894 144.435 49.7739 144.435 49.6333C144.435 49.5308 144.412 49.4399 144.365 49.3608C144.318 49.2817 144.237 49.2012 144.123 49.1191C144.009 49.0371 143.851 48.939 143.648 48.8247C143.435 48.7046 143.253 48.583 143.104 48.46C142.957 48.334 142.844 48.1948 142.765 48.0425C142.689 47.8901 142.651 47.7114 142.651 47.5063C142.651 47.1987 142.721 46.9365 142.862 46.7197C143.005 46.5 143.208 46.333 143.468 46.2188C143.732 46.1016 144.042 46.043 144.4 46.043C144.687 46.043 144.958 46.0767 145.213 46.144C145.468 46.2085 145.704 46.2993 145.92 46.4165L145.582 47.1812C145.421 47.0903 145.242 47.0127 145.046 46.9482C144.85 46.8809 144.639 46.8472 144.413 46.8472C144.205 46.8472 144.031 46.8955 143.89 46.9922C143.752 47.0889 143.684 47.2266 143.684 47.4053C143.684 47.499 143.706 47.584 143.75 47.6602C143.796 47.7334 143.874 47.8081 143.982 47.8843C144.091 47.9604 144.239 48.0483 144.426 48.1479C144.628 48.2593 144.809 48.3765 144.967 48.4995C145.125 48.6226 145.25 48.7646 145.34 48.9258C145.431 49.084 145.477 49.2759 145.477 49.5015C145.477 49.8442 145.396 50.1343 145.235 50.3716C145.077 50.606 144.851 50.7847 144.558 50.9077C144.265 51.0278 143.919 51.0879 143.521 51.0879ZM147.814 51.0879C147.46 51.0879 147.171 51.0088 146.949 50.8506C146.729 50.6895 146.619 50.4082 146.619 50.0068C146.619 49.9277 146.624 49.8413 146.632 49.7476C146.644 49.6509 146.66 49.5513 146.681 49.4487L147.217 46.9175H146.514L146.61 46.4253L147.441 46.0869L147.995 45.0586H148.641L148.412 46.1353H149.651L149.484 46.9175H148.25L147.709 49.4531C147.694 49.5146 147.681 49.5806 147.669 49.6509C147.661 49.7183 147.656 49.7798 147.656 49.8354C147.656 49.9673 147.693 50.0698 147.766 50.1431C147.839 50.2163 147.951 50.2529 148.1 50.2529C148.214 50.2529 148.324 50.2412 148.43 50.2178C148.535 50.1943 148.651 50.1606 148.777 50.1167V50.8945C148.668 50.9443 148.528 50.9883 148.355 51.0264C148.182 51.0674 148.002 51.0879 147.814 51.0879ZM149.643 51L150.675 46.1353H151.479L151.374 47.0537H151.422C151.548 46.8662 151.685 46.6963 151.831 46.5439C151.98 46.3916 152.146 46.27 152.328 46.1792C152.509 46.0884 152.711 46.043 152.934 46.043C153.013 46.043 153.095 46.0488 153.18 46.0605C153.268 46.0693 153.344 46.0825 153.409 46.1001L153.185 47.0669C153.12 47.0493 153.05 47.0347 152.974 47.0229C152.897 47.0112 152.817 47.0054 152.732 47.0054C152.539 47.0054 152.357 47.0508 152.187 47.1416C152.017 47.2324 151.863 47.3584 151.726 47.5195C151.588 47.6807 151.469 47.8696 151.37 48.0864C151.27 48.3003 151.192 48.5332 151.137 48.7852L150.671 51H149.643ZM154.824 51.0879C154.563 51.0879 154.34 51.0366 154.156 50.9341C153.974 50.8315 153.835 50.6836 153.738 50.4902C153.645 50.2939 153.598 50.0596 153.598 49.7871C153.598 49.667 153.606 49.5352 153.624 49.3916C153.645 49.2451 153.669 49.0942 153.699 48.939L154.296 46.1353H155.325L154.696 49.0884C154.676 49.2026 154.658 49.3066 154.644 49.4004C154.632 49.4912 154.626 49.5747 154.626 49.6509C154.626 49.8472 154.671 49.9966 154.762 50.0991C154.856 50.1987 155.001 50.2485 155.197 50.2485C155.408 50.2485 155.613 50.1694 155.812 50.0112C156.015 49.8501 156.198 49.6172 156.362 49.3125C156.526 49.0078 156.653 48.6401 156.744 48.2095L157.184 46.1353H158.203L157.175 51H156.366L156.472 50.0771H156.428C156.311 50.25 156.174 50.4141 156.019 50.5693C155.864 50.7217 155.688 50.8462 155.492 50.9429C155.295 51.0396 155.073 51.0879 154.824 51.0879ZM160.646 51.0879C160.298 51.0879 159.987 51.0234 159.715 50.8945C159.442 50.7656 159.229 50.5679 159.073 50.3013C158.918 50.0347 158.84 49.6948 158.84 49.2817C158.84 48.9331 158.877 48.5991 158.95 48.2798C159.026 47.9575 159.136 47.6616 159.28 47.3921C159.423 47.1196 159.599 46.8838 159.807 46.6846C160.015 46.4824 160.252 46.3257 160.519 46.2144C160.786 46.1001 161.08 46.043 161.402 46.043C161.654 46.043 161.89 46.0679 162.11 46.1177C162.33 46.1646 162.532 46.2305 162.716 46.3154L162.409 47.1284C162.268 47.064 162.117 47.0083 161.956 46.9614C161.798 46.9116 161.624 46.8867 161.433 46.8867C161.196 46.8867 160.982 46.9512 160.792 47.0801C160.601 47.2061 160.438 47.3804 160.304 47.603C160.169 47.8228 160.065 48.0718 159.992 48.3501C159.921 48.6284 159.886 48.9199 159.886 49.2246C159.886 49.4414 159.923 49.626 159.996 49.7783C160.069 49.9307 160.175 50.0479 160.312 50.1299C160.453 50.209 160.622 50.2485 160.818 50.2485C161.035 50.2485 161.238 50.2178 161.429 50.1562C161.619 50.0918 161.81 50.0127 162 49.9189V50.7715C161.818 50.8682 161.616 50.9443 161.394 51C161.171 51.0586 160.922 51.0879 160.646 51.0879ZM164.355 51.0879C164.001 51.0879 163.712 51.0088 163.49 50.8506C163.27 50.6895 163.16 50.4082 163.16 50.0068C163.16 49.9277 163.165 49.8413 163.173 49.7476C163.185 49.6509 163.201 49.5513 163.222 49.4487L163.758 46.9175H163.055L163.151 46.4253L163.982 46.0869L164.536 45.0586H165.182L164.953 46.1353H166.192L166.025 46.9175H164.791L164.25 49.4531C164.235 49.5146 164.222 49.5806 164.21 49.6509C164.202 49.7183 164.197 49.7798 164.197 49.8354C164.197 49.9673 164.234 50.0698 164.307 50.1431C164.38 50.2163 164.492 50.2529 164.641 50.2529C164.755 50.2529 164.865 50.2412 164.971 50.2178C165.076 50.1943 165.192 50.1606 165.318 50.1167V50.8945C165.209 50.9443 165.069 50.9883 164.896 51.0264C164.723 51.0674 164.543 51.0879 164.355 51.0879ZM167.691 51.0879C167.43 51.0879 167.208 51.0366 167.023 50.9341C166.841 50.8315 166.702 50.6836 166.605 50.4902C166.512 50.2939 166.465 50.0596 166.465 49.7871C166.465 49.667 166.474 49.5352 166.491 49.3916C166.512 49.2451 166.537 49.0942 166.566 48.939L167.164 46.1353H168.192L167.563 49.0884C167.543 49.2026 167.525 49.3066 167.511 49.4004C167.499 49.4912 167.493 49.5747 167.493 49.6509C167.493 49.8472 167.539 49.9966 167.629 50.0991C167.723 50.1987 167.868 50.2485 168.064 50.2485C168.275 50.2485 168.48 50.1694 168.68 50.0112C168.882 49.8501 169.065 49.6172 169.229 49.3125C169.393 49.0078 169.521 48.6401 169.611 48.2095L170.051 46.1353H171.07L170.042 51H169.233L169.339 50.0771H169.295C169.178 50.25 169.042 50.4141 168.886 50.5693C168.731 50.7217 168.555 50.8462 168.359 50.9429C168.163 51.0396 167.94 51.0879 167.691 51.0879ZM171.501 51L172.534 46.1353H173.338L173.232 47.0537H173.281C173.407 46.8662 173.543 46.6963 173.689 46.5439C173.839 46.3916 174.004 46.27 174.186 46.1792C174.368 46.0884 174.57 46.043 174.792 46.043C174.872 46.043 174.954 46.0488 175.039 46.0605C175.126 46.0693 175.203 46.0825 175.267 46.1001L175.043 47.0669C174.979 47.0493 174.908 47.0347 174.832 47.0229C174.756 47.0112 174.675 47.0054 174.59 47.0054C174.397 47.0054 174.215 47.0508 174.045 47.1416C173.875 47.2324 173.722 47.3584 173.584 47.5195C173.446 47.6807 173.328 47.8696 173.228 48.0864C173.128 48.3003 173.051 48.5332 172.995 48.7852L172.529 51H171.501ZM177.227 51.0879C176.855 51.0879 176.53 51.0176 176.251 50.877C175.976 50.7334 175.762 50.5239 175.61 50.2485C175.46 49.9702 175.386 49.6304 175.386 49.229C175.386 48.8306 175.443 48.4424 175.557 48.0645C175.671 47.6836 175.84 47.3408 176.062 47.0361C176.285 46.7314 176.556 46.4897 176.875 46.311C177.195 46.1323 177.558 46.043 177.965 46.043C178.463 46.043 178.837 46.1558 179.086 46.3813C179.338 46.604 179.464 46.8999 179.464 47.269C179.464 47.521 179.407 47.751 179.292 47.959C179.178 48.167 179.004 48.3472 178.77 48.4995C178.538 48.6489 178.244 48.7646 177.886 48.8467C177.532 48.9287 177.114 48.9697 176.634 48.9697H176.436C176.433 49.0137 176.43 49.0591 176.427 49.106C176.424 49.1499 176.423 49.1938 176.423 49.2378C176.423 49.563 176.508 49.8193 176.678 50.0068C176.848 50.1914 177.095 50.2837 177.42 50.2837C177.667 50.2837 177.894 50.2529 178.102 50.1914C178.31 50.1299 178.542 50.0376 178.8 49.9146V50.7275C178.563 50.8418 178.323 50.9312 178.08 50.9956C177.836 51.0571 177.552 51.0879 177.227 51.0879ZM176.563 48.2227H176.713C177.07 48.2227 177.381 48.189 177.645 48.1216C177.908 48.0513 178.112 47.9487 178.255 47.814C178.399 47.6763 178.471 47.5093 178.471 47.313C178.471 47.1606 178.422 47.042 178.326 46.957C178.232 46.8691 178.091 46.8252 177.904 46.8252C177.719 46.8252 177.538 46.8823 177.359 46.9966C177.18 47.1079 177.021 47.269 176.88 47.48C176.739 47.688 176.634 47.9355 176.563 48.2227ZM182.364 51L183.722 44.5752H184.764L183.59 50.1035H185.972L185.783 51H182.364ZM188.262 51.0879C187.907 51.0879 187.619 51.0088 187.396 50.8506C187.176 50.6895 187.066 50.4082 187.066 50.0068C187.066 49.9277 187.071 49.8413 187.08 49.7476C187.091 49.6509 187.107 49.5513 187.128 49.4487L187.664 46.9175H186.961L187.058 46.4253L187.888 46.0869L188.442 45.0586H189.088L188.859 46.1353H190.099L189.932 46.9175H188.697L188.156 49.4531C188.142 49.5146 188.128 49.5806 188.117 49.6509C188.108 49.7183 188.104 49.7798 188.104 49.8354C188.104 49.9673 188.14 50.0698 188.213 50.1431C188.287 50.2163 188.398 50.2529 188.547 50.2529C188.662 50.2529 188.771 50.2412 188.877 50.2178C188.982 50.1943 189.098 50.1606 189.224 50.1167V50.8945C189.116 50.9443 188.975 50.9883 188.802 51.0264C188.629 51.0674 188.449 51.0879 188.262 51.0879ZM191.646 51.0879C191.394 51.0879 191.165 51.0278 190.96 50.9077C190.758 50.7876 190.597 50.6016 190.477 50.3496C190.356 50.0947 190.296 49.7681 190.296 49.3696C190.296 49.0356 190.33 48.709 190.397 48.3896C190.468 48.0674 190.569 47.7656 190.701 47.4844C190.833 47.2002 190.994 46.9512 191.184 46.7373C191.375 46.5205 191.59 46.3521 191.83 46.2319C192.073 46.1089 192.337 46.0474 192.621 46.0474C192.832 46.0474 193.012 46.084 193.162 46.1572C193.311 46.2305 193.437 46.3271 193.54 46.4473C193.642 46.5674 193.729 46.6978 193.799 46.8384H193.838C193.847 46.7622 193.857 46.6655 193.869 46.5483C193.884 46.4282 193.901 46.2993 193.922 46.1616C193.942 46.021 193.967 45.8848 193.997 45.7529L194.335 44.1621H195.359L193.909 51H193.104L193.201 50.2134H193.17C193.042 50.3774 192.901 50.5254 192.749 50.6572C192.599 50.7891 192.434 50.8945 192.252 50.9736C192.07 51.0498 191.868 51.0879 191.646 51.0879ZM192.045 50.2485C192.183 50.2485 192.315 50.2134 192.441 50.1431C192.57 50.0728 192.688 49.9761 192.797 49.853C192.908 49.7271 193.009 49.5835 193.1 49.4224C193.191 49.2583 193.269 49.084 193.333 48.8994C193.397 48.7148 193.447 48.5273 193.482 48.3369C193.518 48.1465 193.535 47.9619 193.535 47.7832C193.535 47.5107 193.469 47.2939 193.337 47.1328C193.208 46.9688 193.015 46.8867 192.757 46.8867C192.59 46.8867 192.435 46.9336 192.292 47.0273C192.148 47.1211 192.018 47.2485 191.9 47.4097C191.783 47.5708 191.682 47.7568 191.597 47.9678C191.515 48.1758 191.452 48.3984 191.408 48.6357C191.364 48.873 191.342 49.1104 191.342 49.3477C191.342 49.6436 191.401 49.8677 191.518 50.02C191.638 50.1724 191.814 50.2485 192.045 50.2485Z"
      fill="#1D1D1B"
    />
    <defs>
      <clipPath id="clip0_2667_586">
        <rect width="149.879" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FooterSvg = ({ className, ...rest }) => (
  <svg
    width="386"
    height="380"
    viewBox="0 0 386 380"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <g opacity="0.05" clip-path="url(#clip0_486_2650)">
      <path
        d="M89.4108 425.517C160.253 425.517 217.681 368.088 217.681 297.247C217.681 226.405 160.253 168.977 89.4108 168.977C18.5691 168.977 -38.8594 226.405 -38.8594 297.247C-38.8594 368.088 18.5691 425.517 89.4108 425.517Z"
        fill="white"
      />
      <path
        d="M89.6233 131.153C107.88 131.153 122.718 145.955 122.718 164.248H185.817C185.817 111.114 142.757 68.0547 89.6233 68.0547C36.4895 68.0547 -6.57031 111.114 -6.57031 164.248H56.5283C56.5283 145.991 71.3301 131.153 89.6233 131.153V131.153Z"
        fill="white"
      />
      <path
        d="M255.72 297.244C255.72 315.501 240.918 330.339 222.625 330.339V393.438C275.759 393.438 318.819 350.378 318.819 297.244C318.819 244.111 275.759 201.051 222.625 201.051V264.149C240.882 264.149 255.72 278.951 255.72 297.244V297.244Z"
        fill="white"
      />
      <path
        d="M207.496 152.283V101.367C251.683 101.367 287.542 137.19 287.542 181.413H236.627C236.627 165.339 223.571 152.283 207.496 152.283V152.283Z"
        fill="white"
      />
      <path
        d="M326.562 318.083L362.567 354.088C393.807 322.847 393.807 272.15 362.567 240.91L326.562 276.915C337.909 288.261 337.909 306.736 326.562 318.083Z"
        fill="white"
      />
      <path
        d="M67.9146 59.4345L31.9102 23.4301C63.1503 -7.81005 113.847 -7.81005 145.088 23.4301L109.083 59.4345C97.7364 48.0877 79.2614 48.0877 67.9146 59.4345Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_486_2650">
        <rect width="386" height="380" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FooterLogo = ({ className, ...rest }) => (
  <svg
    width="180"
    height="48"
    {...rest}
    className={`w-full h-auto ${className}`}
    viewBox="0 0 180 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_485_2530)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#1D1D1B"
      />
      <path
        d="M24.2787 16.9141C20.3033 16.9141 17.082 20.1354 17.082 24.1107C17.082 28.0861 20.3033 31.3074 24.2787 31.3074C28.254 31.3074 31.4753 28.0861 31.4753 24.1107C31.4706 20.1354 28.2493 16.9141 24.2787 16.9141ZM24.2787 27.6661C22.3125 27.6661 20.7233 26.0721 20.7233 24.1107C20.7233 22.1445 22.3173 20.5553 24.2787 20.5553C26.2401 20.5553 27.8341 22.1493 27.8341 24.1107C27.8341 26.0721 26.2401 27.6661 24.2787 27.6661Z"
        fill="#E43625"
      />
      <path
        d="M30.1631 3.12745C28.6646 1.60508 26.5838 0.660156 24.2788 0.660156C21.9738 0.660156 19.893 1.60508 18.3945 3.12745H30.1631Z"
        fill="#EE7F25"
      />
      <path
        d="M44.9062 29.8623C46.4286 28.3638 47.3735 26.2831 47.3735 23.978C47.3735 21.673 46.4286 19.5923 44.9062 18.0938V29.8623Z"
        fill="#FFCE1B"
      />
      <path
        d="M3.36573 18.0938C1.84336 19.5923 0.898438 21.673 0.898438 23.978C0.898438 26.2831 1.84336 28.3638 3.36573 29.8623V18.0938Z"
        fill="#6F368B"
      />
      <path
        d="M18.3906 44.7305C19.8891 46.2528 21.9699 47.1978 24.2749 47.1978C26.5799 47.1978 28.6607 46.2528 30.1592 44.7305H18.3906Z"
        fill="#3091D0"
      />
      <path
        d="M31.2455 7.31329C29.7804 5.00348 27.2081 3.4668 24.2731 3.4668C21.3382 3.4668 18.7659 5.00348 17.3008 7.31329H31.2455Z"
        fill="#3091D0"
      />
      <path
        d="M40.7266 30.9486C43.0364 29.4835 44.5731 26.9112 44.5731 23.9763C44.5731 21.0413 43.0364 18.469 40.7266 17.0039V30.9486Z"
        fill="#6F368B"
      />
      <path
        d="M7.56133 17.0039C5.25153 18.469 3.71484 21.0413 3.71484 23.9763C3.71484 26.9112 5.25153 29.4835 7.56133 30.9486V17.0039Z"
        fill="#FFCE1B"
      />
      <path
        d="M17.3008 40.5332C18.7659 42.843 21.3382 44.3797 24.2731 44.3797C27.2081 44.3797 29.7804 42.843 31.2455 40.5332H17.3008Z"
        fill="#54AD47"
      />
      <path
        d="M16.0865 35.6415C14.106 35.5222 12.5073 33.9998 12.2782 32.0527H8.09766C8.34104 36.2953 11.7867 39.6741 16.0579 39.8173L16.0865 35.6415Z"
        fill="#6F368B"
      />
      <path
        d="M35.8857 31.9297C35.7664 33.9102 34.244 35.5089 32.2969 35.738V39.9186C36.5395 39.6752 39.9183 36.2295 40.0614 31.9583L35.8857 31.9297Z"
        fill="#EE7F25"
      />
      <path
        d="M32.0742 12.0488C34.0547 12.1681 35.6535 13.6905 35.8825 15.6376H40.0631C39.8197 11.395 36.3741 8.01622 32.1029 7.87305L32.0742 12.0488Z"
        fill="#FFCE1B"
      />
      <path
        d="M12.2734 15.7506C12.3927 13.7701 13.9151 12.1713 15.8622 11.9423V7.76172C11.6196 8.00511 8.24083 11.4507 8.09766 15.7219L12.2734 15.7506Z"
        fill="#E43625"
      />
      <path
        d="M7.79085 8.82227L7.62859 15.5751L3.73438 15.7183L3.8155 13.733C3.8155 13.733 5.17562 10.588 7.79085 8.82227Z"
        fill="#FFCE1B"
      />
      <path
        d="M40.5039 8.77344L40.6662 15.5263L44.5604 15.6694L44.4792 13.6842C44.4792 13.6794 43.1191 10.5392 40.5039 8.77344Z"
        fill="#3091D0"
      />
      <path
        d="M40.5039 38.5269L40.6662 31.774L44.5604 31.6309L44.4792 33.6161C44.4792 33.6209 43.1191 36.7659 40.5039 38.5269Z"
        fill="#FFCE1B"
      />
      <path
        d="M7.79085 38.5874L7.62859 31.8346L3.73438 31.6914L3.8155 33.6767C3.8155 33.6767 5.17562 36.8216 7.79085 38.5874Z"
        fill="#3091D0"
      />
      <path
        d="M9.23047 7.34148C9.23047 7.34148 12.2704 3.95313 14.2175 3.44727H16.4701L16.451 7.34148H9.23047Z"
        fill="#54AD47"
      />
      <path
        d="M39.4497 7.45281C39.4497 7.45281 36.4097 4.06446 34.4626 3.55859H32.2148L32.2339 7.45281H39.4497Z"
        fill="#6F368B"
      />
      <path
        d="M39.4497 40.2148C39.4497 40.2148 36.4097 43.6032 34.4626 44.1091H32.2148L32.2339 40.2148H39.4497Z"
        fill="#E43625"
      />
      <path
        d="M9.23047 40.1055C9.23047 40.1055 12.2704 43.4938 14.2175 43.9997H16.4701L16.451 40.1055H9.23047Z"
        fill="#EE7F25"
      />
      <path
        d="M20.6643 24.4082H17.1328V38.4484H20.6643V24.4082Z"
        fill="#E43625"
      />
      <path
        d="M20.2187 15.6108C20.3333 13.4585 22.1086 11.75 24.2895 11.75C26.4705 11.75 28.2458 13.4585 28.3603 15.6108H32.5361C32.4168 11.1535 28.7755 7.57422 24.2895 7.57422C19.8036 7.57422 16.1623 11.1535 16.043 15.6108H20.2187Z"
        fill="#EE7F25"
      />
      <path
        d="M32.4375 19.9043C34.5898 20.0188 36.2983 21.7941 36.2983 23.9751C36.2983 26.156 34.5898 27.9313 32.4375 28.0459V32.2216C36.8948 32.1023 40.4741 28.4611 40.4741 23.9751C40.4741 19.4891 36.8948 15.8478 32.4375 15.7285V19.9043Z"
        fill="#54AD47"
      />
      <path
        d="M15.8686 28.0459C13.7163 27.9313 12.0078 26.156 12.0078 23.9751C12.0078 21.7941 13.7163 20.0188 15.8686 19.9043V15.7285C11.4113 15.8478 7.83203 19.4891 7.83203 23.9751C7.83203 28.4611 11.4113 32.1023 15.8686 32.2216V28.0459Z"
        fill="#3091D0"
      />
      <path
        d="M28.1825 31.9336C28.0632 33.9141 26.5409 35.5128 24.5938 35.7419V39.9225C28.8363 39.6791 32.2151 36.2335 32.3583 31.9622L28.1825 31.9336Z"
        fill="#FFCE1B"
      />
      <path
        d="M74.9362 22.7918C74.9362 27.8875 71.7821 31.2742 67.179 31.2742C65.547 31.2742 64.1347 30.7552 62.984 29.822V37.6335H57.6016V14.5714H62.6126L62.7591 15.7982C63.9098 14.7916 65.3953 14.1992 67.1738 14.1992C71.7821 14.2359 74.9362 17.8061 74.9362 22.7918ZM69.5224 22.7918C69.5224 20.5951 68.1886 18.8494 66.18 18.8494C63.8052 18.8494 62.7643 20.375 62.7643 22.7551C62.7643 25.1719 64.0249 26.6241 66.18 26.6241C68.1833 26.6241 69.5224 25.0985 69.5224 22.7918Z"
        fill="white"
      />
      <path
        d="M89.7473 14.346L89.4126 18.6973C89.2295 18.6606 89.0412 18.6239 88.4083 18.6239C85.5523 18.6239 83.5855 20.1495 83.5855 22.3042V30.9335H78.2031V14.5714H83.2142L83.4391 16.5793C84.4068 15.0905 86.0021 14.1992 88.3769 14.1992C88.9261 14.1992 89.4492 14.2726 89.7473 14.346Z"
        fill="white"
      />
      <path
        d="M108.493 22.7184C108.493 27.7041 104.931 31.3109 99.6951 31.3109C94.4225 31.3109 90.9336 27.7041 90.9336 22.7184C90.9336 17.8061 94.4225 14.1992 99.6951 14.1992C104.931 14.1992 108.493 17.8061 108.493 22.7184ZM103.074 22.7184C103.074 20.4483 101.74 18.8494 99.6951 18.8494C97.6185 18.8494 96.3526 20.4483 96.3526 22.7184C96.3526 25.0618 97.6132 26.6608 99.6951 26.6608C101.735 26.6608 103.074 25.0618 103.074 22.7184Z"
        fill="white"
      />
      <path
        d="M124.077 30.3046C123.036 30.897 121.367 31.3112 119.401 31.3112C115.357 31.3112 112.721 29.1513 112.721 25.3242V18.9597H110.383V14.5717H112.721V10.3672H118.103V14.5717H123.151V18.923H118.103V24.6165C118.103 26.1054 118.993 26.6244 120.295 26.6244C121.074 26.6244 121.817 26.5143 122.78 26.1054L124.077 30.3046Z"
        fill="white"
      />
      <path
        d="M142.113 24.2073H130.977C131.494 25.7695 132.907 26.8128 135.135 26.8128C136.919 26.8128 137.918 26.4406 138.807 25.8429L140.999 29.3397C139.738 30.2677 137.845 31.3109 134.764 31.3109C129.083 31.3109 125.484 27.704 125.484 22.7184C125.484 17.6226 128.863 14.1992 133.911 14.1992C139.032 14.1992 142.259 17.2504 142.259 22.7551C142.265 23.2426 142.191 23.9137 142.113 24.2073ZM130.982 21.0093H137.327C136.992 19.447 136.03 18.6292 134.246 18.6292C132.65 18.6292 131.426 19.3369 130.982 21.0093Z"
        fill="white"
      />
      <path
        d="M159.89 21.4182V30.9387H154.769L154.733 29.9688C153.619 30.8234 152.133 31.3057 150.574 31.3057C146.861 31.3057 144.156 29.2244 144.156 25.8744C144.156 22.3042 146.939 20.4064 151.171 20.4064C152.468 20.4064 153.697 20.7052 154.66 21.3343V21.1509C154.66 19.3264 153.472 18.2884 150.501 18.2884C148.644 18.2884 147.609 18.6606 146.677 18.9962L147.122 14.7549C147.865 14.5295 149.387 14.1992 151.725 14.1992C157.181 14.2045 159.89 17.2556 159.89 21.4182ZM154.66 25.8849C154.66 25.067 154.027 23.9871 152.096 23.9871C150.574 23.9871 149.575 24.7315 149.575 25.8849C149.575 27.0382 150.58 27.746 152.096 27.746C153.692 27.7407 154.66 26.9596 154.66 25.8849Z"
        fill="white"
      />
      <path
        d="M179.857 20.9674V30.9387H174.438V21.1928C174.438 19.8926 173.548 18.8127 171.765 18.8127C170.243 18.8127 169.128 19.7825 169.128 21.2295V30.9387H163.746V14.5714H168.794L168.94 15.9869C169.793 14.907 171.205 14.1992 173.355 14.1992C177.634 14.1992 179.857 16.7261 179.857 20.9674Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_485_2530">
        <rect width="179.854" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DotGrid = ({ className, fillColor, ...rest }) => (
  <svg
    width="214"
    height="115"
    {...rest}
    className={`${className}`}
    viewBox="0 0 214 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.578 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 214 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 199.859 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 185.719 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171.582 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 157.441 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 143.301 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 129.16 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 115.02 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.5781 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 115)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 100.877)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 86.7559)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 72.6309)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 58.5078)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 44.3867)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 16.1406)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 101 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8594 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.7188 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58.582 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 44.4414 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 30.3008 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 16.1602 2.01758)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 30.2637)"
      fill={fillColor}
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.01953 2.01758)"
      fill={fillColor}
    />
  </svg>
);

export const YellowBottomVector = ({ className, ...rest }) => (
  <svg
    width="73"
    height="73"
    {...rest}
    className={`w-full h-auto ${className}`}
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.5666 6.81108e-05L73 6.86646e-05C73 40.2976 40.3308 73 7.62939e-05 73L7.68477e-05 26.5666C14.6598 26.5666 26.5666 14.6598 26.5666 6.81108e-05Z"
      fill="#FFCE1B"
    />
  </svg>
);
export const CallIcon = ({ className, ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1864_43472)">
      <path
        d="M4.99609 4H8.99609L10.9961 9L8.49609 10.5C9.56705 12.6715 11.3246 14.429 13.4961 15.5L14.9961 13L19.9961 15V19C19.9961 19.5304 19.7854 20.0391 19.4103 20.4142C19.0352 20.7893 18.5265 21 17.9961 21C14.0954 20.763 10.4162 19.1065 7.65292 16.3432C4.8896 13.5798 3.23314 9.90074 2.99609 6C2.99609 5.46957 3.20681 4.96086 3.58188 4.58579C3.95695 4.21071 4.46566 4 4.99609 4Z"
        stroke="#6F368B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9961 7C15.5265 7 16.0352 7.21071 16.4103 7.58579C16.7854 7.96086 16.9961 8.46957 16.9961 9"
        stroke="#6F368B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9961 3C16.5874 3 18.1135 3.63214 19.2387 4.75736C20.364 5.88258 20.9961 7.4087 20.9961 9"
        stroke="#6F368B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1864_43472">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(-0.00390625)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const GreenVector = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={` ${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43 15.6488L43 43C19.2631 43 0 23.7565 0 0L27.3512 0C27.3512 8.63517 34.3648 15.6488 43 15.6488Z"
      fill="#54AD47"
    />
  </svg>
);

export const WhatsAppIcon = ({ className, ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9961 23.25C17.7951 23.25 22.4961 18.549 22.4961 12.75C22.4961 6.95101 17.7951 2.25 11.9961 2.25C6.1971 2.25 1.49609 6.95101 1.49609 12.75C1.49609 14.6332 1.99184 16.4005 2.85995 17.9287L1.49609 23.25L6.98224 21.9778C8.47213 22.7891 10.1803 23.25 11.9961 23.25ZM11.9961 21.6346C16.9029 21.6346 20.8807 17.6568 20.8807 12.75C20.8807 7.84316 16.9029 3.86538 11.9961 3.86538C7.08926 3.86538 3.11148 7.84316 3.11148 12.75C3.11148 14.6445 3.70447 16.4006 4.71497 17.8427L3.91917 20.8269L6.95604 20.0677C8.38811 21.0559 10.1245 21.6346 11.9961 21.6346Z"
      fill="#BFC8D0"
    />
    <path
      d="M20.9961 12C20.9961 16.9706 16.9667 21 11.9961 21C10.1002 21 8.34126 20.4138 6.89059 19.4127L3.81428 20.1818L4.62041 17.1588C3.59679 15.698 2.99609 13.9192 2.99609 12C2.99609 7.02944 7.02553 3 11.9961 3C16.9667 3 20.9961 7.02944 20.9961 12Z"
      fill="url(#paint0_linear_1864_43475)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9961 22.5C17.7951 22.5 22.4961 17.799 22.4961 12C22.4961 6.20101 17.7951 1.5 11.9961 1.5C6.1971 1.5 1.49609 6.20101 1.49609 12C1.49609 13.8832 1.99184 15.6505 2.85995 17.1787L1.49609 22.5L6.98224 21.2278C8.47213 22.0391 10.1803 22.5 11.9961 22.5ZM11.9961 20.8846C16.9029 20.8846 20.8807 16.9068 20.8807 12C20.8807 7.09316 16.9029 3.11538 11.9961 3.11538C7.08926 3.11538 3.11148 7.09316 3.11148 12C3.11148 13.8945 3.70447 15.6506 4.71497 17.0927L3.91917 20.0769L6.95604 19.3177C8.38811 20.3059 10.1245 20.8846 11.9961 20.8846Z"
      fill="white"
    />
    <path
      d="M9.37111 7.12504C9.12146 6.6236 8.73849 6.668 8.3516 6.668C7.66016 6.668 6.58203 7.49621 6.58203 9.03759C6.58203 10.3008 7.13868 11.6836 9.01441 13.7522C10.8246 15.7485 13.2031 16.7812 15.1777 16.7461C17.1524 16.7109 17.5586 15.0117 17.5586 14.4379C17.5586 14.1835 17.4008 14.0566 17.292 14.0221C16.6192 13.6992 15.3781 13.0975 15.0957 12.9844C14.8133 12.8714 14.6659 13.0243 14.5742 13.1075C14.3181 13.3515 13.8105 14.0707 13.6367 14.2325C13.4629 14.3942 13.2038 14.3124 13.096 14.2512C12.6992 14.092 11.6233 13.6134 10.7657 12.7821C9.70509 11.754 9.64284 11.4002 9.44302 11.0854C9.28316 10.8335 9.40047 10.6789 9.459 10.6114C9.68752 10.3477 10.003 9.94061 10.1445 9.73832C10.286 9.53602 10.1737 9.22889 10.1063 9.03759C9.81642 8.21488 9.57083 7.52618 9.37111 7.12504Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1864_43475"
        x1="19.8711"
        y1="5.25"
        x2="2.99609"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BD066" />
        <stop offset="1" stop-color="#27B43E" />
      </linearGradient>
    </defs>
  </svg>
);
export const PolicyVector = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 71 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.6541 0.587328L70.4929 0.587326C70.4929 39.6846 38.9456 71.4128 -2.28882e-05 71.4128L-2.48481e-05 26.3625C14.1562 26.3625 25.6541 14.8104 25.6541 0.587328Z"
      fill="#6F368B"
    />
  </svg>
);
export const PolicyVector12 = ({ className }) => (
  <svg
    className={className}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.5" cy="21.5" r="21.5" fill="#6F368B" />
  </svg>
);
export const SearchSvg2 = ({ className, ...rest }) => (
  <svg
    width="128"
    height="83"
    viewBox="0 0 128 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <g clip-path="url(#clip0_190_14930)">
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0586 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0352 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0117 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9883 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0625 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0391 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9922 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0625 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0391 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9922 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0625 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0391 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9922 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0586 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0391 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9922 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0586 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0625 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0391 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0352 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9922 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9883 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 81.1484 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 75.125 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 69.1016 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 63.082 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0586 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 57.0625 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0391 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 51.0352 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.0156 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9922 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 38.9883 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.92969 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.90625 49.043)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.93359 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.91016 43.0273)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.93359 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.91016 37.0137)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.93359 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.91016 30.998)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.92969 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.91016 24.9824)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.92969 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.93359 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.91016 18.9668)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.90625 6.9375)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 33.0195 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 26.9961 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 20.9727 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 14.9531 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.92969 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 8.93359 0.921875)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.91016 12.9512)"
        fill="#6F368B"
      />
      <ellipse
        cx="0.429656"
        cy="0.430179"
        rx="0.429656"
        ry="0.430179"
        transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 2.90625 0.921875)"
        fill="#6F368B"
      />
      <path
        d="M125.115 138.76C66.3023 137.342 18.8354 89.8755 17.418 31.0624L84.0426 31.0716C85.3867 53.0979 103.08 70.7911 125.106 72.1352L125.115 138.76Z"
        stroke="#3091D0"
        stroke-width="5.38287"
      />
    </g>
    <defs>
      <clipPath id="clip0_190_14930">
        <rect
          width="138"
          height="82.2026"
          fill="white"
          transform="translate(-10 0.0625)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BlueSemiCircle = ({ className, ...rest }) => (
  <svg
    width="88"
    height="96"
    {...rest}
    className={`${className}`}
    viewBox="0 0 88 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.3945 52.0148C54.305 45.364 63.6881 43.9398 70.3522 48.86L87.3237 25.8737C67.9674 11.5824 40.6994 15.6871 26.4081 35.0433C12.1169 54.3996 16.2215 81.6676 35.5778 95.9589L52.5492 72.9725C45.8984 68.0621 44.4742 58.6789 49.3945 52.0148Z"
      fill="#3091D0"
    />
    <mask
      id="mask0_184_29219"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="18"
      y="17"
      width="70"
      height="79"
    >
      <path
        d="M49.4005 51.8035C54.291 45.1798 63.6359 43.7614 70.2728 48.6616L87.1751 25.7689C67.8978 11.5359 40.7409 15.6239 26.5079 34.9012C12.2749 54.1785 16.3628 81.3354 35.6401 95.5684L52.5424 72.6757C45.9187 67.7853 44.5003 58.4403 49.4005 51.8035Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_184_29219)">
      <g opacity="0.5">
        <path
          d="M88.1981 -89.0982L104.366 18.3058"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M85.1512 -84.979L101.319 22.4249"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M82.1083 -80.8599L98.2758 26.5441"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M79.0731 -76.7369L95.2407 30.6671"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M76.0302 -72.6177L92.1977 34.7863"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M72.9872 -68.5025L89.1547 38.9015"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M69.9481 -64.3833L86.1157 43.0206"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M66.9012 -60.2642L83.0688 47.1398"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M63.8661 -56.1431L80.0337 51.2609"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M60.8192 -52.0259L76.9868 55.378"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M57.7802 -47.9068L73.9477 59.4972"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M54.7411 -43.7876L70.9087 63.6163"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M51.702 -39.6665L67.8696 67.7374"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M48.6591 -35.5494L64.8266 71.8546"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M45.6161 -31.4322L61.7837 75.9718"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M42.5731 -27.315L58.7407 80.089"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M39.5341 -23.1978L55.7016 84.2062"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M36.4872 -19.0767L52.6547 88.3273"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M33.452 -14.9576L49.6196 92.4464"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M30.4052 -10.8384L46.5727 96.5655"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M27.3661 -6.71733L43.5337 100.687"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M24.327 -2.60209L40.4946 104.802"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M21.288 1.519L37.4555 108.923"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M18.245 5.63814L34.4126 113.042"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M15.2059 9.75533L31.3735 117.159"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M12.1591 13.8745L28.3266 121.278"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M9.11609 17.9936L25.2837 125.398"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M6.08093 22.1167L22.2485 129.521"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M3.03797 26.2358L19.2055 133.64"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-0.00500266 30.351L16.1626 137.755"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-3.04407 34.4702L13.1235 141.874"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-6.09094 38.5893L10.0766 145.993"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-9.1261 42.7104L7.04146 150.114"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-12.173 46.8276L3.99459 154.232"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-15.212 50.9467L0.955526 158.351"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-18.2511 55.0659L-2.08354 162.47"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-21.2902 59.187L-5.1226 166.591"
          stroke="white"
          stroke-width="0.515489"
        />
        <path
          d="M-24.3331 63.3042L-8.16557 170.708"
          stroke="white"
          stroke-width="0.515489"
        />
      </g>
    </g>
  </svg>
);

export const LinkArrowSvg = ({ className, strokeColor, ...rest }) => (
  <svg
    width="24"
    height="24"
    {...rest}
    className={`${className}`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1864_20929)">
      <path
        d="M16.9495 7.05054L7.04997 16.95"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9495 12.7074V7.05054"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.2929 7.05035H16.9498"
        stroke={strokeColor}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1864_20929">
        <rect width="24" height="24" fill={strokeColor} />
      </clipPath>
    </defs>
  </svg>
);

export const ThreeDotsBulletSvg = ({ className, fillColor, ...rest }) => (
  <svg
    width="34"
    height="18"
    viewBox="0 0 34 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M0 9C0 13.6944 3.80558 17.5 8.5 17.5V0.5C3.80558 0.5 0 4.30558 0 9Z"
      fill={fillColor}
    />
    <path
      d="M8.5 9C8.5 13.6944 12.3056 17.5 17 17.5V0.5C12.3056 0.5 8.5 4.30558 8.5 9Z"
      fill={fillColor}
    />
    <circle cx="25.5" cy="9" r="8.5" fill={fillColor} />
  </svg>
);

export const BlueVectorSvg = ({ className, ...rest }) => (
  <svg
    width="71"
    height="71"
    viewBox="0 0 71 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M25.6534 70.4929L70.4922 70.4929C70.4922 31.5793 38.9449 -1.37898e-06 -0.00075531 -3.08134e-06L-0.00075727 44.8388C14.1555 44.8388 25.6534 56.3367 25.6534 70.4929Z"
      fill="#3091D0"
    />
  </svg>
);

export const RedVectorSvg = ({ className, ...rest }) => (
  <svg
    width="63"
    height="126"
    viewBox="0 0 63 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M41.3252 63C41.3252 74.9569 51.0193 84.6749 63 84.6749L63 126C28.2011 126 1.99939e-05 97.7989 1.69517e-05 63C1.39095e-05 28.2011 28.2011 3.04221e-06 63 0L63 41.3251C51.0431 41.3251 41.3252 51.0193 41.3252 63Z"
      fill="#E43625"
    />
  </svg>
);

export const ReprintGraphic = () => (
  <svg
    width="120"
    height="124"
    viewBox="0 0 120 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="95.7475" cy="59.9956" r="24.2553" fill="#FFCE1B" />
    <g clip-path="url(#clip0_2718_14463)">
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4844 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4766 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4766 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5234 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 121.531)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 109.496)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 97.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 49.4277)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 13.3281)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 0.421875 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4453 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4453 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4453 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4453 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 13.3281)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 12.4375 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4531 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 13.3281)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 24.4609 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4844 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4844 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4766 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4766 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4844 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4844 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4766 13.3281)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 36.4766 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 13.3262)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 48.5 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5625 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5234 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5625 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5625 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5625 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5234 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5234 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 13.3262)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 13.3262)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 60.5156 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 84.5547 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5312 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 85.5312)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 73.4961)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 61.4629)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 49.4316)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 37.3965)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 25.3613)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 13.3262)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 13.3281)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 72.5391 1.29297)"
        fill="#1D1D1B"
      />
      <ellipse
        cx="0.858529"
        cy="0.859574"
        rx="0.858529"
        ry="0.859574"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 96.5781 1.29297)"
        fill="#1D1D1B"
      />
    </g>
    <defs>
      <clipPath id="clip0_2718_14463">
        <rect
          width="123.404"
          height="97.8723"
          fill="white"
          transform="translate(97.875) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const OverViewSvg1 = ({ className, strokeColor, ...rest }) => (
  <svg
    width="378"
    height="186"
    {...rest}
    className={`${className}`}
    viewBox="0 0 378 186"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.6541 0.587328L70.4929 0.587326C70.4929 39.6846 38.9456 71.4128 -2.28882e-05 71.4128L-2.48481e-05 26.3625C14.1562 26.3625 25.6541 14.8104 25.6541 0.587328Z"
      fill="#6F368B"
    />
  </svg>
);
export const Link11Svg1 = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43 15.6488L43 43C19.2631 43 0 23.7565 0 0L27.3512 0C27.3512 8.63517 34.3648 15.6488 43 15.6488Z"
      fill="#54AD47"
    />
  </svg>
);
export const Link11Svg2 = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3512 43L-1.87959e-06 43C-8.42015e-07 19.2631 19.2435 8.41161e-07 43 1.87959e-06L43 27.3512C34.3648 27.3512 27.3512 34.3648 27.3512 43Z"
      fill="#EE7F25"
    />
  </svg>
);
export const Link11Svg3 = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6488 1.19556e-06L43 0C43 23.7369 23.7565 43 0 43L-1.19556e-06 15.6488C8.63516 15.6488 15.6488 8.63517 15.6488 1.19556e-06Z"
      fill="#6F368B"
    />
  </svg>
);

export const PolicyVector2 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="102"
    height="204"
    viewBox="0 0 102 204"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M66.9074 101.877C66.9074 82.5414 82.6027 66.8266 102 66.8266L102 -1.52588e-05C45.659 -1.70467e-05 2.02942e-05 45.6038 1.85025e-05 101.877C1.67108e-05 158.15 45.659 203.754 102 203.754L102 136.927C82.6412 136.927 66.9074 121.251 66.9074 101.877Z"
      fill="#EE7F25"
    />
    <mask
      id="mask0_1864_25201"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="102"
      height="204"
    >
      <path
        d="M66.9074 101.877C66.9074 82.5414 82.6027 66.8266 102 66.8266L102 -1.52588e-05C45.659 -1.70619e-05 2.02518e-05 45.6038 1.84752e-05 101.877C1.66986e-05 158.15 45.659 203.754 102 203.754L102 136.927C82.6412 136.927 66.9074 121.251 66.9074 101.877Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_1864_25201)">
      <g opacity="0.5">
        <path
          d="M-56.5084 -170.338L124.07 10.0228"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -158.315L124.07 22.046"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -146.294L124.07 34.0662"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -134.268L124.07 46.0924"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -122.245L124.07 58.1161"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -110.218L124.07 70.1424"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -98.1982L124.07 82.1624"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -86.1716L124.07 94.1891"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -74.1484L124.07 106.212"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -62.1221L124.07 118.239"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -50.1018L124.07 130.259"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -38.0754L124.07 142.285"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -26.0518L124.07 154.309"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -14.032L124.07 166.329"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 -2.00537L124.07 178.355"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 10.0178L124.07 190.379"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 22.0442L124.07 202.405"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 34.0645L124.07 214.425"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 46.0908L124.07 226.452"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 58.1143L124.07 238.475"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 70.1406L124.07 250.501"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 82.1609L124.07 262.522"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 94.1873L124.07 274.548"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 106.21L124.07 286.571"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 118.237L124.07 298.597"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 130.26L124.07 310.621"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 142.281L124.07 322.641"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 154.307L124.07 334.667"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 166.33L124.07 346.691"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 178.357L124.07 358.717"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 190.377L124.07 370.737"
          stroke="white"
          strokeWidth="1.25123"
        />
        <path
          d="M-56.5084 202.403L124.07 382.764"
          stroke="white"
          strokeWidth="1.25123"
        />
      </g>
    </g>
  </svg>
);

export const PolicyVector3 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="137"
    height="147"
    viewBox="0 0 137 147"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68.4592 102.746C81.4522 102.746 92.0123 92.5726 92.0123 80L136.918 80C136.918 116.518 106.274 146.112 68.4592 146.112C30.6449 146.112 -1.59625e-06 116.518 0 80L44.9061 80C44.9061 92.5476 55.4403 102.746 68.4592 102.746Z"
      fill="#E43625"
    />
    <path
      d="M68.4592 22.7457C81.4522 22.7457 92.0123 12.5726 92.0123 5.20238e-06L136.918 7.74138e-06C136.918 36.518 106.274 66.1124 68.4592 66.1124C30.6449 66.1124 -1.59625e-06 36.518 0 0L44.9061 2.539e-06C44.9061 12.5476 55.4403 22.7457 68.4592 22.7457Z"
      fill="#FFCE1B"
    />
  </svg>
);

export const PolicyVector4 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.5" cy="21.5" r="21.5" fill="#EE7F25" />
  </svg>
);

export const PolicyVector5 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28.5" cy="28.5" r="28.5" fill="#54AD47" />
  </svg>
);
export const DotsGrid = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="171"
    height="115"
    viewBox="0 0 171 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.297 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1562 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0156 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.297 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0156 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.297 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0156 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 115)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 100.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 86.7559)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 72.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 58.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 44.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 16.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 2.01758)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 30.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 2.01758)"
      fill="#6F368B"
    />
  </svg>
);

export const PolicyVector6 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13.5" cy="13.5" r="13.5" fill="#FFCE1B" />
  </svg>
);

export const PolicyVector7 = ({ className, ...rest }) => (
  <svg
    width="63"
    height="126"
    viewBox="0 0 63 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M41.3252 63C41.3252 74.9569 51.0193 84.6749 63 84.6749L63 126C28.2011 126 1.99939e-05 97.7989 1.69517e-05 63C1.39095e-05 28.2011 28.2011 3.04221e-06 63 0L63 41.3251C51.0431 41.3251 41.3252 51.0193 41.3252 63Z"
      fill="#E43625"
    />
  </svg>
);

export const DropDownArrowSvg = ({ className, ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <g clip-path="url(#clip0_184_29332)">
      <path
        d="M18 15L12 9L6 15"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_184_29332">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="matrix(-1 0 0 -1 24 24)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowUpSvg = ({ className, ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <g clip-path="url(#clip0_190_3688)">
      <path
        d="M6 9L12 15L18 9"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_190_3688">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CardOneSvg = ({ className, ...rest }) => (
  <svg
    width="170"
    height="94"
    viewBox="0 0 170 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.004 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 161.68 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.352 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.027 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 136.703 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.379 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.051 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 111.727 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 92.71)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 84.3945)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 76.0803)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 76.0803)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 76.0801)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 67.7637)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 59.4482)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 51.1338)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 34.5029)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.469 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.1445 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.8164 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.4922 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.168 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 61.8438 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 53.5156 26.1875)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 42.8184)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.1914 26.1875)"
      fill="#1D1D1B"
    />
    <path
      d="M41.2775 51.3222C47.0675 57.2643 46.9557 66.7879 41.0018 72.5894L61.0128 93.1262C78.3063 76.2754 78.6651 48.6047 61.8143 31.3112C44.9636 14.0177 17.2929 13.6589 -0.000647154 30.5096L20.0104 51.0464C25.9524 45.2565 35.4761 45.3683 41.2775 51.3222Z"
      fill="#E43625"
    />
    <circle cx="115.5" cy="23.5" r="13.5" fill="#6F368B" />
  </svg>
);

export const CardTwoSvg = ({ className, ...rest }) => (
  <svg
    width="159"
    height="144"
    viewBox="0 0 159 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <circle cx="10.5" cy="56.5" r="10.5" fill="#EE7F25" />
    <path
      d="M22.2849 102L49 102C49 125.185 30.204 144 7 144L7 117.285C15.4343 117.285 22.2849 110.434 22.2849 102Z"
      fill="#E43625"
    />
    <path
      d="M142.215 46C142.215 37.2696 149.666 30.1739 158.874 30.1739L158.874 -3.87718e-06C132.128 -1.73557e-06 110.453 20.5913 110.453 46C110.453 71.4087 132.128 92 158.874 92L158.874 61.8261C149.684 61.8261 142.215 54.7478 142.215 46Z"
      fill="#6F368B"
    />
    <mask
      id="mask0_2907_30639"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="110"
      y="0"
      width="49"
      height="92"
    >
      <path
        d="M142.077 45.8131C142.077 37.1182 149.497 30.0515 158.668 30.0515L158.668 0.000610352C132.031 0.000606086 110.444 20.508 110.444 45.813C110.444 71.1181 132.031 91.6255 158.668 91.6255L158.668 61.5746C149.516 61.5746 142.077 54.5252 142.077 45.8131Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_2907_30639)">
      <g opacity="0.5">
        <path d="M78.0079 -81.0003L159.113 0.105165" stroke="white" />
        <path d="M78.004 -75.5952L159.109 5.51019" stroke="white" />
        <path d="M78.004 -70.189L159.109 10.9164" stroke="white" />
        <path d="M78.0079 -64.7793L159.113 16.3261" stroke="white" />
        <path d="M78.004 -59.3743L159.109 21.7311" stroke="white" />
        <path d="M78.004 -53.9663L159.109 27.1391" stroke="white" />
        <path d="M78.0001 -48.5628L159.105 32.5427" stroke="white" />
        <path d="M78.0079 -43.1509L159.113 37.9545" stroke="white" />
        <path d="M78.004 -37.7454L159.109 43.36" stroke="white" />
        <path d="M78.0079 -32.3372L159.113 48.7683" stroke="white" />
        <path d="M78.0079 -26.9299L159.113 54.1755" stroke="white" />
        <path d="M78.004 -21.5247L159.109 59.5808" stroke="white" />
        <path d="M78.004 -16.1174L159.109 64.988" stroke="white" />
        <path d="M78.004 -10.7105L159.109 70.395" stroke="white" />
        <path d="M78.0079 -5.30128L159.113 75.8041" stroke="white" />
        <path d="M78.004 0.103265L159.109 81.2087" stroke="white" />
        <path d="M78.0079 5.51244L159.113 86.6179" stroke="white" />
        <path d="M78.004 10.9177L159.109 92.0231" stroke="white" />
        <path d="M78.004 16.3249L159.109 97.4304" stroke="white" />
        <path d="M78.0079 21.7351L159.113 102.841" stroke="white" />
        <path d="M78.004 27.1384L159.109 108.244" stroke="white" />
        <path d="M78.004 32.5447L159.109 113.65" stroke="white" />
        <path d="M78.0001 37.9499L159.105 119.055" stroke="white" />
        <path d="M78.004 43.3591L159.109 124.465" stroke="white" />
      </g>
    </g>
  </svg>
);

export const CardThreeSvg = ({ className, ...rest }) => (
  <svg
    width="207"
    height="119"
    viewBox="0 0 207 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <circle cx="17" cy="62" r="17" fill="#6F368B" />
    <path
      d="M182.829 1.05654e-06L207 0C207 20.9768 189.994 38 169 38L169 13.8292C176.631 13.8292 182.829 1.05654e-06Z"
      fill="#FFCE1B"
    />
    <path
      d="M133.498 96.6365C145.74 96.6365 155.689 106.638 155.689 118.999L197.997 118.999C197.997 83.0961 169.125 54.0002 133.498 54.0002C97.8719 54.0002 69 83.0961 69 118.999L111.308 118.999C111.308 106.663 121.233 96.6365 133.498 96.6365Z"
      fill="#EE7F25"
    />
    <mask
      id="mask0_2907_30640"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="69"
      y="54"
      width="130"
      height="65"
    >
      <path
        d="M133.502 96.6375C145.744 96.6375 155.693 106.639 155.693 119L198.001 119C198.001 83.0971 169.129 54.0012 133.502 54.0012C97.8758 54.0012 69.0039 83.0971 69.0039 119L111.312 119C111.312 106.664 121.237 96.6375 133.502 96.6375Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_2907_30640)">
      <g opacity="0.5">
        <path
          d="M305.84 17.9872L191.653 133.06"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M298.227 17.9882L184.04 133.061"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M290.617 17.9882L176.43 133.061"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M283.004 17.9879L168.817 133.061"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M275.391 17.9901L161.204 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M267.777 17.9901L153.591 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M260.168 17.9872L145.981 133.06"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M252.551 17.9892L138.364 133.062"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M244.941 17.9882L130.755 133.061"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M237.328 17.9882L123.141 133.061"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M229.719 17.9911L115.532 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M222.102 17.9901L107.915 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M214.492 17.9901L100.305 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M206.883 17.9911L92.696 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M199.266 17.9892L85.0788 133.062"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M191.656 17.9921L77.4695 133.065"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M184.043 17.9911L69.8562 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M176.434 17.9911L62.2468 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M168.82 17.9901L54.6335 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M161.203 17.9901L47.0163 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M153.594 17.9909L39.407 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M145.98 17.9909L31.7937 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M138.367 17.9921L24.1804 133.065"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M130.758 17.9899L16.571 133.062"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M123.145 17.9911L8.95774 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M115.531 17.9911L1.34446 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M107.922 17.9901L-6.26491 133.063"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M100.309 17.9899L-13.8782 133.062"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M92.6953 17.9921L-21.4915 133.065"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M85.082 17.9921L-29.1048 133.065"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M77.4727 17.9892L-36.7141 133.062"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M69.8555 17.991L-44.3313 133.064"
          stroke="white"
          stroke-width="1.25123"
        />
      </g>
    </g>
  </svg>
);

export const CardFourSvg = ({ className, ...rest }) => (
  <svg
    width="155"
    height="81"
    viewBox="0 0 155 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M132.437 62L93 62C93 27.7747 120.746 1.21284e-06 155 2.71011e-06L155 39.4366C142.549 39.4366 132.437 49.5493 132.437 62Z"
      fill="#FFCE1B"
    />
    <circle cx="17" cy="64" r="17" fill="#3091D0" />
  </svg>
);

export const PolicyVector8 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="71"
    height="71"
    viewBox="0 0 71 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.6541 -2.09282e-05L70.4929 -2.28882e-05C70.4929 38.9136 38.9456 70.4929 -2.28882e-05 70.4929L-2.48481e-05 25.6542C14.1562 25.6542 25.6541 14.1562 25.6541 -2.09282e-05Z"
      fill="#FFCE1B"
    />
  </svg>
);

export const PolicyVector9 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="71"
    height="71"
    viewBox="0 0 71 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.6541 70.4929L70.4929 70.4929C70.4929 31.5793 38.9456 -1.37898e-06 -2.28882e-05 -3.08134e-06L-2.48481e-05 44.8388C14.1562 44.8388 25.6541 56.3367 25.6541 70.4929Z"
      fill="#54AD47"
    />
  </svg>
);

export const PolicyVector10 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="76"
    height="152"
    viewBox="0 0 76 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.8526 76C49.8526 90.4242 61.5471 102.147 76 102.147L76 152C34.0204 152 4.94469e-06 117.98 8.61466e-06 76C1.22846e-05 34.0204 34.0204 -3.66997e-06 76 0L76 49.8525C61.5758 49.8525 49.8526 61.5471 49.8526 76Z"
      fill="#E43625"
    />
  </svg>
);

export const PolicyVector11 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28.5" cy="28.5" r="28.5" fill="#3091D0" />
  </svg>
);

export const OverViewSvg2 = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.5" cy="21.5" r="21.5" fill="#6F368B" />
  </svg>
);

export const RefreshSvg = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2876_18018)">
      <path
        d="M9 4.5501C10.9759 3.75445 13.1869 3.77629 15.1466 4.61083C17.1064 5.44537 18.6544 7.02423 19.45 9.00009C20.2457 10.976 20.2238 13.187 19.3893 15.1467C18.5547 17.1065 16.9759 18.6544 15 19.4501M15 15.0001V20.0001H20"
        stroke="#1D1D1B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.62891 7.16016V7.17016"
        stroke="#1D1D1B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.05859 11V11.01"
        stroke="#1D1D1B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.62891 15.0996V15.1096"
        stroke="#1D1D1B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.16016 18.3701V18.3801"
        stroke="#1D1D1B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 19.9404V19.9504"
        stroke="#1D1D1B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2876_18018">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchSvg = ({ className, strokeColor, ...rest }) => (
  <svg
    width="365"
    height="211"
    {...rest}
    className={`${className}`}
    viewBox="0 0 365 211"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.297 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1562 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0156 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.297 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0156 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 171 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 156.859 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 142.719 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.578 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.586 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.438 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 114.445 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.305 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 100.297 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 86.1641 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0234 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 72.0156 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 133)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 118.877)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 104.756)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 90.6309)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 76.5078)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 62.3867)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 34.1406)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 58 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 43.8594 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 29.7188 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5781 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 15.5859 20.0176)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.4375 48.2637)"
      fill="#6F368B"
    />
    <ellipse
      cx="1.00877"
      cy="1.01"
      rx="1.00877"
      ry="1.01"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 1.44531 20.0176)"
      fill="#6F368B"
    />
    <path
      d="M274.218 343.64C136.133 340.312 24.6877 228.867 21.3599 90.7819L177.785 90.8035C180.941 142.518 222.482 184.059 274.197 187.215L274.218 343.64Z"
      stroke="#3091D0"
      stroke-width="12.6382"
    />
  </svg>
);

export const OrangeTopSemiCircle = ({ className, ...rest }) => (
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M62 22.5634L62 62C27.7747 62 0 34.2535 0 0L39.4366 0C39.4366 12.4507 49.5493 22.5634 62 22.5634Z"
      fill="#EE7F25"
    />
  </svg>
);

export const Link13Graphic2 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43 15.6488V43C19.2631 43 0 23.7565 0 0H27.3512C27.3512 8.63517 34.3648 15.6488 43 15.6488Z"
      fill="#3091D0"
    />
  </svg>
);

export const Link14Graphic3 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="139"
    height="180"
    viewBox="0 0 139 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0962 55.954C20.0962 66.5736 11.108 75.2047 -0.000274738 75.2047L-0.000274777 111.908C32.2646 111.908 58.4121 86.8609 58.4121 55.954C58.4121 25.0471 32.2646 -2.77759e-08 -0.000274658 -6.20501e-08L-0.000274697 36.7033C11.0859 36.7033 20.0962 45.3132 20.0962 55.954Z"
      fill="#3091D0"
    />
    <mask
      id="mask0_3114_30934"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="59"
      height="112"
    >
      <path
        d="M20.2313 56.177C20.2313 66.7533 11.2798 75.3492 0.216777 75.3492L0.216768 111.903C32.35 111.903 58.391 86.9579 58.391 56.177C58.391 25.3961 32.3501 0.45118 0.216797 0.451172L0.216787 37.0048C11.2578 37.0048 20.2313 45.5796 20.2313 56.177Z"
        fill="#E43625"
      />
    </mask>
    <g mask="url(#mask0_3114_30934)">
      <g opacity="0.5">
        <path d="M97.5343 210.441L-0.306623 111.786" stroke="white" />
        <path d="M97.5421 203.865L-0.298811 105.209" stroke="white" />
        <path d="M97.5421 197.295L-0.298811 98.639" stroke="white" />
        <path d="M97.5265 190.717L-0.314436 92.0609" stroke="white" />
        <path d="M97.5421 184.154L-0.298811 85.4984" stroke="white" />
        <path d="M97.5421 177.568L-0.298811 78.9125" stroke="white" />
        <path d="M97.5421 170.994L-0.298811 72.3383" stroke="white" />
        <path d="M97.5265 164.426L-0.314436 65.7699" stroke="white" />
        <path d="M97.5343 157.84L-0.306623 59.184" stroke="white" />
        <path d="M97.5343 151.248L-0.306623 52.5922" stroke="white" />
        <path d="M97.5265 144.688L-0.314436 46.0316" stroke="white" />
        <path d="M97.5421 138.092L-0.298811 39.4359" stroke="white" />
        <path d="M97.5421 131.535L-0.298811 32.8793" stroke="white" />
        <path d="M97.5421 124.957L-0.298811 26.3011" stroke="white" />
        <path d="M97.5343 118.377L-0.306623 19.7211" stroke="white" />
        <path d="M97.5499 111.809L-0.290998 13.1527" stroke="white" />
        <path d="M97.5265 105.223L-0.314436 6.56677" stroke="white" />
        <path d="M97.5499 98.6465L-0.290998 -0.00940108" stroke="white" />
        <path d="M97.5577 92.0664L-0.283186 -6.58948" stroke="white" />
        <path d="M97.5265 85.4771L-0.314436 -13.1788" stroke="white" />
        <path d="M97.5421 78.9009L-0.298811 -19.755" stroke="white" />
        <path d="M97.5343 72.3423L-0.306623 -26.3136" stroke="white" />
        <path d="M97.339 56.2676L-0.501936 -42.3883" stroke="white" />
        <path d="M97.5499 59.1841L-0.290998 -39.4718" stroke="white" />
      </g>
    </g>
    <path
      d="M138.998 152.649V180C115.261 180 95.998 160.756 95.998 137H123.349C123.349 145.635 130.363 152.649 138.998 152.649Z"
      fill="#FFCE1B"
    />
  </svg>
);

export const Link14Graphic1 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="139"
    height="180"
    viewBox="0 0 139 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0962 55.954C20.0962 66.5736 11.108 75.2047 -0.000274738 75.2047L-0.000274777 111.908C32.2646 111.908 58.4121 86.8609 58.4121 55.954C58.4121 25.0471 32.2646 -2.77759e-08 -0.000274658 -6.20501e-08L-0.000274697 36.7033C11.0859 36.7033 20.0962 45.3132 20.0962 55.954Z"
      fill="#3091D0"
    />
    <mask
      id="mask0_3114_30934"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="59"
      height="112"
    >
      <path
        d="M20.2313 56.177C20.2313 66.7533 11.2798 75.3492 0.216777 75.3492L0.216768 111.903C32.35 111.903 58.391 86.9579 58.391 56.177C58.391 25.3961 32.3501 0.45118 0.216797 0.451172L0.216787 37.0048C11.2578 37.0048 20.2313 45.5796 20.2313 56.177Z"
        fill="#E43625"
      />
    </mask>
    <g mask="url(#mask0_3114_30934)">
      <g opacity="0.5">
        <path d="M97.5343 210.441L-0.306623 111.786" stroke="white" />
        <path d="M97.5421 203.865L-0.298811 105.209" stroke="white" />
        <path d="M97.5421 197.295L-0.298811 98.639" stroke="white" />
        <path d="M97.5265 190.717L-0.314436 92.0609" stroke="white" />
        <path d="M97.5421 184.154L-0.298811 85.4984" stroke="white" />
        <path d="M97.5421 177.568L-0.298811 78.9125" stroke="white" />
        <path d="M97.5421 170.994L-0.298811 72.3383" stroke="white" />
        <path d="M97.5265 164.426L-0.314436 65.7699" stroke="white" />
        <path d="M97.5343 157.84L-0.306623 59.184" stroke="white" />
        <path d="M97.5343 151.248L-0.306623 52.5922" stroke="white" />
        <path d="M97.5265 144.688L-0.314436 46.0316" stroke="white" />
        <path d="M97.5421 138.092L-0.298811 39.4359" stroke="white" />
        <path d="M97.5421 131.535L-0.298811 32.8793" stroke="white" />
        <path d="M97.5421 124.957L-0.298811 26.3011" stroke="white" />
        <path d="M97.5343 118.377L-0.306623 19.7211" stroke="white" />
        <path d="M97.5499 111.809L-0.290998 13.1527" stroke="white" />
        <path d="M97.5265 105.223L-0.314436 6.56677" stroke="white" />
        <path d="M97.5499 98.6465L-0.290998 -0.00940108" stroke="white" />
        <path d="M97.5577 92.0664L-0.283186 -6.58948" stroke="white" />
        <path d="M97.5265 85.4771L-0.314436 -13.1788" stroke="white" />
        <path d="M97.5421 78.9009L-0.298811 -19.755" stroke="white" />
        <path d="M97.5343 72.3423L-0.306623 -26.3136" stroke="white" />
        <path d="M97.339 56.2676L-0.501936 -42.3883" stroke="white" />
        <path d="M97.5499 59.1841L-0.290998 -39.4718" stroke="white" />
      </g>
    </g>
    <path
      d="M138.998 152.649V180C115.261 180 95.998 160.756 95.998 137H123.349C123.349 145.635 130.363 152.649 138.998 152.649Z"
      fill="#FFCE1B"
    />
  </svg>
);


export const Link13Graphic1 = ({ className, ...rest }) => (
  <svg
    {...rest}
    className={`${className}`}
    width="159"
    height="59"
    viewBox="0 0 159 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M102.954 38.3164C113.574 38.3164 122.205 47.3046 122.205 58.4129L158.908 58.4129C158.908 26.148 133.861 0.000484577 102.954 0.000485895C72.0471 0.000487213 47 26.148 47 58.4129L83.7033 58.4129C83.7033 47.3267 92.3132 38.3164 102.954 38.3164V38.3164Z"
      fill="#EE7F25"
    />
    <mask
      id="mask0_3069_29163"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="47"
      y="0"
      width="112"
      height="59"
    >
      <path
        d="M103.177 38.1598C113.753 38.1598 122.349 47.1113 122.349 58.1743L158.903 58.1743C158.903 26.0411 133.958 0.000143845 103.177 0.000137184C72.3961 0.000130522 47.4512 26.041 47.4512 58.1743L84.0048 58.1743C84.0048 47.1333 92.5796 38.1598 103.177 38.1598V38.1598Z"
        fill="#E43625"
      />
    </mask>
    <g mask="url(#mask0_3069_29163)">
      <g opacity="0.5">
        <path d="M257.451 -39.1236L158.795 58.7173" stroke="white" />
        <path d="M250.865 -39.1393L152.209 58.7016" stroke="white" />
        <path d="M244.295 -39.1393L145.639 58.7016" stroke="white" />
        <path d="M237.717 -39.1236L139.061 58.7173" stroke="white" />
        <path d="M231.154 -39.1334L132.498 58.7075" stroke="white" />
        <path d="M224.568 -39.1393L125.912 58.7016" stroke="white" />
        <path d="M217.99 -39.1393L119.334 58.7016" stroke="white" />
        <path d="M211.412 -39.1295L112.756 58.7114" stroke="white" />
        <path d="M204.842 -39.1334L106.186 58.7075" stroke="white" />
        <path d="M198.248 -39.1295L99.5922 58.7114" stroke="white" />
        <path d="M191.686 -39.1236L93.0297 58.7173" stroke="white" />
        <path d="M185.092 -39.1393L86.4359 58.7016" stroke="white" />
        <path d="M178.529 -39.1393L79.8734 58.7016" stroke="white" />
        <path d="M171.951 -39.1451L73.2953 58.6958" stroke="white" />
        <path d="M165.373 -39.1295L66.7172 58.7114" stroke="white" />
        <path d="M158.795 -39.1393L60.139 58.7016" stroke="white" />
        <path d="M152.209 -39.1295L53.5531 58.7114" stroke="white" />
        <path d="M145.646 -39.1393L46.9906 58.7016" stroke="white" />
        <path d="M139.061 -39.1393L40.4047 58.7016" stroke="white" />
        <path d="M132.482 -39.1295L33.8265 58.7114" stroke="white" />
        <path d="M125.904 -39.1393L27.2484 58.7016" stroke="white" />
        <path d="M119.334 -39.1334L20.6781 58.7075" stroke="white" />
        <path d="M103.279 -38.944L4.62341 58.897" stroke="white" />
        <path d="M106.186 -39.1393L7.52966 58.7016" stroke="white" />
      </g>
    </g>
    <circle cx="10.5" cy="10.5" r="10.5" fill="#FFCE1B" />
  </svg>
);

export const QuarterlyReturnsBottomSvg = ({ className, ...rest }) => (
  <svg
    width="231"
    height="140"
    viewBox="0 0 231 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M99.8292 1.05654e-06L124 0C124 20.9768 106.994 38 86 38L86 13.8292C93.6311 13.8292 99.8292 7.63108 99.8292 1.05654e-06Z"
      fill="#FFCE1B"
    />
    <circle cx="12" cy="111" r="12" fill="#EE7F25" />
    <path
      d="M208.982 76.0787C208.982 63.947 218.829 54.087 231 54.087L231 12.1577C195.65 12.1577 167.002 40.7711 167.002 76.0787C167.002 111.386 195.65 140 231 140L231 98.0705C218.854 98.0705 208.982 88.2346 208.982 76.0787Z"
      fill="#54AD47"
    />
    <mask
      id="mask0_2930_28365"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="167"
      y="12"
      width="64"
      height="128"
    >
      <path
        d="M208.982 76.0763C208.982 63.9446 218.829 54.0845 231 54.0845L231 12.1552C195.65 12.1552 167.002 40.7687 167.002 76.0763C167.002 111.384 195.65 139.997 231 139.997L231 98.068C218.854 98.068 208.982 88.2322 208.982 76.0763Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_2930_28365)">
      <g opacity="0.5">
        <path
          d="M131.542 -94.72L244.844 18.4446"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -87.1763L244.844 25.9883"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 -79.6377L244.848 33.5268"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -72.0925L244.844 41.072"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 -64.5459L244.848 48.6186"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -57.002L244.844 56.1626"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -49.4602L244.844 63.7043"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -41.9094L244.844 71.2551"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -34.3716L244.844 78.7929"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 -26.8262L244.848 86.3384"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 -19.2842L244.848 93.8803"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 -11.7336L244.848 101.431"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 -4.19116L244.844 108.973"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 3.34888L244.848 116.513"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 10.897L244.848 124.061"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 18.4397L244.848 131.604"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 25.9861L244.844 139.151"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 33.522L244.848 146.686"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 41.0728L244.844 154.237"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 48.6191L244.848 161.784"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 56.1599L244.848 169.324"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 63.7039L244.848 176.868"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 71.2534L244.844 184.418"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 78.7913L244.848 191.956"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 86.3369L244.844 199.501"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 93.885L244.844 207.05"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 101.423L244.848 214.588"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 108.969L244.844 222.133"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.546 116.515L244.848 229.68"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 124.059L244.844 237.224"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 131.601L244.844 244.765"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M131.542 139.152L244.844 252.316"
          stroke="white"
          stroke-width="1.25123"
        />
      </g>
    </g>
  </svg>
);

export const ExtractionTDSBlueSvg = ({ className, ...rest }) => (
  <svg
    width="88"
    height="44"
    viewBox="0 0 88 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M43.7348 14.9589C35.4938 14.9589 28.7959 8.26939 28.7959 0.00195312L0.313408 0.00195312C0.313408 24.0153 19.7505 43.4759 43.7348 43.4759C67.7192 43.4759 87.1562 24.0153 87.1562 0.00195312L58.6738 0.00195312C58.6738 8.25296 51.9923 14.9589 43.7348 14.9589Z"
      fill="#3091D0"
    />
    <mask
      id="mask0_1864_34574"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="88"
      height="44"
    >
      <path
        d="M43.7348 14.9575C35.4938 14.9575 28.7959 8.26793 28.7959 0.000488281L0.313408 0.000488281C0.313408 24.0139 19.7505 43.4744 43.7348 43.4744C67.7192 43.4744 87.1562 24.0139 87.1562 0.000488281L58.6738 0.000488281C58.6738 8.25149 51.9923 14.9575 43.7348 14.9575Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_1864_34574)">
      <g opacity="0.5">
        <path
          d="M-72.293 67.562L4.57944 -9.40332"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-67.1602 67.5562L9.71225 -9.40918"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-62.043 67.5547L14.8294 -9.41064"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-56.918 67.5586L19.9544 -9.40674"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-51.7891 67.5552L25.0833 -9.41016"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-46.6641 67.5581L30.2083 -9.40723"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-41.543 67.563L35.3294 -9.40234"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-36.4141 67.5601L40.4583 -9.40527"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-31.293 67.5615L45.5794 -9.40381"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-26.1719 67.5562L50.7005 -9.40918"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-21.043 67.5564L55.8294 -9.40894"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-15.9102 67.554L60.9622 -9.41138"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-10.7891 67.5618L66.0833 -9.40356"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-5.67187 67.5574L71.2005 -9.40796"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M-0.542969 67.5579L76.3294 -9.40747"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M4.58203 67.5549L81.4544 -9.4104"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M9.71094 67.5569L86.5833 -9.40845"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M14.8281 67.5549L91.7005 -9.4104"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M19.9609 67.5569L96.8333 -9.40845"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M25.0859 67.5549L101.958 -9.4104"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M30.207 67.5559L107.079 -9.40942"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M35.332 67.5564L112.204 -9.40894"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M40.457 67.5628L117.329 -9.40259"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M45.5781 67.5589L122.451 -9.40649"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M50.7031 67.5608L127.576 -9.40454"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M55.8359 67.5569L132.708 -9.40845"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M60.9531 67.5554L137.826 -9.40991"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M66.0781 67.5593L142.951 -9.40601"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M71.207 67.5559L148.079 -9.40942"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M76.332 67.5589L153.204 -9.40649"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M81.4531 67.5637L158.326 -9.40161"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M86.582 67.5608L163.454 -9.40454"
          stroke="white"
          stroke-width="1.25123"
        />
      </g>
    </g>
  </svg>
);

export const OverViewSvg3 = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={`w-full h-auto ${className}`}
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.71645e-06 27.3512L-6.7467e-07 3.75918e-06C23.7369 1.68403e-06 43 19.2435 43 43L15.6488 43C15.6488 34.3648 8.63517 27.3512 1.71645e-06 27.3512V27.3512Z"
      fill={strokeColor}
    />
  </svg>
);

export const OverViewSvg4 = ({ className, strokeColor, ...rest }) => (
  <svg
    {...rest}
    className={` ${className}`}
    width="47"
    height="91"
    viewBox="0 0 47 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.5062 45.5C30.5062 36.8645 37.6624 29.8459 46.5065 29.8459L46.5065 -4.10205e-06C20.818 -1.83623e-06 -5.9724e-06 20.3675 -3.84729e-06 45.5C-1.72219e-06 70.6325 20.8181 91 46.5065 91L46.5065 61.1541C37.68 61.1541 30.5062 54.1527 30.5062 45.5Z"
      fill="#54AD47"
    />
    <mask
      id="mask0_1864_36111"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="47"
      height="91"
    >
      <path
        d="M30.3852 45.3144C30.3852 36.7141 37.5122 29.7242 46.3203 29.7242L46.3203 -5.34058e-05C20.7366 -5.79189e-05 0.00342224 20.2844 0.003418 45.3144C0.00341377 70.3445 20.7366 90.6289 46.3203 90.6289L46.3203 60.9047C37.5297 60.9047 30.3852 53.9319 30.3852 45.3144Z"
        fill="#E43625"
      />
    </mask>
    <g mask="url(#mask0_1864_36111)">
      <g opacity="0.5">
        <path d="M-31.1486 -80.1348L46.75 0.0890653" stroke="white" />
        <path d="M-31.1564 -74.7813L46.7422 5.44258" stroke="white" />
        <path d="M-31.1564 -69.4375L46.7422 10.7863" stroke="white" />
        <path d="M-31.1486 -64.0879L46.75 16.1359" stroke="white" />
        <path d="M-31.1564 -58.752L46.7422 21.4719" stroke="white" />
        <path d="M-31.1564 -53.3984L46.7422 26.8254" stroke="white" />
        <path d="M-31.1564 -48.0488L46.7422 32.175" stroke="white" />
        <path d="M-31.1486 -42.6934L46.75 37.5305" stroke="white" />
        <path d="M-31.1564 -37.3516L46.7422 42.8723" stroke="white" />
        <path d="M-31.1486 -31.9941L46.75 48.2297" stroke="white" />
        <path d="M-31.1486 -26.6543L46.75 53.5695" stroke="white" />
        <path d="M-31.1564 -21.2969L46.7422 58.927" stroke="white" />
        <path d="M-31.1564 -15.9551L46.7422 64.2688" stroke="white" />
        <path d="M-31.1642 -10.6094L46.7344 69.6145" stroke="white" />
        <path d="M-31.1486 -5.26173L46.75 74.9621" stroke="white" />
        <path d="M-31.1564 0.0878838L46.7422 80.3117" stroke="white" />
        <path d="M-31.1486 5.4414L46.75 85.6652" stroke="white" />
        <path d="M-31.1564 10.7793L46.7422 91.0031" stroke="white" />
        <path d="M-31.1564 16.1348L46.7422 96.3586" stroke="white" />
        <path d="M-31.1486 21.4883L46.75 101.712" stroke="white" />
        <path d="M-31.1564 26.834L46.7422 107.058" stroke="white" />
        <path d="M-31.1564 32.1738L46.7422 112.398" stroke="white" />
        <path d="M-31.0002 45.2324L46.8984 125.456" stroke="white" />
        <path d="M-31.1564 42.8711L46.7422 123.095" stroke="white" />
      </g>
    </g>
  </svg>
);

export const TypesOfPanSvg = ({ className, ...rest }) => (
  <svg
    width="139"
    height="63"
    viewBox="0 0 139 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <circle cx="127" cy="12" r="12" fill="#54AD47" />
    <path
      d="M48.8497 45.4569C58.121 45.4569 65.6562 53.3039 65.6562 63.0018L97.6994 63.0018C97.6994 34.8335 75.8325 12.0059 48.8497 12.0059C21.8669 12.0059 2.11531e-06 34.8335 4.7255e-06 63.0018L32.0432 63.0018C32.0432 53.3232 39.56 45.4569 48.8497 45.4569Z"
      fill="#EE7F25"
    />
    <mask
      id="mask0_2990_28390"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="11"
      width="98"
      height="52"
    >
      <path
        d="M49.049 45.3137C58.2824 45.3137 65.7869 53.1287 65.7869 62.7871L97.6995 62.7871C97.6995 34.7336 75.9217 11.999 49.049 11.999C22.1762 11.999 0.398442 34.7336 0.398438 62.787L32.311 62.7871C32.311 53.1479 39.7971 45.3137 49.049 45.3137Z"
        fill="#E43625"
      />
    </mask>
    <g mask="url(#mask0_2990_28390)">
      <g opacity="0.5">
        <path d="M183.727 -22.1626L97.5967 63.2558" stroke="white" />
        <path d="M177.984 -22.1704L91.8545 63.248" stroke="white" />
        <path d="M172.242 -22.1704L86.1123 63.248" stroke="white" />
        <path d="M166.5 -22.1626L80.3701 63.2558" stroke="white" />
        <path d="M160.766 -22.1704L74.6357 63.248" stroke="white" />
        <path d="M155.023 -22.1704L68.8935 63.248" stroke="white" />
        <path d="M149.281 -22.1704L63.1513 63.248" stroke="white" />
        <path d="M143.531 -22.1626L57.4013 63.2558" stroke="white" />
        <path d="M137.797 -22.1704L51.667 63.248" stroke="white" />
        <path d="M132.047 -22.1626L45.917 63.2558" stroke="white" />
        <path d="M126.305 -22.1626L40.1748 63.2558" stroke="white" />
        <path d="M120.563 -22.1704L34.4326 63.248" stroke="white" />
        <path d="M114.828 -22.1704L28.6982 63.248" stroke="white" />
        <path d="M109.086 -22.1704L22.956 63.248" stroke="white" />
        <path d="M103.344 -22.1626L17.2138 63.2558" stroke="white" />
        <path d="M97.6016 -22.1704L11.4717 63.248" stroke="white" />
        <path d="M91.8516 -22.1626L5.72166 63.2558" stroke="white" />
        <path d="M86.1172 -22.1704L-0.0127175 63.248" stroke="white" />
        <path d="M80.375 -22.1704L-5.7549 63.248" stroke="white" />
        <path d="M74.625 -22.1626L-11.5049 63.2558" stroke="white" />
        <path d="M68.8828 -22.1704L-17.2471 63.248" stroke="white" />
        <path d="M63.1484 -22.1704L-22.9815 63.248" stroke="white" />
        <path d="M57.4063 -22.1704L-28.7237 63.248" stroke="white" />
        <path d="M51.6641 -22.1704L-34.4658 63.248" stroke="white" />
      </g>
    </g>
  </svg>
);

export const ProcedureSectionSvg = ({ className, ...rest }) => (
  <svg
    width="171"
    height="94"
    viewBox="0 0 171 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <path
      d="M41.7785 51.3222C47.5684 57.2643 47.4566 66.7879 41.5027 72.5894L61.5137 93.1262C78.8073 76.2754 79.1661 48.6047 62.3153 31.3112C45.4645 14.0177 17.7939 13.6589 0.500329 30.5096L20.5113 51.0464C26.4534 45.2565 35.977 45.3683 41.7785 51.3222Z"
      fill="#E43625"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.168 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.84 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.215 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.176 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.848 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.223 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.168 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.848 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.223 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.176 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.84 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.223 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.168 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.84 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.223 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.168 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.168 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.84 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.848 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.223 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.215 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 170.496 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.176 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 162.176 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.848 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 153.84 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 145.52 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 137.191 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 128.871 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 120.543 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.215 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 112.215 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6367 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3086 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6836 92.7095)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6367 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3086 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6836 84.394)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 76.0798)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6289 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3086 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6836 76.0796)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6367 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3008 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6836 67.7632)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6289 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3008 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6836 59.4478)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6289 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6289 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3008 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3086 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6836 51.1333)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6758 34.5024)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 103.957 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6367 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 95.6367 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3086 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 87.3008 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 78.9805 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 70.6523 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 62.332 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 54.0039 26.187)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6758 42.8179)"
      fill="#1D1D1B"
    />
    <ellipse
      cx="0.593951"
      cy="0.594674"
      rx="0.593951"
      ry="0.594674"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 45.6758 26.187)"
      fill="#1D1D1B"
    />
    <circle cx="115.996" cy="23.501" r="13.5" fill="#6F368B" />
  </svg>
);

export const FormSectionSvg = ({ className, ...rest }) => (
  <svg
    width="272"
    height="108"
    viewBox="0 0 272 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <circle cx="12.5" cy="44" r="12" fill="#EE7F25" />
    <path
      d="M254.353 48.501C254.353 39.2963 261.824 31.8152 271.059 31.8152L271.059 0.00200653C244.237 0.00200685 222.501 21.712 222.501 48.501C222.501 75.2901 244.237 97 271.059 97L271.059 65.1869C261.843 65.1869 254.353 57.7241 254.353 48.501Z"
      fill="#54AD47"
    />
    <mask
      id="mask0_3030_28392"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="222"
      y="0"
      width="50"
      height="97"
    >
      <path
        d="M254.353 48.4991C254.353 39.2943 261.824 31.8132 271.059 31.8132L271.059 5.34058e-05C244.237 5.37256e-05 222.501 21.71 222.501 48.4991C222.501 75.2881 244.237 96.998 271.059 96.998L271.059 65.1849C261.843 65.1849 254.353 57.7221 254.353 48.4991Z"
        fill="#6F368B"
      />
    </mask>
    <g mask="url(#mask0_3030_28392)">
      <g opacity="0.5">
        <path
          d="M195.597 -81.0894L281.563 4.77229"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -75.366L281.563 10.4957"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -69.6462L281.566 16.2154"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -63.9214L281.563 21.9403"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -58.1956L281.566 27.6661"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -52.4717L281.563 33.39"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -46.7495L281.563 39.1121"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -41.0205L281.563 44.8411"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -35.3013L281.563 50.5604"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -29.5764L281.566 56.2852"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -23.854L281.566 62.0076"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -18.1252L281.566 67.7364"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 -12.4026L281.563 73.4591"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -6.68164L281.566 79.18"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 -0.954589L281.566 84.9071"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 4.76831L281.566 90.63"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 10.4941L281.563 96.3558"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 16.2117L281.566 102.073"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 21.9407L281.563 107.802"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 27.6663L281.566 113.528"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 33.3879L281.566 119.25"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 39.1118L281.566 124.973"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 44.8398L281.563 130.701"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 50.5591L281.566 136.421"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 56.2842L281.563 142.146"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 62.0112L281.563 147.873"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 67.7307L281.566 153.592"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 73.4556L281.563 159.317"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.601 79.1814L281.566 165.043"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 84.9053L281.563 170.767"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 90.6274L281.563 176.489"
          stroke="white"
          stroke-width="1.25123"
        />
        <path
          d="M195.597 96.3564L281.563 182.218"
          stroke="white"
          stroke-width="1.25123"
        />
      </g>
    </g>
    <path
      d="M100.329 85L124.5 85C124.5 105.977 107.494 123 86.5 123L86.5 98.8292C94.1311 98.8292 100.329 92.6311 100.329 85Z"
      fill="#FFCE1B"
    />
  </svg>
);

export const TinSystemFlowChart = ({ className, ...rest }) => (
  <svg width="690" height="480" viewBox="0 0 690 480" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={`${className}`}
  >
    <rect width="80" height="48" transform="translate(0.5)" fill="#EE7F25" />
    <path d="M27.3906 30H26.0625V18.5781H32.4219V19.75H27.3906V23.9375H32.1172V25.1016H27.3906V30ZM35.4297 21.4375V30H34.1328V21.4375H35.4297ZM34.7969 18.2344C35.0104 18.2344 35.1927 18.3047 35.3438 18.4453C35.5 18.5807 35.5781 18.7943 35.5781 19.0859C35.5781 19.3724 35.5 19.5859 35.3438 19.7266C35.1927 19.8672 35.0104 19.9375 34.7969 19.9375C34.5729 19.9375 34.3854 19.8672 34.2344 19.7266C34.0885 19.5859 34.0156 19.3724 34.0156 19.0859C34.0156 18.7943 34.0885 18.5807 34.2344 18.4453C34.3854 18.3047 34.5729 18.2344 34.7969 18.2344ZM39.4844 30H38.1797V17.8438H39.4844V30ZM45.5234 21.2812C46.2526 21.2812 46.8776 21.4427 47.3984 21.7656C47.9193 22.0885 48.3177 22.5417 48.5938 23.125C48.8698 23.7031 49.0078 24.3802 49.0078 25.1562V25.9609H43.0938C43.1094 26.9661 43.3594 27.7318 43.8438 28.2578C44.3281 28.7839 45.0104 29.0469 45.8906 29.0469C46.4323 29.0469 46.9115 28.9974 47.3281 28.8984C47.7448 28.7995 48.1771 28.6536 48.625 28.4609V29.6016C48.1927 29.7943 47.763 29.9349 47.3359 30.0234C46.9141 30.112 46.4141 30.1562 45.8359 30.1562C45.013 30.1562 44.2943 29.9896 43.6797 29.6562C43.0703 29.3177 42.5964 28.8229 42.2578 28.1719C41.9193 27.5208 41.75 26.724 41.75 25.7812C41.75 24.8594 41.9036 24.0625 42.2109 23.3906C42.5234 22.7135 42.9609 22.1927 43.5234 21.8281C44.0911 21.4635 44.7578 21.2812 45.5234 21.2812ZM45.5078 22.3438C44.8151 22.3438 44.263 22.5703 43.8516 23.0234C43.4401 23.4766 43.1953 24.1094 43.1172 24.9219H47.6484C47.6432 24.4115 47.5625 23.9635 47.4062 23.5781C47.2552 23.1875 47.0234 22.8854 46.7109 22.6719C46.3984 22.4531 45.9974 22.3438 45.5078 22.3438ZM55.1016 21.2812C55.2734 21.2812 55.4531 21.2917 55.6406 21.3125C55.8281 21.3281 55.9948 21.3516 56.1406 21.3828L55.9766 22.5859C55.8359 22.5495 55.6797 22.5208 55.5078 22.5C55.3359 22.4792 55.1745 22.4688 55.0234 22.4688C54.6797 22.4688 54.3542 22.5391 54.0469 22.6797C53.7448 22.8151 53.4792 23.013 53.25 23.2734C53.0208 23.5286 52.8411 23.8385 52.7109 24.2031C52.5807 24.5625 52.5156 24.9635 52.5156 25.4062V30H51.2109V21.4375H52.2891L52.4297 23.0156H52.4844C52.6615 22.6979 52.875 22.4089 53.125 22.1484C53.375 21.8828 53.6641 21.6719 53.9922 21.5156C54.3255 21.3594 54.6953 21.2812 55.1016 21.2812Z" fill="white" />
    <rect width="118" height="48" transform="translate(571.5)" fill="#EE7F25" />
    <path d="M606.133 24.1797C606.133 25.4661 605.898 26.5417 605.43 27.4062C604.961 28.2656 604.281 28.9141 603.391 29.3516C602.505 29.7839 601.43 30 600.164 30H597.062V18.5781H600.508C601.669 18.5781 602.669 18.7917 603.508 19.2188C604.346 19.6406 604.992 20.2682 605.445 21.1016C605.904 21.9297 606.133 22.9557 606.133 24.1797ZM604.734 24.2266C604.734 23.2005 604.562 22.3542 604.219 21.6875C603.88 21.0208 603.38 20.526 602.719 20.2031C602.062 19.875 601.258 19.7109 600.305 19.7109H598.391V28.8594H600.008C601.581 28.8594 602.76 28.4714 603.547 27.6953C604.339 26.9193 604.734 25.763 604.734 24.2266ZM611.773 21.2812C612.503 21.2812 613.128 21.4427 613.648 21.7656C614.169 22.0885 614.568 22.5417 614.844 23.125C615.12 23.7031 615.258 24.3802 615.258 25.1562V25.9609H609.344C609.359 26.9661 609.609 27.7318 610.094 28.2578C610.578 28.7839 611.26 29.0469 612.141 29.0469C612.682 29.0469 613.161 28.9974 613.578 28.8984C613.995 28.7995 614.427 28.6536 614.875 28.4609V29.6016C614.443 29.7943 614.013 29.9349 613.586 30.0234C613.164 30.112 612.664 30.1562 612.086 30.1562C611.263 30.1562 610.544 29.9896 609.93 29.6562C609.32 29.3177 608.846 28.8229 608.508 28.1719C608.169 27.5208 608 26.724 608 25.7812C608 24.8594 608.154 24.0625 608.461 23.3906C608.773 22.7135 609.211 22.1927 609.773 21.8281C610.341 21.4635 611.008 21.2812 611.773 21.2812ZM611.758 22.3438C611.065 22.3438 610.513 22.5703 610.102 23.0234C609.69 23.4766 609.445 24.1094 609.367 24.9219H613.898C613.893 24.4115 613.812 23.9635 613.656 23.5781C613.505 23.1875 613.273 22.8854 612.961 22.6719C612.648 22.4531 612.247 22.3438 611.758 22.3438ZM620.508 30.1562C619.424 30.1562 618.565 29.7865 617.93 29.0469C617.299 28.3073 616.984 27.2083 616.984 25.75C616.984 24.276 617.307 23.1641 617.953 22.4141C618.599 21.6589 619.458 21.2812 620.531 21.2812C620.984 21.2812 621.38 21.3411 621.719 21.4609C622.057 21.5807 622.349 21.7422 622.594 21.9453C622.839 22.1432 623.044 22.3698 623.211 22.625H623.305C623.284 22.4635 623.263 22.2422 623.242 21.9609C623.221 21.6797 623.211 21.4505 623.211 21.2734V17.8438H624.508V30H623.461L623.266 28.7812H623.211C623.049 29.0365 622.844 29.2682 622.594 29.4766C622.349 29.6849 622.055 29.8516 621.711 29.9766C621.372 30.0964 620.971 30.1562 620.508 30.1562ZM620.711 29.0781C621.628 29.0781 622.276 28.8177 622.656 28.2969C623.036 27.776 623.227 27.0026 623.227 25.9766V25.7422C623.227 24.6536 623.044 23.8177 622.68 23.2344C622.32 22.651 621.664 22.3594 620.711 22.3594C619.914 22.3594 619.318 22.6667 618.922 23.2812C618.526 23.8906 618.328 24.724 618.328 25.7812C618.328 26.8333 618.523 27.6458 618.914 28.2188C619.31 28.7917 619.909 29.0781 620.711 29.0781ZM634.328 21.4375V30H633.266L633.078 28.7969H633.008C632.831 29.0938 632.602 29.3438 632.32 29.5469C632.039 29.75 631.721 29.901 631.367 30C631.018 30.1042 630.646 30.1562 630.25 30.1562C629.573 30.1562 629.005 30.0469 628.547 29.8281C628.089 29.6094 627.742 29.2708 627.508 28.8125C627.279 28.3542 627.164 27.7656 627.164 27.0469V21.4375H628.477V26.9531C628.477 27.6667 628.638 28.2005 628.961 28.5547C629.284 28.9036 629.776 29.0781 630.438 29.0781C631.073 29.0781 631.578 28.9583 631.953 28.7188C632.333 28.4792 632.607 28.1276 632.773 27.6641C632.94 27.1953 633.023 26.6224 633.023 25.9453V21.4375H634.328ZM640.5 30.1562C639.729 30.1562 639.049 29.9974 638.461 29.6797C637.872 29.362 637.414 28.8776 637.086 28.2266C636.758 27.5755 636.594 26.7552 636.594 25.7656C636.594 24.7292 636.766 23.8828 637.109 23.2266C637.458 22.5651 637.938 22.0755 638.547 21.7578C639.156 21.4401 639.849 21.2812 640.625 21.2812C641.052 21.2812 641.464 21.3255 641.859 21.4141C642.26 21.4974 642.589 21.6042 642.844 21.7344L642.453 22.8203C642.193 22.7161 641.891 22.6224 641.547 22.5391C641.208 22.4557 640.891 22.4141 640.594 22.4141C640 22.4141 639.505 22.5417 639.109 22.7969C638.719 23.0521 638.424 23.4271 638.227 23.9219C638.034 24.4167 637.938 25.026 637.938 25.75C637.938 26.4427 638.031 27.0339 638.219 27.5234C638.411 28.013 638.695 28.388 639.07 28.6484C639.451 28.9036 639.924 29.0312 640.492 29.0312C640.945 29.0312 641.354 28.9844 641.719 28.8906C642.083 28.7917 642.414 28.6771 642.711 28.5469V29.7031C642.424 29.849 642.104 29.9609 641.75 30.0391C641.401 30.1172 640.984 30.1562 640.5 30.1562ZM647.508 29.0938C647.721 29.0938 647.94 29.0755 648.164 29.0391C648.388 29.0026 648.57 28.9583 648.711 28.9062V29.9141C648.56 29.9818 648.349 30.0391 648.078 30.0859C647.812 30.1328 647.552 30.1562 647.297 30.1562C646.844 30.1562 646.432 30.0781 646.062 29.9219C645.693 29.7604 645.396 29.4896 645.172 29.1094C644.953 28.7292 644.844 28.2031 644.844 27.5312V22.4531H643.625V21.8203L644.852 21.3125L645.367 19.4531H646.148V21.4375H648.656V22.4531H646.148V27.4922C646.148 28.0286 646.271 28.4297 646.516 28.6953C646.766 28.9609 647.096 29.0938 647.508 29.0938ZM657.828 25.7031C657.828 26.4062 657.737 27.0339 657.555 27.5859C657.372 28.138 657.109 28.6042 656.766 28.9844C656.422 29.3646 656.005 29.6562 655.516 29.8594C655.031 30.0573 654.482 30.1562 653.867 30.1562C653.294 30.1562 652.768 30.0573 652.289 29.8594C651.815 29.6562 651.404 29.3646 651.055 28.9844C650.711 28.6042 650.443 28.138 650.25 27.5859C650.062 27.0339 649.969 26.4062 649.969 25.7031C649.969 24.7656 650.128 23.9688 650.445 23.3125C650.763 22.651 651.216 22.1484 651.805 21.8047C652.398 21.4557 653.104 21.2812 653.922 21.2812C654.703 21.2812 655.385 21.4557 655.969 21.8047C656.557 22.1536 657.013 22.6589 657.336 23.3203C657.664 23.9766 657.828 24.7708 657.828 25.7031ZM651.312 25.7031C651.312 26.3906 651.404 26.987 651.586 27.4922C651.768 27.9974 652.049 28.388 652.43 28.6641C652.81 28.9401 653.299 29.0781 653.898 29.0781C654.492 29.0781 654.979 28.9401 655.359 28.6641C655.745 28.388 656.029 27.9974 656.211 27.4922C656.393 26.987 656.484 26.3906 656.484 25.7031C656.484 25.0208 656.393 24.4323 656.211 23.9375C656.029 23.4375 655.747 23.0521 655.367 22.7812C654.987 22.5104 654.495 22.375 653.891 22.375C653 22.375 652.346 22.6693 651.93 23.2578C651.518 23.8464 651.312 24.6615 651.312 25.7031ZM663.961 21.2812C664.133 21.2812 664.312 21.2917 664.5 21.3125C664.688 21.3281 664.854 21.3516 665 21.3828L664.836 22.5859C664.695 22.5495 664.539 22.5208 664.367 22.5C664.195 22.4792 664.034 22.4688 663.883 22.4688C663.539 22.4688 663.214 22.5391 662.906 22.6797C662.604 22.8151 662.339 23.013 662.109 23.2734C661.88 23.5286 661.701 23.8385 661.57 24.2031C661.44 24.5625 661.375 24.9635 661.375 25.4062V30H660.07V21.4375H661.148L661.289 23.0156H661.344C661.521 22.6979 661.734 22.4089 661.984 22.1484C662.234 21.8828 662.523 21.6719 662.852 21.5156C663.185 21.3594 663.555 21.2812 663.961 21.2812Z" fill="white" />
    <rect width="106" height="48" transform="translate(292 128)" fill="#3091D0" />
    <path d="M321.07 158H319.734V147.75H316.141V146.578H324.648V147.75H321.07V158ZM326.375 158V146.578H327.703V158H326.375ZM339.773 158H338.242L332.016 148.406H331.953C331.969 148.661 331.987 148.953 332.008 149.281C332.029 149.604 332.044 149.951 332.055 150.32C332.07 150.685 332.078 151.057 332.078 151.438V158H330.844V146.578H332.367L338.57 156.141H338.625C338.615 155.958 338.602 155.701 338.586 155.367C338.57 155.029 338.555 154.667 338.539 154.281C338.529 153.891 338.523 153.529 338.523 153.195V146.578H339.773V158ZM346.125 154.281V153.125H350V154.281H346.125ZM357.688 158H356.359V146.578H362.719V147.75H357.688V151.938H362.414V153.102H357.688V158ZM369.508 147.586C368.878 147.586 368.31 147.695 367.805 147.914C367.305 148.128 366.878 148.44 366.523 148.852C366.174 149.258 365.906 149.75 365.719 150.328C365.531 150.906 365.438 151.557 365.438 152.281C365.438 153.24 365.586 154.073 365.883 154.781C366.185 155.484 366.633 156.029 367.227 156.414C367.826 156.799 368.573 156.992 369.469 156.992C369.979 156.992 370.458 156.951 370.906 156.867C371.359 156.779 371.799 156.669 372.227 156.539V157.695C371.81 157.852 371.372 157.966 370.914 158.039C370.456 158.117 369.911 158.156 369.281 158.156C368.12 158.156 367.148 157.917 366.367 157.438C365.591 156.953 365.008 156.271 364.617 155.391C364.232 154.51 364.039 153.471 364.039 152.273C364.039 151.409 364.159 150.62 364.398 149.906C364.643 149.188 364.997 148.568 365.461 148.047C365.93 147.526 366.503 147.125 367.18 146.844C367.862 146.557 368.643 146.414 369.523 146.414C370.102 146.414 370.659 146.471 371.195 146.586C371.732 146.701 372.216 146.865 372.648 147.078L372.117 148.203C371.753 148.036 371.352 147.893 370.914 147.773C370.482 147.648 370.013 147.586 369.508 147.586Z" fill="white" />
    <rect width="190" height="48" transform="translate(250 216)" fill="#E43625" />
    <path d="M279.07 246H277.734V235.75H274.141V234.578H282.648V235.75H279.07V246ZM284.375 246V234.578H285.703V246H284.375ZM297.773 246H296.242L290.016 236.406H289.953C289.969 236.661 289.987 236.953 290.008 237.281C290.029 237.604 290.044 237.951 290.055 238.32C290.07 238.685 290.078 239.057 290.078 239.438V246H288.844V234.578H290.367L296.57 244.141H296.625C296.615 243.958 296.602 243.701 296.586 243.367C296.57 243.029 296.555 242.667 296.539 242.281C296.529 241.891 296.523 241.529 296.523 241.195V234.578H297.773V246ZM309.93 235.586C309.299 235.586 308.732 235.695 308.227 235.914C307.727 236.128 307.299 236.44 306.945 236.852C306.596 237.258 306.328 237.75 306.141 238.328C305.953 238.906 305.859 239.557 305.859 240.281C305.859 241.24 306.008 242.073 306.305 242.781C306.607 243.484 307.055 244.029 307.648 244.414C308.247 244.799 308.995 244.992 309.891 244.992C310.401 244.992 310.88 244.951 311.328 244.867C311.781 244.779 312.221 244.669 312.648 244.539V245.695C312.232 245.852 311.794 245.966 311.336 246.039C310.878 246.117 310.333 246.156 309.703 246.156C308.542 246.156 307.57 245.917 306.789 245.438C306.013 244.953 305.43 244.271 305.039 243.391C304.654 242.51 304.461 241.471 304.461 240.273C304.461 239.409 304.581 238.62 304.82 237.906C305.065 237.188 305.419 236.568 305.883 236.047C306.352 235.526 306.924 235.125 307.602 234.844C308.284 234.557 309.065 234.414 309.945 234.414C310.523 234.414 311.081 234.471 311.617 234.586C312.154 234.701 312.638 234.865 313.07 235.078L312.539 236.203C312.174 236.036 311.773 235.893 311.336 235.773C310.904 235.648 310.435 235.586 309.93 235.586ZM318.227 237.281C318.956 237.281 319.581 237.443 320.102 237.766C320.622 238.089 321.021 238.542 321.297 239.125C321.573 239.703 321.711 240.38 321.711 241.156V241.961H315.797C315.812 242.966 316.062 243.732 316.547 244.258C317.031 244.784 317.714 245.047 318.594 245.047C319.135 245.047 319.615 244.997 320.031 244.898C320.448 244.799 320.88 244.654 321.328 244.461V245.602C320.896 245.794 320.466 245.935 320.039 246.023C319.617 246.112 319.117 246.156 318.539 246.156C317.716 246.156 316.997 245.99 316.383 245.656C315.773 245.318 315.299 244.823 314.961 244.172C314.622 243.521 314.453 242.724 314.453 241.781C314.453 240.859 314.607 240.062 314.914 239.391C315.227 238.714 315.664 238.193 316.227 237.828C316.794 237.464 317.461 237.281 318.227 237.281ZM318.211 238.344C317.518 238.344 316.966 238.57 316.555 239.023C316.143 239.477 315.898 240.109 315.82 240.922H320.352C320.346 240.411 320.266 239.964 320.109 239.578C319.958 239.188 319.727 238.885 319.414 238.672C319.102 238.453 318.701 238.344 318.211 238.344ZM327.969 237.281C328.984 237.281 329.753 237.531 330.273 238.031C330.794 238.526 331.055 239.323 331.055 240.422V246H329.773V240.508C329.773 239.794 329.609 239.26 329.281 238.906C328.958 238.552 328.461 238.375 327.789 238.375C326.841 238.375 326.174 238.643 325.789 239.18C325.404 239.716 325.211 240.495 325.211 241.516V246H323.914V237.438H324.961L325.156 238.672H325.227C325.409 238.37 325.641 238.117 325.922 237.914C326.203 237.706 326.518 237.549 326.867 237.445C327.216 237.336 327.583 237.281 327.969 237.281ZM336.492 245.094C336.706 245.094 336.924 245.076 337.148 245.039C337.372 245.003 337.555 244.958 337.695 244.906V245.914C337.544 245.982 337.333 246.039 337.062 246.086C336.797 246.133 336.536 246.156 336.281 246.156C335.828 246.156 335.417 246.078 335.047 245.922C334.677 245.76 334.38 245.49 334.156 245.109C333.938 244.729 333.828 244.203 333.828 243.531V238.453H332.609V237.82L333.836 237.312L334.352 235.453H335.133V237.438H337.641V238.453H335.133V243.492C335.133 244.029 335.255 244.43 335.5 244.695C335.75 244.961 336.081 245.094 336.492 245.094ZM343.32 237.281C343.492 237.281 343.672 237.292 343.859 237.312C344.047 237.328 344.214 237.352 344.359 237.383L344.195 238.586C344.055 238.549 343.898 238.521 343.727 238.5C343.555 238.479 343.393 238.469 343.242 238.469C342.898 238.469 342.573 238.539 342.266 238.68C341.964 238.815 341.698 239.013 341.469 239.273C341.24 239.529 341.06 239.839 340.93 240.203C340.799 240.562 340.734 240.964 340.734 241.406V246H339.43V237.438H340.508L340.648 239.016H340.703C340.88 238.698 341.094 238.409 341.344 238.148C341.594 237.883 341.883 237.672 342.211 237.516C342.544 237.359 342.914 237.281 343.32 237.281ZM349.18 237.297C350.201 237.297 350.958 237.526 351.453 237.984C351.948 238.443 352.195 239.174 352.195 240.18V246H351.25L351 244.734H350.938C350.698 245.047 350.448 245.31 350.188 245.523C349.927 245.732 349.625 245.891 349.281 246C348.943 246.104 348.526 246.156 348.031 246.156C347.51 246.156 347.047 246.065 346.641 245.883C346.24 245.701 345.922 245.424 345.688 245.055C345.458 244.685 345.344 244.216 345.344 243.648C345.344 242.794 345.682 242.138 346.359 241.68C347.036 241.221 348.068 240.971 349.453 240.93L350.93 240.867V240.344C350.93 239.604 350.771 239.086 350.453 238.789C350.135 238.492 349.688 238.344 349.109 238.344C348.661 238.344 348.234 238.409 347.828 238.539C347.422 238.669 347.036 238.823 346.672 239L346.273 238.016C346.659 237.818 347.102 237.648 347.602 237.508C348.102 237.367 348.628 237.297 349.18 237.297ZM350.914 241.781L349.609 241.836C348.542 241.878 347.789 242.052 347.352 242.359C346.914 242.667 346.695 243.102 346.695 243.664C346.695 244.154 346.844 244.516 347.141 244.75C347.438 244.984 347.831 245.102 348.32 245.102C349.081 245.102 349.703 244.891 350.188 244.469C350.672 244.047 350.914 243.414 350.914 242.57V241.781ZM356.172 246H354.867V233.844H356.172V246ZM369.711 242.961C369.711 243.638 369.542 244.216 369.203 244.695C368.87 245.169 368.401 245.531 367.797 245.781C367.193 246.031 366.482 246.156 365.664 246.156C365.232 246.156 364.823 246.135 364.438 246.094C364.052 246.052 363.698 245.992 363.375 245.914C363.052 245.836 362.768 245.74 362.523 245.625V244.352C362.914 244.513 363.391 244.664 363.953 244.805C364.516 244.94 365.104 245.008 365.719 245.008C366.292 245.008 366.776 244.932 367.172 244.781C367.568 244.625 367.867 244.404 368.07 244.117C368.279 243.826 368.383 243.477 368.383 243.07C368.383 242.68 368.297 242.354 368.125 242.094C367.953 241.828 367.667 241.589 367.266 241.375C366.87 241.156 366.328 240.924 365.641 240.68C365.156 240.508 364.729 240.32 364.359 240.117C363.99 239.909 363.68 239.674 363.43 239.414C363.18 239.154 362.99 238.852 362.859 238.508C362.734 238.164 362.672 237.771 362.672 237.328C362.672 236.719 362.826 236.198 363.133 235.766C363.445 235.328 363.875 234.995 364.422 234.766C364.974 234.531 365.607 234.414 366.32 234.414C366.93 234.414 367.492 234.471 368.008 234.586C368.529 234.701 369.005 234.854 369.438 235.047L369.023 236.188C368.612 236.016 368.174 235.872 367.711 235.758C367.253 235.643 366.779 235.586 366.289 235.586C365.799 235.586 365.385 235.659 365.047 235.805C364.714 235.945 364.458 236.146 364.281 236.406C364.104 236.667 364.016 236.977 364.016 237.336C364.016 237.737 364.099 238.07 364.266 238.336C364.438 238.602 364.708 238.839 365.078 239.047C365.453 239.25 365.948 239.464 366.562 239.688C367.234 239.932 367.805 240.193 368.273 240.469C368.742 240.74 369.099 241.073 369.344 241.469C369.589 241.859 369.711 242.357 369.711 242.961ZM370.5 237.438H371.891L373.781 242.406C373.891 242.698 373.992 242.979 374.086 243.25C374.18 243.516 374.263 243.771 374.336 244.016C374.409 244.26 374.466 244.497 374.508 244.727H374.562C374.635 244.466 374.74 244.125 374.875 243.703C375.01 243.276 375.156 242.841 375.312 242.398L377.102 237.438H378.5L374.773 247.258C374.576 247.784 374.344 248.242 374.078 248.633C373.818 249.023 373.5 249.323 373.125 249.531C372.75 249.745 372.297 249.852 371.766 249.852C371.521 249.852 371.305 249.836 371.117 249.805C370.93 249.779 370.768 249.747 370.633 249.711V248.672C370.747 248.698 370.885 248.721 371.047 248.742C371.214 248.763 371.385 248.773 371.562 248.773C371.885 248.773 372.164 248.711 372.398 248.586C372.638 248.466 372.844 248.289 373.016 248.055C373.188 247.82 373.336 247.542 373.461 247.219L373.93 246.016L370.5 237.438ZM385.406 243.656C385.406 244.203 385.268 244.664 384.992 245.039C384.721 245.409 384.331 245.688 383.82 245.875C383.315 246.062 382.711 246.156 382.008 246.156C381.409 246.156 380.891 246.109 380.453 246.016C380.016 245.922 379.633 245.789 379.305 245.617V244.422C379.654 244.594 380.07 244.75 380.555 244.891C381.039 245.031 381.534 245.102 382.039 245.102C382.779 245.102 383.315 244.982 383.648 244.742C383.982 244.503 384.148 244.177 384.148 243.766C384.148 243.531 384.081 243.326 383.945 243.148C383.815 242.966 383.594 242.792 383.281 242.625C382.969 242.453 382.536 242.266 381.984 242.062C381.438 241.854 380.964 241.648 380.562 241.445C380.167 241.237 379.859 240.984 379.641 240.688C379.427 240.391 379.32 240.005 379.32 239.531C379.32 238.807 379.612 238.253 380.195 237.867C380.784 237.477 381.555 237.281 382.508 237.281C383.023 237.281 383.505 237.333 383.953 237.438C384.406 237.536 384.828 237.672 385.219 237.844L384.781 238.883C384.427 238.732 384.049 238.604 383.648 238.5C383.247 238.396 382.839 238.344 382.422 238.344C381.823 238.344 381.362 238.443 381.039 238.641C380.721 238.839 380.562 239.109 380.562 239.453C380.562 239.719 380.635 239.938 380.781 240.109C380.932 240.281 381.172 240.443 381.5 240.594C381.828 240.745 382.26 240.922 382.797 241.125C383.333 241.323 383.797 241.529 384.188 241.742C384.578 241.951 384.878 242.206 385.086 242.508C385.299 242.805 385.406 243.188 385.406 243.656ZM390.258 245.094C390.471 245.094 390.69 245.076 390.914 245.039C391.138 245.003 391.32 244.958 391.461 244.906V245.914C391.31 245.982 391.099 246.039 390.828 246.086C390.562 246.133 390.302 246.156 390.047 246.156C389.594 246.156 389.182 246.078 388.812 245.922C388.443 245.76 388.146 245.49 387.922 245.109C387.703 244.729 387.594 244.203 387.594 243.531V238.453H386.375V237.82L387.602 237.312L388.117 235.453H388.898V237.438H391.406V238.453H388.898V243.492C388.898 244.029 389.021 244.43 389.266 244.695C389.516 244.961 389.846 245.094 390.258 245.094ZM396.492 237.281C397.221 237.281 397.846 237.443 398.367 237.766C398.888 238.089 399.286 238.542 399.562 239.125C399.839 239.703 399.977 240.38 399.977 241.156V241.961H394.062C394.078 242.966 394.328 243.732 394.812 244.258C395.297 244.784 395.979 245.047 396.859 245.047C397.401 245.047 397.88 244.997 398.297 244.898C398.714 244.799 399.146 244.654 399.594 244.461V245.602C399.161 245.794 398.732 245.935 398.305 246.023C397.883 246.112 397.383 246.156 396.805 246.156C395.982 246.156 395.263 245.99 394.648 245.656C394.039 245.318 393.565 244.823 393.227 244.172C392.888 243.521 392.719 242.724 392.719 241.781C392.719 240.859 392.872 240.062 393.18 239.391C393.492 238.714 393.93 238.193 394.492 237.828C395.06 237.464 395.727 237.281 396.492 237.281ZM396.477 238.344C395.784 238.344 395.232 238.57 394.82 239.023C394.409 239.477 394.164 240.109 394.086 240.922H398.617C398.612 240.411 398.531 239.964 398.375 239.578C398.224 239.188 397.992 238.885 397.68 238.672C397.367 238.453 396.966 238.344 396.477 238.344ZM411.477 237.281C412.419 237.281 413.13 237.529 413.609 238.023C414.089 238.513 414.328 239.302 414.328 240.391V246H413.047V240.453C413.047 239.76 412.896 239.242 412.594 238.898C412.297 238.549 411.854 238.375 411.266 238.375C410.438 238.375 409.836 238.615 409.461 239.094C409.086 239.573 408.898 240.279 408.898 241.211V246H407.609V240.453C407.609 239.99 407.542 239.604 407.406 239.297C407.276 238.99 407.078 238.76 406.812 238.609C406.552 238.453 406.221 238.375 405.82 238.375C405.253 238.375 404.797 238.492 404.453 238.727C404.109 238.961 403.859 239.31 403.703 239.773C403.552 240.232 403.477 240.797 403.477 241.469V246H402.18V237.438H403.227L403.422 238.648H403.492C403.664 238.352 403.88 238.102 404.141 237.898C404.401 237.695 404.693 237.542 405.016 237.438C405.339 237.333 405.682 237.281 406.047 237.281C406.698 237.281 407.242 237.404 407.68 237.648C408.122 237.888 408.443 238.255 408.641 238.75H408.711C408.992 238.255 409.378 237.888 409.867 237.648C410.357 237.404 410.893 237.281 411.477 237.281Z" fill="white" />
    <rect width="121" height="48" transform="translate(284.5 304)" fill="#E43625" />
    <path d="M313.57 334H312.234V323.75H308.641V322.578H317.148V323.75H313.57V334ZM318.875 334V322.578H320.203V334H318.875ZM332.273 334H330.742L324.516 324.406H324.453C324.469 324.661 324.487 324.953 324.508 325.281C324.529 325.604 324.544 325.951 324.555 326.32C324.57 326.685 324.578 327.057 324.578 327.438V334H323.344V322.578H324.867L331.07 332.141H331.125C331.115 331.958 331.102 331.701 331.086 331.367C331.07 331.029 331.055 330.667 331.039 330.281C331.029 329.891 331.023 329.529 331.023 329.195V322.578H332.273V334ZM347.523 322.578L343.422 334H342.086L337.984 322.578H339.375L342.047 330.102C342.156 330.404 342.253 330.693 342.336 330.969C342.424 331.245 342.503 331.51 342.57 331.766C342.638 332.021 342.698 332.268 342.75 332.508C342.802 332.268 342.862 332.021 342.93 331.766C342.997 331.505 343.076 331.237 343.164 330.961C343.253 330.68 343.352 330.385 343.461 330.078L346.117 322.578H347.523ZM350.195 325.438V334H348.898V325.438H350.195ZM349.562 322.234C349.776 322.234 349.958 322.305 350.109 322.445C350.266 322.581 350.344 322.794 350.344 323.086C350.344 323.372 350.266 323.586 350.109 323.727C349.958 323.867 349.776 323.938 349.562 323.938C349.339 323.938 349.151 323.867 349 323.727C348.854 323.586 348.781 323.372 348.781 323.086C348.781 322.794 348.854 322.581 349 322.445C349.151 322.305 349.339 322.234 349.562 322.234ZM356.242 325.281C356.971 325.281 357.596 325.443 358.117 325.766C358.638 326.089 359.036 326.542 359.312 327.125C359.589 327.703 359.727 328.38 359.727 329.156V329.961H353.812C353.828 330.966 354.078 331.732 354.562 332.258C355.047 332.784 355.729 333.047 356.609 333.047C357.151 333.047 357.63 332.997 358.047 332.898C358.464 332.799 358.896 332.654 359.344 332.461V333.602C358.911 333.794 358.482 333.935 358.055 334.023C357.633 334.112 357.133 334.156 356.555 334.156C355.732 334.156 355.013 333.99 354.398 333.656C353.789 333.318 353.315 332.823 352.977 332.172C352.638 331.521 352.469 330.724 352.469 329.781C352.469 328.859 352.622 328.062 352.93 327.391C353.242 326.714 353.68 326.193 354.242 325.828C354.81 325.464 355.477 325.281 356.242 325.281ZM356.227 326.344C355.534 326.344 354.982 326.57 354.57 327.023C354.159 327.477 353.914 328.109 353.836 328.922H358.367C358.362 328.411 358.281 327.964 358.125 327.578C357.974 327.188 357.742 326.885 357.43 326.672C357.117 326.453 356.716 326.344 356.227 326.344ZM368.898 333.984L367.375 329C367.307 328.786 367.242 328.578 367.18 328.375C367.122 328.167 367.068 327.969 367.016 327.781C366.969 327.589 366.924 327.411 366.883 327.25C366.846 327.083 366.815 326.94 366.789 326.82H366.734C366.714 326.94 366.685 327.083 366.648 327.25C366.612 327.411 366.568 327.589 366.516 327.781C366.469 327.974 366.417 328.177 366.359 328.391C366.302 328.599 366.237 328.81 366.164 329.023L364.57 333.984H363.109L360.75 325.422H362.094L363.328 330.148C363.411 330.461 363.49 330.771 363.562 331.078C363.641 331.38 363.706 331.667 363.758 331.938C363.815 332.203 363.857 332.435 363.883 332.633H363.945C363.977 332.503 364.01 332.346 364.047 332.164C364.089 331.982 364.133 331.789 364.18 331.586C364.232 331.378 364.286 331.172 364.344 330.969C364.401 330.76 364.458 330.565 364.516 330.383L366.094 325.422H367.492L369.016 330.375C369.094 330.625 369.169 330.885 369.242 331.156C369.32 331.427 369.391 331.69 369.453 331.945C369.516 332.195 369.56 332.419 369.586 332.617H369.648C369.669 332.44 369.708 332.221 369.766 331.961C369.823 331.701 369.888 331.414 369.961 331.102C370.039 330.789 370.12 330.471 370.203 330.148L371.453 325.422H372.773L370.406 333.984H368.898ZM379.875 331.656C379.875 332.203 379.737 332.664 379.461 333.039C379.19 333.409 378.799 333.688 378.289 333.875C377.784 334.062 377.18 334.156 376.477 334.156C375.878 334.156 375.359 334.109 374.922 334.016C374.484 333.922 374.102 333.789 373.773 333.617V332.422C374.122 332.594 374.539 332.75 375.023 332.891C375.508 333.031 376.003 333.102 376.508 333.102C377.247 333.102 377.784 332.982 378.117 332.742C378.451 332.503 378.617 332.177 378.617 331.766C378.617 331.531 378.549 331.326 378.414 331.148C378.284 330.966 378.062 330.792 377.75 330.625C377.438 330.453 377.005 330.266 376.453 330.062C375.906 329.854 375.432 329.648 375.031 329.445C374.635 329.237 374.328 328.984 374.109 328.688C373.896 328.391 373.789 328.005 373.789 327.531C373.789 326.807 374.081 326.253 374.664 325.867C375.253 325.477 376.023 325.281 376.977 325.281C377.492 325.281 377.974 325.333 378.422 325.438C378.875 325.536 379.297 325.672 379.688 325.844L379.25 326.883C378.896 326.732 378.518 326.604 378.117 326.5C377.716 326.396 377.307 326.344 376.891 326.344C376.292 326.344 375.831 326.443 375.508 326.641C375.19 326.839 375.031 327.109 375.031 327.453C375.031 327.719 375.104 327.938 375.25 328.109C375.401 328.281 375.641 328.443 375.969 328.594C376.297 328.745 376.729 328.922 377.266 329.125C377.802 329.323 378.266 329.529 378.656 329.742C379.047 329.951 379.346 330.206 379.555 330.508C379.768 330.805 379.875 331.188 379.875 331.656Z" fill="white" />
    <rect width="208" height="48" transform="translate(0.5 432)" fill="#54AD47" />
    <path d="M29.1484 450.578C30.0859 450.578 30.8594 450.695 31.4688 450.93C32.0833 451.159 32.5417 451.51 32.8438 451.984C33.1458 452.458 33.2969 453.062 33.2969 453.797C33.2969 454.401 33.1875 454.906 32.9688 455.312C32.75 455.714 32.4635 456.039 32.1094 456.289C31.7552 456.539 31.3776 456.732 30.9766 456.867L34.1094 462H32.5625L29.7656 457.234H27.3906V462H26.0625V450.578H29.1484ZM29.0703 451.727H27.3906V456.109H29.2031C30.1354 456.109 30.8203 455.919 31.2578 455.539C31.7005 455.159 31.9219 454.599 31.9219 453.859C31.9219 453.083 31.6875 452.534 31.2188 452.211C30.7552 451.888 30.0391 451.727 29.0703 451.727ZM39.0391 453.281C39.7682 453.281 40.3932 453.443 40.9141 453.766C41.4349 454.089 41.8333 454.542 42.1094 455.125C42.3854 455.703 42.5234 456.38 42.5234 457.156V457.961H36.6094C36.625 458.966 36.875 459.732 37.3594 460.258C37.8438 460.784 38.526 461.047 39.4062 461.047C39.9479 461.047 40.4271 460.997 40.8438 460.898C41.2604 460.799 41.6927 460.654 42.1406 460.461V461.602C41.7083 461.794 41.2786 461.935 40.8516 462.023C40.4297 462.112 39.9297 462.156 39.3516 462.156C38.5286 462.156 37.8099 461.99 37.1953 461.656C36.5859 461.318 36.112 460.823 35.7734 460.172C35.4349 459.521 35.2656 458.724 35.2656 457.781C35.2656 456.859 35.4193 456.062 35.7266 455.391C36.0391 454.714 36.4766 454.193 37.0391 453.828C37.6068 453.464 38.2734 453.281 39.0391 453.281ZM39.0234 454.344C38.3307 454.344 37.7786 454.57 37.3672 455.023C36.9557 455.477 36.7109 456.109 36.6328 456.922H41.1641C41.1589 456.411 41.0781 455.964 40.9219 455.578C40.7708 455.188 40.5391 454.885 40.2266 454.672C39.9141 454.453 39.513 454.344 39.0234 454.344ZM46.6094 462L43.3594 453.438H44.75L46.6328 458.617C46.763 458.971 46.8958 459.362 47.0312 459.789C47.1667 460.216 47.2604 460.56 47.3125 460.82H47.3672C47.4297 460.56 47.5339 460.216 47.6797 459.789C47.8255 459.357 47.9583 458.966 48.0781 458.617L49.9609 453.438H51.3516L48.0938 462H46.6094ZM56.0234 453.281C56.7526 453.281 57.3776 453.443 57.8984 453.766C58.4193 454.089 58.8177 454.542 59.0938 455.125C59.3698 455.703 59.5078 456.38 59.5078 457.156V457.961H53.5938C53.6094 458.966 53.8594 459.732 54.3438 460.258C54.8281 460.784 55.5104 461.047 56.3906 461.047C56.9323 461.047 57.4115 460.997 57.8281 460.898C58.2448 460.799 58.6771 460.654 59.125 460.461V461.602C58.6927 461.794 58.263 461.935 57.8359 462.023C57.4141 462.112 56.9141 462.156 56.3359 462.156C55.513 462.156 54.7943 461.99 54.1797 461.656C53.5703 461.318 53.0964 460.823 52.7578 460.172C52.4193 459.521 52.25 458.724 52.25 457.781C52.25 456.859 52.4036 456.062 52.7109 455.391C53.0234 454.714 53.4609 454.193 54.0234 453.828C54.5911 453.464 55.2578 453.281 56.0234 453.281ZM56.0078 454.344C55.3151 454.344 54.763 454.57 54.3516 455.023C53.9401 455.477 53.6953 456.109 53.6172 456.922H58.1484C58.1432 456.411 58.0625 455.964 57.9062 455.578C57.7552 455.188 57.5234 454.885 57.2109 454.672C56.8984 454.453 56.4974 454.344 56.0078 454.344ZM65.7656 453.281C66.7812 453.281 67.5495 453.531 68.0703 454.031C68.5911 454.526 68.8516 455.323 68.8516 456.422V462H67.5703V456.508C67.5703 455.794 67.4062 455.26 67.0781 454.906C66.7552 454.552 66.2578 454.375 65.5859 454.375C64.638 454.375 63.9714 454.643 63.5859 455.18C63.2005 455.716 63.0078 456.495 63.0078 457.516V462H61.7109V453.438H62.7578L62.9531 454.672H63.0234C63.2057 454.37 63.4375 454.117 63.7188 453.914C64 453.706 64.3151 453.549 64.6641 453.445C65.013 453.336 65.3802 453.281 65.7656 453.281ZM78.5938 453.438V462H77.5312L77.3438 460.797H77.2734C77.0964 461.094 76.8672 461.344 76.5859 461.547C76.3047 461.75 75.987 461.901 75.6328 462C75.2839 462.104 74.9115 462.156 74.5156 462.156C73.8385 462.156 73.2708 462.047 72.8125 461.828C72.3542 461.609 72.0078 461.271 71.7734 460.812C71.5443 460.354 71.4297 459.766 71.4297 459.047V453.438H72.7422V458.953C72.7422 459.667 72.9036 460.201 73.2266 460.555C73.5495 460.904 74.0417 461.078 74.7031 461.078C75.3385 461.078 75.8438 460.958 76.2188 460.719C76.599 460.479 76.8724 460.128 77.0391 459.664C77.2057 459.195 77.2891 458.622 77.2891 457.945V453.438H78.5938ZM84.6328 453.281C85.362 453.281 85.987 453.443 86.5078 453.766C87.0286 454.089 87.4271 454.542 87.7031 455.125C87.9792 455.703 88.1172 456.38 88.1172 457.156V457.961H82.2031C82.2188 458.966 82.4688 459.732 82.9531 460.258C83.4375 460.784 84.1198 461.047 85 461.047C85.5417 461.047 86.0208 460.997 86.4375 460.898C86.8542 460.799 87.2865 460.654 87.7344 460.461V461.602C87.3021 461.794 86.8724 461.935 86.4453 462.023C86.0234 462.112 85.5234 462.156 84.9453 462.156C84.1224 462.156 83.4036 461.99 82.7891 461.656C82.1797 461.318 81.7057 460.823 81.3672 460.172C81.0286 459.521 80.8594 458.724 80.8594 457.781C80.8594 456.859 81.013 456.062 81.3203 455.391C81.6328 454.714 82.0703 454.193 82.6328 453.828C83.2005 453.464 83.8672 453.281 84.6328 453.281ZM84.6172 454.344C83.9245 454.344 83.3724 454.57 82.9609 455.023C82.5495 455.477 82.3047 456.109 82.2266 456.922H86.7578C86.7526 456.411 86.6719 455.964 86.5156 455.578C86.3646 455.188 86.1328 454.885 85.8203 454.672C85.5078 454.453 85.1068 454.344 84.6172 454.344ZM103.742 456.18C103.742 457.466 103.508 458.542 103.039 459.406C102.57 460.266 101.891 460.914 101 461.352C100.115 461.784 99.0391 462 97.7734 462H94.6719V450.578H98.1172C99.2786 450.578 100.279 450.792 101.117 451.219C101.956 451.641 102.602 452.268 103.055 453.102C103.513 453.93 103.742 454.956 103.742 456.18ZM102.344 456.227C102.344 455.201 102.172 454.354 101.828 453.688C101.49 453.021 100.99 452.526 100.328 452.203C99.6719 451.875 98.8672 451.711 97.9141 451.711H96V460.859H97.6172C99.1901 460.859 100.37 460.471 101.156 459.695C101.948 458.919 102.344 457.763 102.344 456.227ZM109.383 453.281C110.112 453.281 110.737 453.443 111.258 453.766C111.779 454.089 112.177 454.542 112.453 455.125C112.729 455.703 112.867 456.38 112.867 457.156V457.961H106.953C106.969 458.966 107.219 459.732 107.703 460.258C108.188 460.784 108.87 461.047 109.75 461.047C110.292 461.047 110.771 460.997 111.188 460.898C111.604 460.799 112.036 460.654 112.484 460.461V461.602C112.052 461.794 111.622 461.935 111.195 462.023C110.773 462.112 110.273 462.156 109.695 462.156C108.872 462.156 108.154 461.99 107.539 461.656C106.93 461.318 106.456 460.823 106.117 460.172C105.779 459.521 105.609 458.724 105.609 457.781C105.609 456.859 105.763 456.062 106.07 455.391C106.383 454.714 106.82 454.193 107.383 453.828C107.951 453.464 108.617 453.281 109.383 453.281ZM109.367 454.344C108.674 454.344 108.122 454.57 107.711 455.023C107.299 455.477 107.055 456.109 106.977 456.922H111.508C111.503 456.411 111.422 455.964 111.266 455.578C111.115 455.188 110.883 454.885 110.57 454.672C110.258 454.453 109.857 454.344 109.367 454.344ZM119.094 453.281C120.161 453.281 121.013 453.648 121.648 454.383C122.284 455.117 122.602 456.221 122.602 457.695C122.602 458.669 122.456 459.487 122.164 460.148C121.872 460.81 121.461 461.31 120.93 461.648C120.404 461.987 119.781 462.156 119.062 462.156C118.609 462.156 118.211 462.096 117.867 461.977C117.523 461.857 117.229 461.695 116.984 461.492C116.74 461.289 116.536 461.068 116.375 460.828H116.281C116.297 461.031 116.315 461.276 116.336 461.562C116.362 461.849 116.375 462.099 116.375 462.312V465.828H115.07V453.438H116.141L116.312 454.703H116.375C116.542 454.443 116.745 454.206 116.984 453.992C117.224 453.773 117.516 453.602 117.859 453.477C118.208 453.346 118.62 453.281 119.094 453.281ZM118.867 454.375C118.273 454.375 117.794 454.49 117.43 454.719C117.07 454.948 116.807 455.292 116.641 455.75C116.474 456.203 116.385 456.773 116.375 457.461V457.711C116.375 458.435 116.453 459.047 116.609 459.547C116.771 460.047 117.034 460.427 117.398 460.688C117.768 460.948 118.263 461.078 118.883 461.078C119.414 461.078 119.857 460.935 120.211 460.648C120.565 460.362 120.828 459.964 121 459.453C121.177 458.938 121.266 458.346 121.266 457.68C121.266 456.669 121.068 455.867 120.672 455.273C120.281 454.674 119.68 454.375 118.867 454.375ZM128.07 453.297C129.091 453.297 129.849 453.526 130.344 453.984C130.839 454.443 131.086 455.174 131.086 456.18V462H130.141L129.891 460.734H129.828C129.589 461.047 129.339 461.31 129.078 461.523C128.818 461.732 128.516 461.891 128.172 462C127.833 462.104 127.417 462.156 126.922 462.156C126.401 462.156 125.938 462.065 125.531 461.883C125.13 461.701 124.812 461.424 124.578 461.055C124.349 460.685 124.234 460.216 124.234 459.648C124.234 458.794 124.573 458.138 125.25 457.68C125.927 457.221 126.958 456.971 128.344 456.93L129.82 456.867V456.344C129.82 455.604 129.661 455.086 129.344 454.789C129.026 454.492 128.578 454.344 128 454.344C127.552 454.344 127.125 454.409 126.719 454.539C126.312 454.669 125.927 454.823 125.562 455L125.164 454.016C125.549 453.818 125.992 453.648 126.492 453.508C126.992 453.367 127.518 453.297 128.07 453.297ZM129.805 457.781L128.5 457.836C127.432 457.878 126.68 458.052 126.242 458.359C125.805 458.667 125.586 459.102 125.586 459.664C125.586 460.154 125.734 460.516 126.031 460.75C126.328 460.984 126.721 461.102 127.211 461.102C127.971 461.102 128.594 460.891 129.078 460.469C129.562 460.047 129.805 459.414 129.805 458.57V457.781ZM137.648 453.281C137.82 453.281 138 453.292 138.188 453.312C138.375 453.328 138.542 453.352 138.688 453.383L138.523 454.586C138.383 454.549 138.227 454.521 138.055 454.5C137.883 454.479 137.721 454.469 137.57 454.469C137.227 454.469 136.901 454.539 136.594 454.68C136.292 454.815 136.026 455.013 135.797 455.273C135.568 455.529 135.388 455.839 135.258 456.203C135.128 456.562 135.062 456.964 135.062 457.406V462H133.758V453.438H134.836L134.977 455.016H135.031C135.208 454.698 135.422 454.409 135.672 454.148C135.922 453.883 136.211 453.672 136.539 453.516C136.872 453.359 137.242 453.281 137.648 453.281ZM143.07 461.094C143.284 461.094 143.503 461.076 143.727 461.039C143.951 461.003 144.133 460.958 144.273 460.906V461.914C144.122 461.982 143.911 462.039 143.641 462.086C143.375 462.133 143.115 462.156 142.859 462.156C142.406 462.156 141.995 462.078 141.625 461.922C141.255 461.76 140.958 461.49 140.734 461.109C140.516 460.729 140.406 460.203 140.406 459.531V454.453H139.188V453.82L140.414 453.312L140.93 451.453H141.711V453.438H144.219V454.453H141.711V459.492C141.711 460.029 141.833 460.43 142.078 460.695C142.328 460.961 142.659 461.094 143.07 461.094ZM155.305 453.281C156.247 453.281 156.958 453.529 157.438 454.023C157.917 454.513 158.156 455.302 158.156 456.391V462H156.875V456.453C156.875 455.76 156.724 455.242 156.422 454.898C156.125 454.549 155.682 454.375 155.094 454.375C154.266 454.375 153.664 454.615 153.289 455.094C152.914 455.573 152.727 456.279 152.727 457.211V462H151.438V456.453C151.438 455.99 151.37 455.604 151.234 455.297C151.104 454.99 150.906 454.76 150.641 454.609C150.38 454.453 150.049 454.375 149.648 454.375C149.081 454.375 148.625 454.492 148.281 454.727C147.938 454.961 147.688 455.31 147.531 455.773C147.38 456.232 147.305 456.797 147.305 457.469V462H146.008V453.438H147.055L147.25 454.648H147.32C147.492 454.352 147.708 454.102 147.969 453.898C148.229 453.695 148.521 453.542 148.844 453.438C149.167 453.333 149.51 453.281 149.875 453.281C150.526 453.281 151.07 453.404 151.508 453.648C151.951 453.888 152.271 454.255 152.469 454.75H152.539C152.82 454.255 153.206 453.888 153.695 453.648C154.185 453.404 154.721 453.281 155.305 453.281ZM164.117 453.281C164.846 453.281 165.471 453.443 165.992 453.766C166.513 454.089 166.911 454.542 167.188 455.125C167.464 455.703 167.602 456.38 167.602 457.156V457.961H161.688C161.703 458.966 161.953 459.732 162.438 460.258C162.922 460.784 163.604 461.047 164.484 461.047C165.026 461.047 165.505 460.997 165.922 460.898C166.339 460.799 166.771 460.654 167.219 460.461V461.602C166.786 461.794 166.357 461.935 165.93 462.023C165.508 462.112 165.008 462.156 164.43 462.156C163.607 462.156 162.888 461.99 162.273 461.656C161.664 461.318 161.19 460.823 160.852 460.172C160.513 459.521 160.344 458.724 160.344 457.781C160.344 456.859 160.497 456.062 160.805 455.391C161.117 454.714 161.555 454.193 162.117 453.828C162.685 453.464 163.352 453.281 164.117 453.281ZM164.102 454.344C163.409 454.344 162.857 454.57 162.445 455.023C162.034 455.477 161.789 456.109 161.711 456.922H166.242C166.237 456.411 166.156 455.964 166 455.578C165.849 455.188 165.617 454.885 165.305 454.672C164.992 454.453 164.591 454.344 164.102 454.344ZM173.859 453.281C174.875 453.281 175.643 453.531 176.164 454.031C176.685 454.526 176.945 455.323 176.945 456.422V462H175.664V456.508C175.664 455.794 175.5 455.26 175.172 454.906C174.849 454.552 174.352 454.375 173.68 454.375C172.732 454.375 172.065 454.643 171.68 455.18C171.294 455.716 171.102 456.495 171.102 457.516V462H169.805V453.438H170.852L171.047 454.672H171.117C171.299 454.37 171.531 454.117 171.812 453.914C172.094 453.706 172.409 453.549 172.758 453.445C173.107 453.336 173.474 453.281 173.859 453.281ZM182.383 461.094C182.596 461.094 182.815 461.076 183.039 461.039C183.263 461.003 183.445 460.958 183.586 460.906V461.914C183.435 461.982 183.224 462.039 182.953 462.086C182.688 462.133 182.427 462.156 182.172 462.156C181.719 462.156 181.307 462.078 180.938 461.922C180.568 461.76 180.271 461.49 180.047 461.109C179.828 460.729 179.719 460.203 179.719 459.531V454.453H178.5V453.82L179.727 453.312L180.242 451.453H181.023V453.438H183.531V454.453H181.023V459.492C181.023 460.029 181.146 460.43 181.391 460.695C181.641 460.961 181.971 461.094 182.383 461.094Z" fill="white" />
    <rect width="233" height="48" transform="translate(248.5 432)" fill="#54AD47" />
    <path d="M277.148 450.578C278.086 450.578 278.859 450.695 279.469 450.93C280.083 451.159 280.542 451.51 280.844 451.984C281.146 452.458 281.297 453.062 281.297 453.797C281.297 454.401 281.188 454.906 280.969 455.312C280.75 455.714 280.464 456.039 280.109 456.289C279.755 456.539 279.378 456.732 278.977 456.867L282.109 462H280.562L277.766 457.234H275.391V462H274.062V450.578H277.148ZM277.07 451.727H275.391V456.109H277.203C278.135 456.109 278.82 455.919 279.258 455.539C279.701 455.159 279.922 454.599 279.922 453.859C279.922 453.083 279.688 452.534 279.219 452.211C278.755 451.888 278.039 451.727 277.07 451.727ZM287.039 453.281C287.768 453.281 288.393 453.443 288.914 453.766C289.435 454.089 289.833 454.542 290.109 455.125C290.385 455.703 290.523 456.38 290.523 457.156V457.961H284.609C284.625 458.966 284.875 459.732 285.359 460.258C285.844 460.784 286.526 461.047 287.406 461.047C287.948 461.047 288.427 460.997 288.844 460.898C289.26 460.799 289.693 460.654 290.141 460.461V461.602C289.708 461.794 289.279 461.935 288.852 462.023C288.43 462.112 287.93 462.156 287.352 462.156C286.529 462.156 285.81 461.99 285.195 461.656C284.586 461.318 284.112 460.823 283.773 460.172C283.435 459.521 283.266 458.724 283.266 457.781C283.266 456.859 283.419 456.062 283.727 455.391C284.039 454.714 284.477 454.193 285.039 453.828C285.607 453.464 286.273 453.281 287.039 453.281ZM287.023 454.344C286.331 454.344 285.779 454.57 285.367 455.023C284.956 455.477 284.711 456.109 284.633 456.922H289.164C289.159 456.411 289.078 455.964 288.922 455.578C288.771 455.188 288.539 454.885 288.227 454.672C287.914 454.453 287.513 454.344 287.023 454.344ZM295.492 461.094C295.706 461.094 295.924 461.076 296.148 461.039C296.372 461.003 296.555 460.958 296.695 460.906V461.914C296.544 461.982 296.333 462.039 296.062 462.086C295.797 462.133 295.536 462.156 295.281 462.156C294.828 462.156 294.417 462.078 294.047 461.922C293.677 461.76 293.38 461.49 293.156 461.109C292.938 460.729 292.828 460.203 292.828 459.531V454.453H291.609V453.82L292.836 453.312L293.352 451.453H294.133V453.438H296.641V454.453H294.133V459.492C294.133 460.029 294.255 460.43 294.5 460.695C294.75 460.961 295.081 461.094 295.492 461.094ZM305.5 453.438V462H304.438L304.25 460.797H304.18C304.003 461.094 303.773 461.344 303.492 461.547C303.211 461.75 302.893 461.901 302.539 462C302.19 462.104 301.818 462.156 301.422 462.156C300.745 462.156 300.177 462.047 299.719 461.828C299.26 461.609 298.914 461.271 298.68 460.812C298.451 460.354 298.336 459.766 298.336 459.047V453.438H299.648V458.953C299.648 459.667 299.81 460.201 300.133 460.555C300.456 460.904 300.948 461.078 301.609 461.078C302.245 461.078 302.75 460.958 303.125 460.719C303.505 460.479 303.779 460.128 303.945 459.664C304.112 459.195 304.195 458.622 304.195 457.945V453.438H305.5ZM312.133 453.281C312.305 453.281 312.484 453.292 312.672 453.312C312.859 453.328 313.026 453.352 313.172 453.383L313.008 454.586C312.867 454.549 312.711 454.521 312.539 454.5C312.367 454.479 312.206 454.469 312.055 454.469C311.711 454.469 311.385 454.539 311.078 454.68C310.776 454.815 310.51 455.013 310.281 455.273C310.052 455.529 309.872 455.839 309.742 456.203C309.612 456.562 309.547 456.964 309.547 457.406V462H308.242V453.438H309.32L309.461 455.016H309.516C309.693 454.698 309.906 454.409 310.156 454.148C310.406 453.883 310.695 453.672 311.023 453.516C311.357 453.359 311.727 453.281 312.133 453.281ZM318.844 453.281C319.859 453.281 320.628 453.531 321.148 454.031C321.669 454.526 321.93 455.323 321.93 456.422V462H320.648V456.508C320.648 455.794 320.484 455.26 320.156 454.906C319.833 454.552 319.336 454.375 318.664 454.375C317.716 454.375 317.049 454.643 316.664 455.18C316.279 455.716 316.086 456.495 316.086 457.516V462H314.789V453.438H315.836L316.031 454.672H316.102C316.284 454.37 316.516 454.117 316.797 453.914C317.078 453.706 317.393 453.549 317.742 453.445C318.091 453.336 318.458 453.281 318.844 453.281ZM328.93 450.578L324.68 462H323.398L327.656 450.578H328.93ZM337.117 458.961C337.117 459.638 336.948 460.216 336.609 460.695C336.276 461.169 335.807 461.531 335.203 461.781C334.599 462.031 333.888 462.156 333.07 462.156C332.638 462.156 332.229 462.135 331.844 462.094C331.458 462.052 331.104 461.992 330.781 461.914C330.458 461.836 330.174 461.74 329.93 461.625V460.352C330.32 460.513 330.797 460.664 331.359 460.805C331.922 460.94 332.51 461.008 333.125 461.008C333.698 461.008 334.182 460.932 334.578 460.781C334.974 460.625 335.273 460.404 335.477 460.117C335.685 459.826 335.789 459.477 335.789 459.07C335.789 458.68 335.703 458.354 335.531 458.094C335.359 457.828 335.073 457.589 334.672 457.375C334.276 457.156 333.734 456.924 333.047 456.68C332.562 456.508 332.135 456.32 331.766 456.117C331.396 455.909 331.086 455.674 330.836 455.414C330.586 455.154 330.396 454.852 330.266 454.508C330.141 454.164 330.078 453.771 330.078 453.328C330.078 452.719 330.232 452.198 330.539 451.766C330.852 451.328 331.281 450.995 331.828 450.766C332.38 450.531 333.013 450.414 333.727 450.414C334.336 450.414 334.898 450.471 335.414 450.586C335.935 450.701 336.411 450.854 336.844 451.047L336.43 452.188C336.018 452.016 335.581 451.872 335.117 451.758C334.659 451.643 334.185 451.586 333.695 451.586C333.206 451.586 332.792 451.659 332.453 451.805C332.12 451.945 331.865 452.146 331.688 452.406C331.51 452.667 331.422 452.977 331.422 453.336C331.422 453.737 331.505 454.07 331.672 454.336C331.844 454.602 332.115 454.839 332.484 455.047C332.859 455.25 333.354 455.464 333.969 455.688C334.641 455.932 335.211 456.193 335.68 456.469C336.148 456.74 336.505 457.073 336.75 457.469C336.995 457.859 337.117 458.357 337.117 458.961ZM342.023 461.094C342.237 461.094 342.456 461.076 342.68 461.039C342.904 461.003 343.086 460.958 343.227 460.906V461.914C343.076 461.982 342.865 462.039 342.594 462.086C342.328 462.133 342.068 462.156 341.812 462.156C341.359 462.156 340.948 462.078 340.578 461.922C340.208 461.76 339.911 461.49 339.688 461.109C339.469 460.729 339.359 460.203 339.359 459.531V454.453H338.141V453.82L339.367 453.312L339.883 451.453H340.664V453.438H343.172V454.453H340.664V459.492C340.664 460.029 340.786 460.43 341.031 460.695C341.281 460.961 341.612 461.094 342.023 461.094ZM348.164 453.297C349.185 453.297 349.943 453.526 350.438 453.984C350.932 454.443 351.18 455.174 351.18 456.18V462H350.234L349.984 460.734H349.922C349.682 461.047 349.432 461.31 349.172 461.523C348.911 461.732 348.609 461.891 348.266 462C347.927 462.104 347.51 462.156 347.016 462.156C346.495 462.156 346.031 462.065 345.625 461.883C345.224 461.701 344.906 461.424 344.672 461.055C344.443 460.685 344.328 460.216 344.328 459.648C344.328 458.794 344.667 458.138 345.344 457.68C346.021 457.221 347.052 456.971 348.438 456.93L349.914 456.867V456.344C349.914 455.604 349.755 455.086 349.438 454.789C349.12 454.492 348.672 454.344 348.094 454.344C347.646 454.344 347.219 454.409 346.812 454.539C346.406 454.669 346.021 454.823 345.656 455L345.258 454.016C345.643 453.818 346.086 453.648 346.586 453.508C347.086 453.367 347.612 453.297 348.164 453.297ZM349.898 457.781L348.594 457.836C347.526 457.878 346.773 458.052 346.336 458.359C345.898 458.667 345.68 459.102 345.68 459.664C345.68 460.154 345.828 460.516 346.125 460.75C346.422 460.984 346.815 461.102 347.305 461.102C348.065 461.102 348.688 460.891 349.172 460.469C349.656 460.047 349.898 459.414 349.898 458.57V457.781ZM356.617 461.094C356.831 461.094 357.049 461.076 357.273 461.039C357.497 461.003 357.68 460.958 357.82 460.906V461.914C357.669 461.982 357.458 462.039 357.188 462.086C356.922 462.133 356.661 462.156 356.406 462.156C355.953 462.156 355.542 462.078 355.172 461.922C354.802 461.76 354.505 461.49 354.281 461.109C354.062 460.729 353.953 460.203 353.953 459.531V454.453H352.734V453.82L353.961 453.312L354.477 451.453H355.258V453.438H357.766V454.453H355.258V459.492C355.258 460.029 355.38 460.43 355.625 460.695C355.875 460.961 356.206 461.094 356.617 461.094ZM362.852 453.281C363.581 453.281 364.206 453.443 364.727 453.766C365.247 454.089 365.646 454.542 365.922 455.125C366.198 455.703 366.336 456.38 366.336 457.156V457.961H360.422C360.438 458.966 360.688 459.732 361.172 460.258C361.656 460.784 362.339 461.047 363.219 461.047C363.76 461.047 364.24 460.997 364.656 460.898C365.073 460.799 365.505 460.654 365.953 460.461V461.602C365.521 461.794 365.091 461.935 364.664 462.023C364.242 462.112 363.742 462.156 363.164 462.156C362.341 462.156 361.622 461.99 361.008 461.656C360.398 461.318 359.924 460.823 359.586 460.172C359.247 459.521 359.078 458.724 359.078 457.781C359.078 456.859 359.232 456.062 359.539 455.391C359.852 454.714 360.289 454.193 360.852 453.828C361.419 453.464 362.086 453.281 362.852 453.281ZM362.836 454.344C362.143 454.344 361.591 454.57 361.18 455.023C360.768 455.477 360.523 456.109 360.445 456.922H364.977C364.971 456.411 364.891 455.964 364.734 455.578C364.583 455.188 364.352 454.885 364.039 454.672C363.727 454.453 363.326 454.344 362.836 454.344ZM377.836 453.281C378.779 453.281 379.49 453.529 379.969 454.023C380.448 454.513 380.688 455.302 380.688 456.391V462H379.406V456.453C379.406 455.76 379.255 455.242 378.953 454.898C378.656 454.549 378.214 454.375 377.625 454.375C376.797 454.375 376.195 454.615 375.82 455.094C375.445 455.573 375.258 456.279 375.258 457.211V462H373.969V456.453C373.969 455.99 373.901 455.604 373.766 455.297C373.635 454.99 373.438 454.76 373.172 454.609C372.911 454.453 372.581 454.375 372.18 454.375C371.612 454.375 371.156 454.492 370.812 454.727C370.469 454.961 370.219 455.31 370.062 455.773C369.911 456.232 369.836 456.797 369.836 457.469V462H368.539V453.438H369.586L369.781 454.648H369.852C370.023 454.352 370.24 454.102 370.5 453.898C370.76 453.695 371.052 453.542 371.375 453.438C371.698 453.333 372.042 453.281 372.406 453.281C373.057 453.281 373.602 453.404 374.039 453.648C374.482 453.888 374.802 454.255 375 454.75H375.07C375.352 454.255 375.737 453.888 376.227 453.648C376.716 453.404 377.253 453.281 377.836 453.281ZM386.648 453.281C387.378 453.281 388.003 453.443 388.523 453.766C389.044 454.089 389.443 454.542 389.719 455.125C389.995 455.703 390.133 456.38 390.133 457.156V457.961H384.219C384.234 458.966 384.484 459.732 384.969 460.258C385.453 460.784 386.135 461.047 387.016 461.047C387.557 461.047 388.036 460.997 388.453 460.898C388.87 460.799 389.302 460.654 389.75 460.461V461.602C389.318 461.794 388.888 461.935 388.461 462.023C388.039 462.112 387.539 462.156 386.961 462.156C386.138 462.156 385.419 461.99 384.805 461.656C384.195 461.318 383.721 460.823 383.383 460.172C383.044 459.521 382.875 458.724 382.875 457.781C382.875 456.859 383.029 456.062 383.336 455.391C383.648 454.714 384.086 454.193 384.648 453.828C385.216 453.464 385.883 453.281 386.648 453.281ZM386.633 454.344C385.94 454.344 385.388 454.57 384.977 455.023C384.565 455.477 384.32 456.109 384.242 456.922H388.773C388.768 456.411 388.688 455.964 388.531 455.578C388.38 455.188 388.148 454.885 387.836 454.672C387.523 454.453 387.122 454.344 386.633 454.344ZM396.391 453.281C397.406 453.281 398.174 453.531 398.695 454.031C399.216 454.526 399.477 455.323 399.477 456.422V462H398.195V456.508C398.195 455.794 398.031 455.26 397.703 454.906C397.38 454.552 396.883 454.375 396.211 454.375C395.263 454.375 394.596 454.643 394.211 455.18C393.826 455.716 393.633 456.495 393.633 457.516V462H392.336V453.438H393.383L393.578 454.672H393.648C393.831 454.37 394.062 454.117 394.344 453.914C394.625 453.706 394.94 453.549 395.289 453.445C395.638 453.336 396.005 453.281 396.391 453.281ZM404.914 461.094C405.128 461.094 405.346 461.076 405.57 461.039C405.794 461.003 405.977 460.958 406.117 460.906V461.914C405.966 461.982 405.755 462.039 405.484 462.086C405.219 462.133 404.958 462.156 404.703 462.156C404.25 462.156 403.839 462.078 403.469 461.922C403.099 461.76 402.802 461.49 402.578 461.109C402.359 460.729 402.25 460.203 402.25 459.531V454.453H401.031V453.82L402.258 453.312L402.773 451.453H403.555V453.438H406.062V454.453H403.555V459.492C403.555 460.029 403.677 460.43 403.922 460.695C404.172 460.961 404.503 461.094 404.914 461.094ZM418.648 458.961C418.648 459.638 418.479 460.216 418.141 460.695C417.807 461.169 417.339 461.531 416.734 461.781C416.13 462.031 415.419 462.156 414.602 462.156C414.169 462.156 413.76 462.135 413.375 462.094C412.99 462.052 412.635 461.992 412.312 461.914C411.99 461.836 411.706 461.74 411.461 461.625V460.352C411.852 460.513 412.328 460.664 412.891 460.805C413.453 460.94 414.042 461.008 414.656 461.008C415.229 461.008 415.714 460.932 416.109 460.781C416.505 460.625 416.805 460.404 417.008 460.117C417.216 459.826 417.32 459.477 417.32 459.07C417.32 458.68 417.234 458.354 417.062 458.094C416.891 457.828 416.604 457.589 416.203 457.375C415.807 457.156 415.266 456.924 414.578 456.68C414.094 456.508 413.667 456.32 413.297 456.117C412.927 455.909 412.617 455.674 412.367 455.414C412.117 455.154 411.927 454.852 411.797 454.508C411.672 454.164 411.609 453.771 411.609 453.328C411.609 452.719 411.763 452.198 412.07 451.766C412.383 451.328 412.812 450.995 413.359 450.766C413.911 450.531 414.544 450.414 415.258 450.414C415.867 450.414 416.43 450.471 416.945 450.586C417.466 450.701 417.943 450.854 418.375 451.047L417.961 452.188C417.549 452.016 417.112 451.872 416.648 451.758C416.19 451.643 415.716 451.586 415.227 451.586C414.737 451.586 414.323 451.659 413.984 451.805C413.651 451.945 413.396 452.146 413.219 452.406C413.042 452.667 412.953 452.977 412.953 453.336C412.953 453.737 413.036 454.07 413.203 454.336C413.375 454.602 413.646 454.839 414.016 455.047C414.391 455.25 414.885 455.464 415.5 455.688C416.172 455.932 416.742 456.193 417.211 456.469C417.68 456.74 418.036 457.073 418.281 457.469C418.526 457.859 418.648 458.357 418.648 458.961ZM423.555 461.094C423.768 461.094 423.987 461.076 424.211 461.039C424.435 461.003 424.617 460.958 424.758 460.906V461.914C424.607 461.982 424.396 462.039 424.125 462.086C423.859 462.133 423.599 462.156 423.344 462.156C422.891 462.156 422.479 462.078 422.109 461.922C421.74 461.76 421.443 461.49 421.219 461.109C421 460.729 420.891 460.203 420.891 459.531V454.453H419.672V453.82L420.898 453.312L421.414 451.453H422.195V453.438H424.703V454.453H422.195V459.492C422.195 460.029 422.318 460.43 422.562 460.695C422.812 460.961 423.143 461.094 423.555 461.094ZM429.695 453.297C430.716 453.297 431.474 453.526 431.969 453.984C432.464 454.443 432.711 455.174 432.711 456.18V462H431.766L431.516 460.734H431.453C431.214 461.047 430.964 461.31 430.703 461.523C430.443 461.732 430.141 461.891 429.797 462C429.458 462.104 429.042 462.156 428.547 462.156C428.026 462.156 427.562 462.065 427.156 461.883C426.755 461.701 426.438 461.424 426.203 461.055C425.974 460.685 425.859 460.216 425.859 459.648C425.859 458.794 426.198 458.138 426.875 457.68C427.552 457.221 428.583 456.971 429.969 456.93L431.445 456.867V456.344C431.445 455.604 431.286 455.086 430.969 454.789C430.651 454.492 430.203 454.344 429.625 454.344C429.177 454.344 428.75 454.409 428.344 454.539C427.938 454.669 427.552 454.823 427.188 455L426.789 454.016C427.174 453.818 427.617 453.648 428.117 453.508C428.617 453.367 429.143 453.297 429.695 453.297ZM431.43 457.781L430.125 457.836C429.057 457.878 428.305 458.052 427.867 458.359C427.43 458.667 427.211 459.102 427.211 459.664C427.211 460.154 427.359 460.516 427.656 460.75C427.953 460.984 428.346 461.102 428.836 461.102C429.596 461.102 430.219 460.891 430.703 460.469C431.188 460.047 431.43 459.414 431.43 458.57V457.781ZM438.148 461.094C438.362 461.094 438.581 461.076 438.805 461.039C439.029 461.003 439.211 460.958 439.352 460.906V461.914C439.201 461.982 438.99 462.039 438.719 462.086C438.453 462.133 438.193 462.156 437.938 462.156C437.484 462.156 437.073 462.078 436.703 461.922C436.333 461.76 436.036 461.49 435.812 461.109C435.594 460.729 435.484 460.203 435.484 459.531V454.453H434.266V453.82L435.492 453.312L436.008 451.453H436.789V453.438H439.297V454.453H436.789V459.492C436.789 460.029 436.911 460.43 437.156 460.695C437.406 460.961 437.737 461.094 438.148 461.094ZM448.156 453.438V462H447.094L446.906 460.797H446.836C446.659 461.094 446.43 461.344 446.148 461.547C445.867 461.75 445.549 461.901 445.195 462C444.846 462.104 444.474 462.156 444.078 462.156C443.401 462.156 442.833 462.047 442.375 461.828C441.917 461.609 441.57 461.271 441.336 460.812C441.107 460.354 440.992 459.766 440.992 459.047V453.438H442.305V458.953C442.305 459.667 442.466 460.201 442.789 460.555C443.112 460.904 443.604 461.078 444.266 461.078C444.901 461.078 445.406 460.958 445.781 460.719C446.161 460.479 446.435 460.128 446.602 459.664C446.768 459.195 446.852 458.622 446.852 457.945V453.438H448.156ZM456.438 459.656C456.438 460.203 456.299 460.664 456.023 461.039C455.753 461.409 455.362 461.688 454.852 461.875C454.346 462.062 453.742 462.156 453.039 462.156C452.44 462.156 451.922 462.109 451.484 462.016C451.047 461.922 450.664 461.789 450.336 461.617V460.422C450.685 460.594 451.102 460.75 451.586 460.891C452.07 461.031 452.565 461.102 453.07 461.102C453.81 461.102 454.346 460.982 454.68 460.742C455.013 460.503 455.18 460.177 455.18 459.766C455.18 459.531 455.112 459.326 454.977 459.148C454.846 458.966 454.625 458.792 454.312 458.625C454 458.453 453.568 458.266 453.016 458.062C452.469 457.854 451.995 457.648 451.594 457.445C451.198 457.237 450.891 456.984 450.672 456.688C450.458 456.391 450.352 456.005 450.352 455.531C450.352 454.807 450.643 454.253 451.227 453.867C451.815 453.477 452.586 453.281 453.539 453.281C454.055 453.281 454.536 453.333 454.984 453.438C455.438 453.536 455.859 453.672 456.25 453.844L455.812 454.883C455.458 454.732 455.081 454.604 454.68 454.5C454.279 454.396 453.87 454.344 453.453 454.344C452.854 454.344 452.393 454.443 452.07 454.641C451.753 454.839 451.594 455.109 451.594 455.453C451.594 455.719 451.667 455.938 451.812 456.109C451.964 456.281 452.203 456.443 452.531 456.594C452.859 456.745 453.292 456.922 453.828 457.125C454.365 457.323 454.828 457.529 455.219 457.742C455.609 457.951 455.909 458.206 456.117 458.508C456.331 458.805 456.438 459.188 456.438 459.656Z" fill="white" />
    <rect width="168" height="48" transform="translate(521.5 432)" fill="#54AD47" />
    <path d="M550.57 462H549.234V451.75H545.641V450.578H554.148V451.75H550.57V462ZM558.883 453.297C559.904 453.297 560.661 453.526 561.156 453.984C561.651 454.443 561.898 455.174 561.898 456.18V462H560.953L560.703 460.734H560.641C560.401 461.047 560.151 461.31 559.891 461.523C559.63 461.732 559.328 461.891 558.984 462C558.646 462.104 558.229 462.156 557.734 462.156C557.214 462.156 556.75 462.065 556.344 461.883C555.943 461.701 555.625 461.424 555.391 461.055C555.161 460.685 555.047 460.216 555.047 459.648C555.047 458.794 555.385 458.138 556.062 457.68C556.74 457.221 557.771 456.971 559.156 456.93L560.633 456.867V456.344C560.633 455.604 560.474 455.086 560.156 454.789C559.839 454.492 559.391 454.344 558.812 454.344C558.365 454.344 557.938 454.409 557.531 454.539C557.125 454.669 556.74 454.823 556.375 455L555.977 454.016C556.362 453.818 556.805 453.648 557.305 453.508C557.805 453.367 558.331 453.297 558.883 453.297ZM560.617 457.781L559.312 457.836C558.245 457.878 557.492 458.052 557.055 458.359C556.617 458.667 556.398 459.102 556.398 459.664C556.398 460.154 556.547 460.516 556.844 460.75C557.141 460.984 557.534 461.102 558.023 461.102C558.784 461.102 559.406 460.891 559.891 460.469C560.375 460.047 560.617 459.414 560.617 458.57V457.781ZM566.609 457.617L563.648 453.438H565.133L567.391 456.734L569.641 453.438H571.109L568.148 457.617L571.273 462H569.789L567.391 458.508L564.977 462H563.508L566.609 457.617ZM580.281 450.578C581.755 450.578 582.831 450.867 583.508 451.445C584.19 452.018 584.531 452.841 584.531 453.914C584.531 454.398 584.451 454.859 584.289 455.297C584.133 455.729 583.878 456.112 583.523 456.445C583.169 456.773 582.703 457.034 582.125 457.227C581.552 457.414 580.849 457.508 580.016 457.508H578.625V462H577.297V450.578H580.281ZM580.156 451.711H578.625V456.367H579.867C580.596 456.367 581.203 456.289 581.688 456.133C582.177 455.977 582.544 455.724 582.789 455.375C583.034 455.021 583.156 454.552 583.156 453.969C583.156 453.208 582.914 452.643 582.43 452.273C581.945 451.898 581.188 451.711 580.156 451.711ZM589.93 453.297C590.951 453.297 591.708 453.526 592.203 453.984C592.698 454.443 592.945 455.174 592.945 456.18V462H592L591.75 460.734H591.688C591.448 461.047 591.198 461.31 590.938 461.523C590.677 461.732 590.375 461.891 590.031 462C589.693 462.104 589.276 462.156 588.781 462.156C588.26 462.156 587.797 462.065 587.391 461.883C586.99 461.701 586.672 461.424 586.438 461.055C586.208 460.685 586.094 460.216 586.094 459.648C586.094 458.794 586.432 458.138 587.109 457.68C587.786 457.221 588.818 456.971 590.203 456.93L591.68 456.867V456.344C591.68 455.604 591.521 455.086 591.203 454.789C590.885 454.492 590.438 454.344 589.859 454.344C589.411 454.344 588.984 454.409 588.578 454.539C588.172 454.669 587.786 454.823 587.422 455L587.023 454.016C587.409 453.818 587.852 453.648 588.352 453.508C588.852 453.367 589.378 453.297 589.93 453.297ZM591.664 457.781L590.359 457.836C589.292 457.878 588.539 458.052 588.102 458.359C587.664 458.667 587.445 459.102 587.445 459.664C587.445 460.154 587.594 460.516 587.891 460.75C588.188 460.984 588.581 461.102 589.07 461.102C589.831 461.102 590.453 460.891 590.938 460.469C591.422 460.047 591.664 459.414 591.664 458.57V457.781ZM594.266 453.438H595.656L597.547 458.406C597.656 458.698 597.758 458.979 597.852 459.25C597.945 459.516 598.029 459.771 598.102 460.016C598.174 460.26 598.232 460.497 598.273 460.727H598.328C598.401 460.466 598.505 460.125 598.641 459.703C598.776 459.276 598.922 458.841 599.078 458.398L600.867 453.438H602.266L598.539 463.258C598.341 463.784 598.109 464.242 597.844 464.633C597.583 465.023 597.266 465.323 596.891 465.531C596.516 465.745 596.062 465.852 595.531 465.852C595.286 465.852 595.07 465.836 594.883 465.805C594.695 465.779 594.534 465.747 594.398 465.711V464.672C594.513 464.698 594.651 464.721 594.812 464.742C594.979 464.763 595.151 464.773 595.328 464.773C595.651 464.773 595.93 464.711 596.164 464.586C596.404 464.466 596.609 464.289 596.781 464.055C596.953 463.82 597.102 463.542 597.227 463.219L597.695 462.016L594.266 453.438ZM606.93 453.281C607.659 453.281 608.284 453.443 608.805 453.766C609.326 454.089 609.724 454.542 610 455.125C610.276 455.703 610.414 456.38 610.414 457.156V457.961H604.5C604.516 458.966 604.766 459.732 605.25 460.258C605.734 460.784 606.417 461.047 607.297 461.047C607.839 461.047 608.318 460.997 608.734 460.898C609.151 460.799 609.583 460.654 610.031 460.461V461.602C609.599 461.794 609.169 461.935 608.742 462.023C608.32 462.112 607.82 462.156 607.242 462.156C606.419 462.156 605.701 461.99 605.086 461.656C604.477 461.318 604.003 460.823 603.664 460.172C603.326 459.521 603.156 458.724 603.156 457.781C603.156 456.859 603.31 456.062 603.617 455.391C603.93 454.714 604.367 454.193 604.93 453.828C605.497 453.464 606.164 453.281 606.93 453.281ZM606.914 454.344C606.221 454.344 605.669 454.57 605.258 455.023C604.846 455.477 604.602 456.109 604.523 456.922H609.055C609.049 456.411 608.969 455.964 608.812 455.578C608.661 455.188 608.43 454.885 608.117 454.672C607.805 454.453 607.404 454.344 606.914 454.344ZM616.508 453.281C616.68 453.281 616.859 453.292 617.047 453.312C617.234 453.328 617.401 453.352 617.547 453.383L617.383 454.586C617.242 454.549 617.086 454.521 616.914 454.5C616.742 454.479 616.581 454.469 616.43 454.469C616.086 454.469 615.76 454.539 615.453 454.68C615.151 454.815 614.885 455.013 614.656 455.273C614.427 455.529 614.247 455.839 614.117 456.203C613.987 456.562 613.922 456.964 613.922 457.406V462H612.617V453.438H613.695L613.836 455.016H613.891C614.068 454.698 614.281 454.409 614.531 454.148C614.781 453.883 615.07 453.672 615.398 453.516C615.732 453.359 616.102 453.281 616.508 453.281ZM624.703 459.656C624.703 460.203 624.565 460.664 624.289 461.039C624.018 461.409 623.628 461.688 623.117 461.875C622.612 462.062 622.008 462.156 621.305 462.156C620.706 462.156 620.188 462.109 619.75 462.016C619.312 461.922 618.93 461.789 618.602 461.617V460.422C618.951 460.594 619.367 460.75 619.852 460.891C620.336 461.031 620.831 461.102 621.336 461.102C622.076 461.102 622.612 460.982 622.945 460.742C623.279 460.503 623.445 460.177 623.445 459.766C623.445 459.531 623.378 459.326 623.242 459.148C623.112 458.966 622.891 458.792 622.578 458.625C622.266 458.453 621.833 458.266 621.281 458.062C620.734 457.854 620.26 457.648 619.859 457.445C619.464 457.237 619.156 456.984 618.938 456.688C618.724 456.391 618.617 456.005 618.617 455.531C618.617 454.807 618.909 454.253 619.492 453.867C620.081 453.477 620.852 453.281 621.805 453.281C622.32 453.281 622.802 453.333 623.25 453.438C623.703 453.536 624.125 453.672 624.516 453.844L624.078 454.883C623.724 454.732 623.346 454.604 622.945 454.5C622.544 454.396 622.135 454.344 621.719 454.344C621.12 454.344 620.659 454.443 620.336 454.641C620.018 454.839 619.859 455.109 619.859 455.453C619.859 455.719 619.932 455.938 620.078 456.109C620.229 456.281 620.469 456.443 620.797 456.594C621.125 456.745 621.557 456.922 622.094 457.125C622.63 457.323 623.094 457.529 623.484 457.742C623.875 457.951 624.174 458.206 624.383 458.508C624.596 458.805 624.703 459.188 624.703 459.656ZM639.117 450.578L635.016 462H633.68L629.578 450.578H630.969L633.641 458.102C633.75 458.404 633.846 458.693 633.93 458.969C634.018 459.245 634.096 459.51 634.164 459.766C634.232 460.021 634.292 460.268 634.344 460.508C634.396 460.268 634.456 460.021 634.523 459.766C634.591 459.505 634.669 459.237 634.758 458.961C634.846 458.68 634.945 458.385 635.055 458.078L637.711 450.578H639.117ZM641.789 453.438V462H640.492V453.438H641.789ZM641.156 450.234C641.37 450.234 641.552 450.305 641.703 450.445C641.859 450.581 641.938 450.794 641.938 451.086C641.938 451.372 641.859 451.586 641.703 451.727C641.552 451.867 641.37 451.938 641.156 451.938C640.932 451.938 640.745 451.867 640.594 451.727C640.448 451.586 640.375 451.372 640.375 451.086C640.375 450.794 640.448 450.581 640.594 450.445C640.745 450.305 640.932 450.234 641.156 450.234ZM647.836 453.281C648.565 453.281 649.19 453.443 649.711 453.766C650.232 454.089 650.63 454.542 650.906 455.125C651.182 455.703 651.32 456.38 651.32 457.156V457.961H645.406C645.422 458.966 645.672 459.732 646.156 460.258C646.641 460.784 647.323 461.047 648.203 461.047C648.745 461.047 649.224 460.997 649.641 460.898C650.057 460.799 650.49 460.654 650.938 460.461V461.602C650.505 461.794 650.076 461.935 649.648 462.023C649.227 462.112 648.727 462.156 648.148 462.156C647.326 462.156 646.607 461.99 645.992 461.656C645.383 461.318 644.909 460.823 644.57 460.172C644.232 459.521 644.062 458.724 644.062 457.781C644.062 456.859 644.216 456.062 644.523 455.391C644.836 454.714 645.273 454.193 645.836 453.828C646.404 453.464 647.07 453.281 647.836 453.281ZM647.82 454.344C647.128 454.344 646.576 454.57 646.164 455.023C645.753 455.477 645.508 456.109 645.43 456.922H649.961C649.956 456.411 649.875 455.964 649.719 455.578C649.568 455.188 649.336 454.885 649.023 454.672C648.711 454.453 648.31 454.344 647.82 454.344ZM660.492 461.984L658.969 457C658.901 456.786 658.836 456.578 658.773 456.375C658.716 456.167 658.661 455.969 658.609 455.781C658.562 455.589 658.518 455.411 658.477 455.25C658.44 455.083 658.409 454.94 658.383 454.82H658.328C658.307 454.94 658.279 455.083 658.242 455.25C658.206 455.411 658.161 455.589 658.109 455.781C658.062 455.974 658.01 456.177 657.953 456.391C657.896 456.599 657.831 456.81 657.758 457.023L656.164 461.984H654.703L652.344 453.422H653.688L654.922 458.148C655.005 458.461 655.083 458.771 655.156 459.078C655.234 459.38 655.299 459.667 655.352 459.938C655.409 460.203 655.451 460.435 655.477 460.633H655.539C655.57 460.503 655.604 460.346 655.641 460.164C655.682 459.982 655.727 459.789 655.773 459.586C655.826 459.378 655.88 459.172 655.938 458.969C655.995 458.76 656.052 458.565 656.109 458.383L657.688 453.422H659.086L660.609 458.375C660.688 458.625 660.763 458.885 660.836 459.156C660.914 459.427 660.984 459.69 661.047 459.945C661.109 460.195 661.154 460.419 661.18 460.617H661.242C661.263 460.44 661.302 460.221 661.359 459.961C661.417 459.701 661.482 459.414 661.555 459.102C661.633 458.789 661.714 458.471 661.797 458.148L663.047 453.422H664.367L662 461.984H660.492Z" fill="white" />
    <path d="M282.671 155.531L272.671 149.758L272.671 161.305L282.671 155.531ZM38.6742 155.532L37.6742 155.531L37.6742 156.532L38.6742 156.532L38.6742 155.532ZM37.6758 49L37.6742 155.531L39.6742 155.532L39.6758 49L37.6758 49ZM38.6742 156.532L273.671 156.531L273.671 154.531L38.6742 154.532L38.6742 156.532Z" fill="black" />
    <path d="M96 428L90.2265 418L101.774 418L96 428ZM96 328.886L95 328.886L95 327.886L96 327.886L96 328.886ZM95 419L95 328.886L97 328.886L97 419L95 419ZM96 327.886L282.672 327.887L282.672 329.887L96 329.886L96 327.886Z" fill="black" />
    <path d="M595.828 428L601.602 418L590.055 418L595.828 428ZM595.828 328.886L596.828 328.886L596.828 327.886L595.828 327.886L595.828 328.886ZM596.828 419L596.828 328.886L594.828 328.886L594.828 419L596.828 419ZM595.828 327.886L409.156 327.887L409.156 329.887L595.828 329.886L595.828 327.886Z" fill="black" />
    <path d="M404.498 155.531L414.498 149.758L414.498 161.305L404.498 155.531ZM648.495 155.532L649.495 155.531L649.495 156.532L648.495 156.532L648.495 155.532ZM649.492 48.5L649.495 155.531L647.495 155.532L647.492 48.5L649.492 48.5ZM648.495 156.532L413.498 156.531L413.498 154.531L648.495 154.532L648.495 156.532Z" fill="black" />
    <path d="M345.5 424L351.274 414L339.726 414L345.5 424ZM344.5 352L344.5 415L346.5 415L346.5 352L344.5 352Z" fill="black" />
    <path d="M138.227 140L136.82 136.375H132.242L130.844 140H129.5L133.969 128.531H135.164L139.602 140H138.227ZM136.422 135.195L135.086 131.594C135.055 131.5 135.003 131.346 134.93 131.133C134.862 130.919 134.792 130.698 134.719 130.469C134.646 130.24 134.586 130.055 134.539 129.914C134.487 130.128 134.43 130.341 134.367 130.555C134.31 130.763 134.253 130.958 134.195 131.141C134.138 131.318 134.089 131.469 134.047 131.594L132.688 135.195H136.422ZM141.188 140V128.578H142.516V140H141.188ZM148.742 128.578C149.68 128.578 150.453 128.695 151.062 128.93C151.677 129.159 152.135 129.51 152.438 129.984C152.74 130.458 152.891 131.062 152.891 131.797C152.891 132.401 152.781 132.906 152.562 133.312C152.344 133.714 152.057 134.039 151.703 134.289C151.349 134.539 150.971 134.732 150.57 134.867L153.703 140H152.156L149.359 135.234H146.984V140H145.656V128.578H148.742ZM148.664 129.727H146.984V134.109H148.797C149.729 134.109 150.414 133.919 150.852 133.539C151.294 133.159 151.516 132.599 151.516 131.859C151.516 131.083 151.281 130.534 150.812 130.211C150.349 129.888 149.633 129.727 148.664 129.727ZM159.664 128.578L155.414 140H154.133L158.391 128.578H159.664ZM167.852 136.961C167.852 137.638 167.682 138.216 167.344 138.695C167.01 139.169 166.542 139.531 165.938 139.781C165.333 140.031 164.622 140.156 163.805 140.156C163.372 140.156 162.964 140.135 162.578 140.094C162.193 140.052 161.839 139.992 161.516 139.914C161.193 139.836 160.909 139.74 160.664 139.625V138.352C161.055 138.513 161.531 138.664 162.094 138.805C162.656 138.94 163.245 139.008 163.859 139.008C164.432 139.008 164.917 138.932 165.312 138.781C165.708 138.625 166.008 138.404 166.211 138.117C166.419 137.826 166.523 137.477 166.523 137.07C166.523 136.68 166.438 136.354 166.266 136.094C166.094 135.828 165.807 135.589 165.406 135.375C165.01 135.156 164.469 134.924 163.781 134.68C163.297 134.508 162.87 134.32 162.5 134.117C162.13 133.909 161.82 133.674 161.57 133.414C161.32 133.154 161.13 132.852 161 132.508C160.875 132.164 160.812 131.771 160.812 131.328C160.812 130.719 160.966 130.198 161.273 129.766C161.586 129.328 162.016 128.995 162.562 128.766C163.115 128.531 163.747 128.414 164.461 128.414C165.07 128.414 165.633 128.471 166.148 128.586C166.669 128.701 167.146 128.854 167.578 129.047L167.164 130.188C166.753 130.016 166.315 129.872 165.852 129.758C165.393 129.643 164.919 129.586 164.43 129.586C163.94 129.586 163.526 129.659 163.188 129.805C162.854 129.945 162.599 130.146 162.422 130.406C162.245 130.667 162.156 130.977 162.156 131.336C162.156 131.737 162.24 132.07 162.406 132.336C162.578 132.602 162.849 132.839 163.219 133.047C163.594 133.25 164.089 133.464 164.703 133.688C165.375 133.932 165.945 134.193 166.414 134.469C166.883 134.74 167.24 135.073 167.484 135.469C167.729 135.859 167.852 136.357 167.852 136.961ZM171.516 140H170.188V128.578H176.547V129.75H171.516V133.938H176.242V135.102H171.516V140ZM181.961 140H180.625V129.75H177.031V128.578H185.539V129.75H181.961V140Z" fill="#0F0F0F" />
    <path d="M138.227 140L136.82 136.375H132.242L130.844 140H129.5L133.969 128.531H135.164L139.602 140H138.227ZM136.422 135.195L135.086 131.594C135.055 131.5 135.003 131.346 134.93 131.133C134.862 130.919 134.792 130.698 134.719 130.469C134.646 130.24 134.586 130.055 134.539 129.914C134.487 130.128 134.43 130.341 134.367 130.555C134.31 130.763 134.253 130.958 134.195 131.141C134.138 131.318 134.089 131.469 134.047 131.594L132.688 135.195H136.422ZM141.188 140V128.578H142.516V140H141.188ZM148.742 128.578C149.68 128.578 150.453 128.695 151.062 128.93C151.677 129.159 152.135 129.51 152.438 129.984C152.74 130.458 152.891 131.062 152.891 131.797C152.891 132.401 152.781 132.906 152.562 133.312C152.344 133.714 152.057 134.039 151.703 134.289C151.349 134.539 150.971 134.732 150.57 134.867L153.703 140H152.156L149.359 135.234H146.984V140H145.656V128.578H148.742ZM148.664 129.727H146.984V134.109H148.797C149.729 134.109 150.414 133.919 150.852 133.539C151.294 133.159 151.516 132.599 151.516 131.859C151.516 131.083 151.281 130.534 150.812 130.211C150.349 129.888 149.633 129.727 148.664 129.727ZM159.664 128.578L155.414 140H154.133L158.391 128.578H159.664ZM167.852 136.961C167.852 137.638 167.682 138.216 167.344 138.695C167.01 139.169 166.542 139.531 165.938 139.781C165.333 140.031 164.622 140.156 163.805 140.156C163.372 140.156 162.964 140.135 162.578 140.094C162.193 140.052 161.839 139.992 161.516 139.914C161.193 139.836 160.909 139.74 160.664 139.625V138.352C161.055 138.513 161.531 138.664 162.094 138.805C162.656 138.94 163.245 139.008 163.859 139.008C164.432 139.008 164.917 138.932 165.312 138.781C165.708 138.625 166.008 138.404 166.211 138.117C166.419 137.826 166.523 137.477 166.523 137.07C166.523 136.68 166.438 136.354 166.266 136.094C166.094 135.828 165.807 135.589 165.406 135.375C165.01 135.156 164.469 134.924 163.781 134.68C163.297 134.508 162.87 134.32 162.5 134.117C162.13 133.909 161.82 133.674 161.57 133.414C161.32 133.154 161.13 132.852 161 132.508C160.875 132.164 160.812 131.771 160.812 131.328C160.812 130.719 160.966 130.198 161.273 129.766C161.586 129.328 162.016 128.995 162.562 128.766C163.115 128.531 163.747 128.414 164.461 128.414C165.07 128.414 165.633 128.471 166.148 128.586C166.669 128.701 167.146 128.854 167.578 129.047L167.164 130.188C166.753 130.016 166.315 129.872 165.852 129.758C165.393 129.643 164.919 129.586 164.43 129.586C163.94 129.586 163.526 129.659 163.188 129.805C162.854 129.945 162.599 130.146 162.422 130.406C162.245 130.667 162.156 130.977 162.156 131.336C162.156 131.737 162.24 132.07 162.406 132.336C162.578 132.602 162.849 132.839 163.219 133.047C163.594 133.25 164.089 133.464 164.703 133.688C165.375 133.932 165.945 134.193 166.414 134.469C166.883 134.74 167.24 135.073 167.484 135.469C167.729 135.859 167.852 136.357 167.852 136.961ZM171.516 140H170.188V128.578H176.547V129.75H171.516V133.938H176.242V135.102H171.516V140ZM181.961 140H180.625V129.75H177.031V128.578H185.539V129.75H181.961V140Z" fill="black" fill-opacity="0.2" />
    <path d="M138.227 140L136.82 136.375H132.242L130.844 140H129.5L133.969 128.531H135.164L139.602 140H138.227ZM136.422 135.195L135.086 131.594C135.055 131.5 135.003 131.346 134.93 131.133C134.862 130.919 134.792 130.698 134.719 130.469C134.646 130.24 134.586 130.055 134.539 129.914C134.487 130.128 134.43 130.341 134.367 130.555C134.31 130.763 134.253 130.958 134.195 131.141C134.138 131.318 134.089 131.469 134.047 131.594L132.688 135.195H136.422ZM141.188 140V128.578H142.516V140H141.188ZM148.742 128.578C149.68 128.578 150.453 128.695 151.062 128.93C151.677 129.159 152.135 129.51 152.438 129.984C152.74 130.458 152.891 131.062 152.891 131.797C152.891 132.401 152.781 132.906 152.562 133.312C152.344 133.714 152.057 134.039 151.703 134.289C151.349 134.539 150.971 134.732 150.57 134.867L153.703 140H152.156L149.359 135.234H146.984V140H145.656V128.578H148.742ZM148.664 129.727H146.984V134.109H148.797C149.729 134.109 150.414 133.919 150.852 133.539C151.294 133.159 151.516 132.599 151.516 131.859C151.516 131.083 151.281 130.534 150.812 130.211C150.349 129.888 149.633 129.727 148.664 129.727ZM159.664 128.578L155.414 140H154.133L158.391 128.578H159.664ZM167.852 136.961C167.852 137.638 167.682 138.216 167.344 138.695C167.01 139.169 166.542 139.531 165.938 139.781C165.333 140.031 164.622 140.156 163.805 140.156C163.372 140.156 162.964 140.135 162.578 140.094C162.193 140.052 161.839 139.992 161.516 139.914C161.193 139.836 160.909 139.74 160.664 139.625V138.352C161.055 138.513 161.531 138.664 162.094 138.805C162.656 138.94 163.245 139.008 163.859 139.008C164.432 139.008 164.917 138.932 165.312 138.781C165.708 138.625 166.008 138.404 166.211 138.117C166.419 137.826 166.523 137.477 166.523 137.07C166.523 136.68 166.438 136.354 166.266 136.094C166.094 135.828 165.807 135.589 165.406 135.375C165.01 135.156 164.469 134.924 163.781 134.68C163.297 134.508 162.87 134.32 162.5 134.117C162.13 133.909 161.82 133.674 161.57 133.414C161.32 133.154 161.13 132.852 161 132.508C160.875 132.164 160.812 131.771 160.812 131.328C160.812 130.719 160.966 130.198 161.273 129.766C161.586 129.328 162.016 128.995 162.562 128.766C163.115 128.531 163.747 128.414 164.461 128.414C165.07 128.414 165.633 128.471 166.148 128.586C166.669 128.701 167.146 128.854 167.578 129.047L167.164 130.188C166.753 130.016 166.315 129.872 165.852 129.758C165.393 129.643 164.919 129.586 164.43 129.586C163.94 129.586 163.526 129.659 163.188 129.805C162.854 129.945 162.599 130.146 162.422 130.406C162.245 130.667 162.156 130.977 162.156 131.336C162.156 131.737 162.24 132.07 162.406 132.336C162.578 132.602 162.849 132.839 163.219 133.047C163.594 133.25 164.089 133.464 164.703 133.688C165.375 133.932 165.945 134.193 166.414 134.469C166.883 134.74 167.24 135.073 167.484 135.469C167.729 135.859 167.852 136.357 167.852 136.961ZM171.516 140H170.188V128.578H176.547V129.75H171.516V133.938H176.242V135.102H171.516V140ZM181.961 140H180.625V129.75H177.031V128.578H185.539V129.75H181.961V140Z" fill="black" fill-opacity="0.2" />
    <path d="M138.227 140L136.82 136.375H132.242L130.844 140H129.5L133.969 128.531H135.164L139.602 140H138.227ZM136.422 135.195L135.086 131.594C135.055 131.5 135.003 131.346 134.93 131.133C134.862 130.919 134.792 130.698 134.719 130.469C134.646 130.24 134.586 130.055 134.539 129.914C134.487 130.128 134.43 130.341 134.367 130.555C134.31 130.763 134.253 130.958 134.195 131.141C134.138 131.318 134.089 131.469 134.047 131.594L132.688 135.195H136.422ZM141.188 140V128.578H142.516V140H141.188ZM148.742 128.578C149.68 128.578 150.453 128.695 151.062 128.93C151.677 129.159 152.135 129.51 152.438 129.984C152.74 130.458 152.891 131.062 152.891 131.797C152.891 132.401 152.781 132.906 152.562 133.312C152.344 133.714 152.057 134.039 151.703 134.289C151.349 134.539 150.971 134.732 150.57 134.867L153.703 140H152.156L149.359 135.234H146.984V140H145.656V128.578H148.742ZM148.664 129.727H146.984V134.109H148.797C149.729 134.109 150.414 133.919 150.852 133.539C151.294 133.159 151.516 132.599 151.516 131.859C151.516 131.083 151.281 130.534 150.812 130.211C150.349 129.888 149.633 129.727 148.664 129.727ZM159.664 128.578L155.414 140H154.133L158.391 128.578H159.664ZM167.852 136.961C167.852 137.638 167.682 138.216 167.344 138.695C167.01 139.169 166.542 139.531 165.938 139.781C165.333 140.031 164.622 140.156 163.805 140.156C163.372 140.156 162.964 140.135 162.578 140.094C162.193 140.052 161.839 139.992 161.516 139.914C161.193 139.836 160.909 139.74 160.664 139.625V138.352C161.055 138.513 161.531 138.664 162.094 138.805C162.656 138.94 163.245 139.008 163.859 139.008C164.432 139.008 164.917 138.932 165.312 138.781C165.708 138.625 166.008 138.404 166.211 138.117C166.419 137.826 166.523 137.477 166.523 137.07C166.523 136.68 166.438 136.354 166.266 136.094C166.094 135.828 165.807 135.589 165.406 135.375C165.01 135.156 164.469 134.924 163.781 134.68C163.297 134.508 162.87 134.32 162.5 134.117C162.13 133.909 161.82 133.674 161.57 133.414C161.32 133.154 161.13 132.852 161 132.508C160.875 132.164 160.812 131.771 160.812 131.328C160.812 130.719 160.966 130.198 161.273 129.766C161.586 129.328 162.016 128.995 162.562 128.766C163.115 128.531 163.747 128.414 164.461 128.414C165.07 128.414 165.633 128.471 166.148 128.586C166.669 128.701 167.146 128.854 167.578 129.047L167.164 130.188C166.753 130.016 166.315 129.872 165.852 129.758C165.393 129.643 164.919 129.586 164.43 129.586C163.94 129.586 163.526 129.659 163.188 129.805C162.854 129.945 162.599 130.146 162.422 130.406C162.245 130.667 162.156 130.977 162.156 131.336C162.156 131.737 162.24 132.07 162.406 132.336C162.578 132.602 162.849 132.839 163.219 133.047C163.594 133.25 164.089 133.464 164.703 133.688C165.375 133.932 165.945 134.193 166.414 134.469C166.883 134.74 167.24 135.073 167.484 135.469C167.729 135.859 167.852 136.357 167.852 136.961ZM171.516 140H170.188V128.578H176.547V129.75H171.516V133.938H176.242V135.102H171.516V140ZM181.961 140H180.625V129.75H177.031V128.578H185.539V129.75H181.961V140Z" fill="black" fill-opacity="0.2" />
    <path d="M138.227 140L136.82 136.375H132.242L130.844 140H129.5L133.969 128.531H135.164L139.602 140H138.227ZM136.422 135.195L135.086 131.594C135.055 131.5 135.003 131.346 134.93 131.133C134.862 130.919 134.792 130.698 134.719 130.469C134.646 130.24 134.586 130.055 134.539 129.914C134.487 130.128 134.43 130.341 134.367 130.555C134.31 130.763 134.253 130.958 134.195 131.141C134.138 131.318 134.089 131.469 134.047 131.594L132.688 135.195H136.422ZM141.188 140V128.578H142.516V140H141.188ZM148.742 128.578C149.68 128.578 150.453 128.695 151.062 128.93C151.677 129.159 152.135 129.51 152.438 129.984C152.74 130.458 152.891 131.062 152.891 131.797C152.891 132.401 152.781 132.906 152.562 133.312C152.344 133.714 152.057 134.039 151.703 134.289C151.349 134.539 150.971 134.732 150.57 134.867L153.703 140H152.156L149.359 135.234H146.984V140H145.656V128.578H148.742ZM148.664 129.727H146.984V134.109H148.797C149.729 134.109 150.414 133.919 150.852 133.539C151.294 133.159 151.516 132.599 151.516 131.859C151.516 131.083 151.281 130.534 150.812 130.211C150.349 129.888 149.633 129.727 148.664 129.727ZM159.664 128.578L155.414 140H154.133L158.391 128.578H159.664ZM167.852 136.961C167.852 137.638 167.682 138.216 167.344 138.695C167.01 139.169 166.542 139.531 165.938 139.781C165.333 140.031 164.622 140.156 163.805 140.156C163.372 140.156 162.964 140.135 162.578 140.094C162.193 140.052 161.839 139.992 161.516 139.914C161.193 139.836 160.909 139.74 160.664 139.625V138.352C161.055 138.513 161.531 138.664 162.094 138.805C162.656 138.94 163.245 139.008 163.859 139.008C164.432 139.008 164.917 138.932 165.312 138.781C165.708 138.625 166.008 138.404 166.211 138.117C166.419 137.826 166.523 137.477 166.523 137.07C166.523 136.68 166.438 136.354 166.266 136.094C166.094 135.828 165.807 135.589 165.406 135.375C165.01 135.156 164.469 134.924 163.781 134.68C163.297 134.508 162.87 134.32 162.5 134.117C162.13 133.909 161.82 133.674 161.57 133.414C161.32 133.154 161.13 132.852 161 132.508C160.875 132.164 160.812 131.771 160.812 131.328C160.812 130.719 160.966 130.198 161.273 129.766C161.586 129.328 162.016 128.995 162.562 128.766C163.115 128.531 163.747 128.414 164.461 128.414C165.07 128.414 165.633 128.471 166.148 128.586C166.669 128.701 167.146 128.854 167.578 129.047L167.164 130.188C166.753 130.016 166.315 129.872 165.852 129.758C165.393 129.643 164.919 129.586 164.43 129.586C163.94 129.586 163.526 129.659 163.188 129.805C162.854 129.945 162.599 130.146 162.422 130.406C162.245 130.667 162.156 130.977 162.156 131.336C162.156 131.737 162.24 132.07 162.406 132.336C162.578 132.602 162.849 132.839 163.219 133.047C163.594 133.25 164.089 133.464 164.703 133.688C165.375 133.932 165.945 134.193 166.414 134.469C166.883 134.74 167.24 135.073 167.484 135.469C167.729 135.859 167.852 136.357 167.852 136.961ZM171.516 140H170.188V128.578H176.547V129.75H171.516V133.938H176.242V135.102H171.516V140ZM181.961 140H180.625V129.75H177.031V128.578H185.539V129.75H181.961V140Z" fill="black" fill-opacity="0.2" />
    <path d="M138.227 140L136.82 136.375H132.242L130.844 140H129.5L133.969 128.531H135.164L139.602 140H138.227ZM136.422 135.195L135.086 131.594C135.055 131.5 135.003 131.346 134.93 131.133C134.862 130.919 134.792 130.698 134.719 130.469C134.646 130.24 134.586 130.055 134.539 129.914C134.487 130.128 134.43 130.341 134.367 130.555C134.31 130.763 134.253 130.958 134.195 131.141C134.138 131.318 134.089 131.469 134.047 131.594L132.688 135.195H136.422ZM141.188 140V128.578H142.516V140H141.188ZM148.742 128.578C149.68 128.578 150.453 128.695 151.062 128.93C151.677 129.159 152.135 129.51 152.438 129.984C152.74 130.458 152.891 131.062 152.891 131.797C152.891 132.401 152.781 132.906 152.562 133.312C152.344 133.714 152.057 134.039 151.703 134.289C151.349 134.539 150.971 134.732 150.57 134.867L153.703 140H152.156L149.359 135.234H146.984V140H145.656V128.578H148.742ZM148.664 129.727H146.984V134.109H148.797C149.729 134.109 150.414 133.919 150.852 133.539C151.294 133.159 151.516 132.599 151.516 131.859C151.516 131.083 151.281 130.534 150.812 130.211C150.349 129.888 149.633 129.727 148.664 129.727ZM159.664 128.578L155.414 140H154.133L158.391 128.578H159.664ZM167.852 136.961C167.852 137.638 167.682 138.216 167.344 138.695C167.01 139.169 166.542 139.531 165.938 139.781C165.333 140.031 164.622 140.156 163.805 140.156C163.372 140.156 162.964 140.135 162.578 140.094C162.193 140.052 161.839 139.992 161.516 139.914C161.193 139.836 160.909 139.74 160.664 139.625V138.352C161.055 138.513 161.531 138.664 162.094 138.805C162.656 138.94 163.245 139.008 163.859 139.008C164.432 139.008 164.917 138.932 165.312 138.781C165.708 138.625 166.008 138.404 166.211 138.117C166.419 137.826 166.523 137.477 166.523 137.07C166.523 136.68 166.438 136.354 166.266 136.094C166.094 135.828 165.807 135.589 165.406 135.375C165.01 135.156 164.469 134.924 163.781 134.68C163.297 134.508 162.87 134.32 162.5 134.117C162.13 133.909 161.82 133.674 161.57 133.414C161.32 133.154 161.13 132.852 161 132.508C160.875 132.164 160.812 131.771 160.812 131.328C160.812 130.719 160.966 130.198 161.273 129.766C161.586 129.328 162.016 128.995 162.562 128.766C163.115 128.531 163.747 128.414 164.461 128.414C165.07 128.414 165.633 128.471 166.148 128.586C166.669 128.701 167.146 128.854 167.578 129.047L167.164 130.188C166.753 130.016 166.315 129.872 165.852 129.758C165.393 129.643 164.919 129.586 164.43 129.586C163.94 129.586 163.526 129.659 163.188 129.805C162.854 129.945 162.599 130.146 162.422 130.406C162.245 130.667 162.156 130.977 162.156 131.336C162.156 131.737 162.24 132.07 162.406 132.336C162.578 132.602 162.849 132.839 163.219 133.047C163.594 133.25 164.089 133.464 164.703 133.688C165.375 133.932 165.945 134.193 166.414 134.469C166.883 134.74 167.24 135.073 167.484 135.469C167.729 135.859 167.852 136.357 167.852 136.961ZM171.516 140H170.188V128.578H176.547V129.75H171.516V133.938H176.242V135.102H171.516V140ZM181.961 140H180.625V129.75H177.031V128.578H185.539V129.75H181.961V140Z" fill="black" fill-opacity="0.2" />
    <path d="M273.148 190.578C274.086 190.578 274.859 190.695 275.469 190.93C276.083 191.159 276.542 191.51 276.844 191.984C277.146 192.458 277.297 193.062 277.297 193.797C277.297 194.401 277.188 194.906 276.969 195.312C276.75 195.714 276.464 196.039 276.109 196.289C275.755 196.539 275.378 196.732 274.977 196.867L278.109 202H276.562L273.766 197.234H271.391V202H270.062V190.578H273.148ZM273.07 191.727H271.391V196.109H273.203C274.135 196.109 274.82 195.919 275.258 195.539C275.701 195.159 275.922 194.599 275.922 193.859C275.922 193.083 275.688 192.534 275.219 192.211C274.755 191.888 274.039 191.727 273.07 191.727ZM283.039 193.281C283.768 193.281 284.393 193.443 284.914 193.766C285.435 194.089 285.833 194.542 286.109 195.125C286.385 195.703 286.523 196.38 286.523 197.156V197.961H280.609C280.625 198.966 280.875 199.732 281.359 200.258C281.844 200.784 282.526 201.047 283.406 201.047C283.948 201.047 284.427 200.997 284.844 200.898C285.26 200.799 285.693 200.654 286.141 200.461V201.602C285.708 201.794 285.279 201.935 284.852 202.023C284.43 202.112 283.93 202.156 283.352 202.156C282.529 202.156 281.81 201.99 281.195 201.656C280.586 201.318 280.112 200.823 279.773 200.172C279.435 199.521 279.266 198.724 279.266 197.781C279.266 196.859 279.419 196.062 279.727 195.391C280.039 194.714 280.477 194.193 281.039 193.828C281.607 193.464 282.273 193.281 283.039 193.281ZM283.023 194.344C282.331 194.344 281.779 194.57 281.367 195.023C280.956 195.477 280.711 196.109 280.633 196.922H285.164C285.159 196.411 285.078 195.964 284.922 195.578C284.771 195.188 284.539 194.885 284.227 194.672C283.914 194.453 283.513 194.344 283.023 194.344ZM291.492 201.094C291.706 201.094 291.924 201.076 292.148 201.039C292.372 201.003 292.555 200.958 292.695 200.906V201.914C292.544 201.982 292.333 202.039 292.062 202.086C291.797 202.133 291.536 202.156 291.281 202.156C290.828 202.156 290.417 202.078 290.047 201.922C289.677 201.76 289.38 201.49 289.156 201.109C288.938 200.729 288.828 200.203 288.828 199.531V194.453H287.609V193.82L288.836 193.312L289.352 191.453H290.133V193.438H292.641V194.453H290.133V199.492C290.133 200.029 290.255 200.43 290.5 200.695C290.75 200.961 291.081 201.094 291.492 201.094ZM301.5 193.438V202H300.438L300.25 200.797H300.18C300.003 201.094 299.773 201.344 299.492 201.547C299.211 201.75 298.893 201.901 298.539 202C298.19 202.104 297.818 202.156 297.422 202.156C296.745 202.156 296.177 202.047 295.719 201.828C295.26 201.609 294.914 201.271 294.68 200.812C294.451 200.354 294.336 199.766 294.336 199.047V193.438H295.648V198.953C295.648 199.667 295.81 200.201 296.133 200.555C296.456 200.904 296.948 201.078 297.609 201.078C298.245 201.078 298.75 200.958 299.125 200.719C299.505 200.479 299.779 200.128 299.945 199.664C300.112 199.195 300.195 198.622 300.195 197.945V193.438H301.5ZM308.133 193.281C308.305 193.281 308.484 193.292 308.672 193.312C308.859 193.328 309.026 193.352 309.172 193.383L309.008 194.586C308.867 194.549 308.711 194.521 308.539 194.5C308.367 194.479 308.206 194.469 308.055 194.469C307.711 194.469 307.385 194.539 307.078 194.68C306.776 194.815 306.51 195.013 306.281 195.273C306.052 195.529 305.872 195.839 305.742 196.203C305.612 196.562 305.547 196.964 305.547 197.406V202H304.242V193.438H305.32L305.461 195.016H305.516C305.693 194.698 305.906 194.409 306.156 194.148C306.406 193.883 306.695 193.672 307.023 193.516C307.357 193.359 307.727 193.281 308.133 193.281ZM314.844 193.281C315.859 193.281 316.628 193.531 317.148 194.031C317.669 194.526 317.93 195.323 317.93 196.422V202H316.648V196.508C316.648 195.794 316.484 195.26 316.156 194.906C315.833 194.552 315.336 194.375 314.664 194.375C313.716 194.375 313.049 194.643 312.664 195.18C312.279 195.716 312.086 196.495 312.086 197.516V202H310.789V193.438H311.836L312.031 194.672H312.102C312.284 194.37 312.516 194.117 312.797 193.914C313.078 193.706 313.393 193.549 313.742 193.445C314.091 193.336 314.458 193.281 314.844 193.281Z" fill="#0F0F0F" />
    <path d="M273.148 190.578C274.086 190.578 274.859 190.695 275.469 190.93C276.083 191.159 276.542 191.51 276.844 191.984C277.146 192.458 277.297 193.062 277.297 193.797C277.297 194.401 277.188 194.906 276.969 195.312C276.75 195.714 276.464 196.039 276.109 196.289C275.755 196.539 275.378 196.732 274.977 196.867L278.109 202H276.562L273.766 197.234H271.391V202H270.062V190.578H273.148ZM273.07 191.727H271.391V196.109H273.203C274.135 196.109 274.82 195.919 275.258 195.539C275.701 195.159 275.922 194.599 275.922 193.859C275.922 193.083 275.688 192.534 275.219 192.211C274.755 191.888 274.039 191.727 273.07 191.727ZM283.039 193.281C283.768 193.281 284.393 193.443 284.914 193.766C285.435 194.089 285.833 194.542 286.109 195.125C286.385 195.703 286.523 196.38 286.523 197.156V197.961H280.609C280.625 198.966 280.875 199.732 281.359 200.258C281.844 200.784 282.526 201.047 283.406 201.047C283.948 201.047 284.427 200.997 284.844 200.898C285.26 200.799 285.693 200.654 286.141 200.461V201.602C285.708 201.794 285.279 201.935 284.852 202.023C284.43 202.112 283.93 202.156 283.352 202.156C282.529 202.156 281.81 201.99 281.195 201.656C280.586 201.318 280.112 200.823 279.773 200.172C279.435 199.521 279.266 198.724 279.266 197.781C279.266 196.859 279.419 196.062 279.727 195.391C280.039 194.714 280.477 194.193 281.039 193.828C281.607 193.464 282.273 193.281 283.039 193.281ZM283.023 194.344C282.331 194.344 281.779 194.57 281.367 195.023C280.956 195.477 280.711 196.109 280.633 196.922H285.164C285.159 196.411 285.078 195.964 284.922 195.578C284.771 195.188 284.539 194.885 284.227 194.672C283.914 194.453 283.513 194.344 283.023 194.344ZM291.492 201.094C291.706 201.094 291.924 201.076 292.148 201.039C292.372 201.003 292.555 200.958 292.695 200.906V201.914C292.544 201.982 292.333 202.039 292.062 202.086C291.797 202.133 291.536 202.156 291.281 202.156C290.828 202.156 290.417 202.078 290.047 201.922C289.677 201.76 289.38 201.49 289.156 201.109C288.938 200.729 288.828 200.203 288.828 199.531V194.453H287.609V193.82L288.836 193.312L289.352 191.453H290.133V193.438H292.641V194.453H290.133V199.492C290.133 200.029 290.255 200.43 290.5 200.695C290.75 200.961 291.081 201.094 291.492 201.094ZM301.5 193.438V202H300.438L300.25 200.797H300.18C300.003 201.094 299.773 201.344 299.492 201.547C299.211 201.75 298.893 201.901 298.539 202C298.19 202.104 297.818 202.156 297.422 202.156C296.745 202.156 296.177 202.047 295.719 201.828C295.26 201.609 294.914 201.271 294.68 200.812C294.451 200.354 294.336 199.766 294.336 199.047V193.438H295.648V198.953C295.648 199.667 295.81 200.201 296.133 200.555C296.456 200.904 296.948 201.078 297.609 201.078C298.245 201.078 298.75 200.958 299.125 200.719C299.505 200.479 299.779 200.128 299.945 199.664C300.112 199.195 300.195 198.622 300.195 197.945V193.438H301.5ZM308.133 193.281C308.305 193.281 308.484 193.292 308.672 193.312C308.859 193.328 309.026 193.352 309.172 193.383L309.008 194.586C308.867 194.549 308.711 194.521 308.539 194.5C308.367 194.479 308.206 194.469 308.055 194.469C307.711 194.469 307.385 194.539 307.078 194.68C306.776 194.815 306.51 195.013 306.281 195.273C306.052 195.529 305.872 195.839 305.742 196.203C305.612 196.562 305.547 196.964 305.547 197.406V202H304.242V193.438H305.32L305.461 195.016H305.516C305.693 194.698 305.906 194.409 306.156 194.148C306.406 193.883 306.695 193.672 307.023 193.516C307.357 193.359 307.727 193.281 308.133 193.281ZM314.844 193.281C315.859 193.281 316.628 193.531 317.148 194.031C317.669 194.526 317.93 195.323 317.93 196.422V202H316.648V196.508C316.648 195.794 316.484 195.26 316.156 194.906C315.833 194.552 315.336 194.375 314.664 194.375C313.716 194.375 313.049 194.643 312.664 195.18C312.279 195.716 312.086 196.495 312.086 197.516V202H310.789V193.438H311.836L312.031 194.672H312.102C312.284 194.37 312.516 194.117 312.797 193.914C313.078 193.706 313.393 193.549 313.742 193.445C314.091 193.336 314.458 193.281 314.844 193.281Z" fill="black" fill-opacity="0.2" />
    <path d="M273.148 190.578C274.086 190.578 274.859 190.695 275.469 190.93C276.083 191.159 276.542 191.51 276.844 191.984C277.146 192.458 277.297 193.062 277.297 193.797C277.297 194.401 277.188 194.906 276.969 195.312C276.75 195.714 276.464 196.039 276.109 196.289C275.755 196.539 275.378 196.732 274.977 196.867L278.109 202H276.562L273.766 197.234H271.391V202H270.062V190.578H273.148ZM273.07 191.727H271.391V196.109H273.203C274.135 196.109 274.82 195.919 275.258 195.539C275.701 195.159 275.922 194.599 275.922 193.859C275.922 193.083 275.688 192.534 275.219 192.211C274.755 191.888 274.039 191.727 273.07 191.727ZM283.039 193.281C283.768 193.281 284.393 193.443 284.914 193.766C285.435 194.089 285.833 194.542 286.109 195.125C286.385 195.703 286.523 196.38 286.523 197.156V197.961H280.609C280.625 198.966 280.875 199.732 281.359 200.258C281.844 200.784 282.526 201.047 283.406 201.047C283.948 201.047 284.427 200.997 284.844 200.898C285.26 200.799 285.693 200.654 286.141 200.461V201.602C285.708 201.794 285.279 201.935 284.852 202.023C284.43 202.112 283.93 202.156 283.352 202.156C282.529 202.156 281.81 201.99 281.195 201.656C280.586 201.318 280.112 200.823 279.773 200.172C279.435 199.521 279.266 198.724 279.266 197.781C279.266 196.859 279.419 196.062 279.727 195.391C280.039 194.714 280.477 194.193 281.039 193.828C281.607 193.464 282.273 193.281 283.039 193.281ZM283.023 194.344C282.331 194.344 281.779 194.57 281.367 195.023C280.956 195.477 280.711 196.109 280.633 196.922H285.164C285.159 196.411 285.078 195.964 284.922 195.578C284.771 195.188 284.539 194.885 284.227 194.672C283.914 194.453 283.513 194.344 283.023 194.344ZM291.492 201.094C291.706 201.094 291.924 201.076 292.148 201.039C292.372 201.003 292.555 200.958 292.695 200.906V201.914C292.544 201.982 292.333 202.039 292.062 202.086C291.797 202.133 291.536 202.156 291.281 202.156C290.828 202.156 290.417 202.078 290.047 201.922C289.677 201.76 289.38 201.49 289.156 201.109C288.938 200.729 288.828 200.203 288.828 199.531V194.453H287.609V193.82L288.836 193.312L289.352 191.453H290.133V193.438H292.641V194.453H290.133V199.492C290.133 200.029 290.255 200.43 290.5 200.695C290.75 200.961 291.081 201.094 291.492 201.094ZM301.5 193.438V202H300.438L300.25 200.797H300.18C300.003 201.094 299.773 201.344 299.492 201.547C299.211 201.75 298.893 201.901 298.539 202C298.19 202.104 297.818 202.156 297.422 202.156C296.745 202.156 296.177 202.047 295.719 201.828C295.26 201.609 294.914 201.271 294.68 200.812C294.451 200.354 294.336 199.766 294.336 199.047V193.438H295.648V198.953C295.648 199.667 295.81 200.201 296.133 200.555C296.456 200.904 296.948 201.078 297.609 201.078C298.245 201.078 298.75 200.958 299.125 200.719C299.505 200.479 299.779 200.128 299.945 199.664C300.112 199.195 300.195 198.622 300.195 197.945V193.438H301.5ZM308.133 193.281C308.305 193.281 308.484 193.292 308.672 193.312C308.859 193.328 309.026 193.352 309.172 193.383L309.008 194.586C308.867 194.549 308.711 194.521 308.539 194.5C308.367 194.479 308.206 194.469 308.055 194.469C307.711 194.469 307.385 194.539 307.078 194.68C306.776 194.815 306.51 195.013 306.281 195.273C306.052 195.529 305.872 195.839 305.742 196.203C305.612 196.562 305.547 196.964 305.547 197.406V202H304.242V193.438H305.32L305.461 195.016H305.516C305.693 194.698 305.906 194.409 306.156 194.148C306.406 193.883 306.695 193.672 307.023 193.516C307.357 193.359 307.727 193.281 308.133 193.281ZM314.844 193.281C315.859 193.281 316.628 193.531 317.148 194.031C317.669 194.526 317.93 195.323 317.93 196.422V202H316.648V196.508C316.648 195.794 316.484 195.26 316.156 194.906C315.833 194.552 315.336 194.375 314.664 194.375C313.716 194.375 313.049 194.643 312.664 195.18C312.279 195.716 312.086 196.495 312.086 197.516V202H310.789V193.438H311.836L312.031 194.672H312.102C312.284 194.37 312.516 194.117 312.797 193.914C313.078 193.706 313.393 193.549 313.742 193.445C314.091 193.336 314.458 193.281 314.844 193.281Z" fill="black" fill-opacity="0.2" />
    <path d="M273.148 190.578C274.086 190.578 274.859 190.695 275.469 190.93C276.083 191.159 276.542 191.51 276.844 191.984C277.146 192.458 277.297 193.062 277.297 193.797C277.297 194.401 277.188 194.906 276.969 195.312C276.75 195.714 276.464 196.039 276.109 196.289C275.755 196.539 275.378 196.732 274.977 196.867L278.109 202H276.562L273.766 197.234H271.391V202H270.062V190.578H273.148ZM273.07 191.727H271.391V196.109H273.203C274.135 196.109 274.82 195.919 275.258 195.539C275.701 195.159 275.922 194.599 275.922 193.859C275.922 193.083 275.688 192.534 275.219 192.211C274.755 191.888 274.039 191.727 273.07 191.727ZM283.039 193.281C283.768 193.281 284.393 193.443 284.914 193.766C285.435 194.089 285.833 194.542 286.109 195.125C286.385 195.703 286.523 196.38 286.523 197.156V197.961H280.609C280.625 198.966 280.875 199.732 281.359 200.258C281.844 200.784 282.526 201.047 283.406 201.047C283.948 201.047 284.427 200.997 284.844 200.898C285.26 200.799 285.693 200.654 286.141 200.461V201.602C285.708 201.794 285.279 201.935 284.852 202.023C284.43 202.112 283.93 202.156 283.352 202.156C282.529 202.156 281.81 201.99 281.195 201.656C280.586 201.318 280.112 200.823 279.773 200.172C279.435 199.521 279.266 198.724 279.266 197.781C279.266 196.859 279.419 196.062 279.727 195.391C280.039 194.714 280.477 194.193 281.039 193.828C281.607 193.464 282.273 193.281 283.039 193.281ZM283.023 194.344C282.331 194.344 281.779 194.57 281.367 195.023C280.956 195.477 280.711 196.109 280.633 196.922H285.164C285.159 196.411 285.078 195.964 284.922 195.578C284.771 195.188 284.539 194.885 284.227 194.672C283.914 194.453 283.513 194.344 283.023 194.344ZM291.492 201.094C291.706 201.094 291.924 201.076 292.148 201.039C292.372 201.003 292.555 200.958 292.695 200.906V201.914C292.544 201.982 292.333 202.039 292.062 202.086C291.797 202.133 291.536 202.156 291.281 202.156C290.828 202.156 290.417 202.078 290.047 201.922C289.677 201.76 289.38 201.49 289.156 201.109C288.938 200.729 288.828 200.203 288.828 199.531V194.453H287.609V193.82L288.836 193.312L289.352 191.453H290.133V193.438H292.641V194.453H290.133V199.492C290.133 200.029 290.255 200.43 290.5 200.695C290.75 200.961 291.081 201.094 291.492 201.094ZM301.5 193.438V202H300.438L300.25 200.797H300.18C300.003 201.094 299.773 201.344 299.492 201.547C299.211 201.75 298.893 201.901 298.539 202C298.19 202.104 297.818 202.156 297.422 202.156C296.745 202.156 296.177 202.047 295.719 201.828C295.26 201.609 294.914 201.271 294.68 200.812C294.451 200.354 294.336 199.766 294.336 199.047V193.438H295.648V198.953C295.648 199.667 295.81 200.201 296.133 200.555C296.456 200.904 296.948 201.078 297.609 201.078C298.245 201.078 298.75 200.958 299.125 200.719C299.505 200.479 299.779 200.128 299.945 199.664C300.112 199.195 300.195 198.622 300.195 197.945V193.438H301.5ZM308.133 193.281C308.305 193.281 308.484 193.292 308.672 193.312C308.859 193.328 309.026 193.352 309.172 193.383L309.008 194.586C308.867 194.549 308.711 194.521 308.539 194.5C308.367 194.479 308.206 194.469 308.055 194.469C307.711 194.469 307.385 194.539 307.078 194.68C306.776 194.815 306.51 195.013 306.281 195.273C306.052 195.529 305.872 195.839 305.742 196.203C305.612 196.562 305.547 196.964 305.547 197.406V202H304.242V193.438H305.32L305.461 195.016H305.516C305.693 194.698 305.906 194.409 306.156 194.148C306.406 193.883 306.695 193.672 307.023 193.516C307.357 193.359 307.727 193.281 308.133 193.281ZM314.844 193.281C315.859 193.281 316.628 193.531 317.148 194.031C317.669 194.526 317.93 195.323 317.93 196.422V202H316.648V196.508C316.648 195.794 316.484 195.26 316.156 194.906C315.833 194.552 315.336 194.375 314.664 194.375C313.716 194.375 313.049 194.643 312.664 195.18C312.279 195.716 312.086 196.495 312.086 197.516V202H310.789V193.438H311.836L312.031 194.672H312.102C312.284 194.37 312.516 194.117 312.797 193.914C313.078 193.706 313.393 193.549 313.742 193.445C314.091 193.336 314.458 193.281 314.844 193.281Z" fill="black" fill-opacity="0.2" />
    <path d="M273.148 190.578C274.086 190.578 274.859 190.695 275.469 190.93C276.083 191.159 276.542 191.51 276.844 191.984C277.146 192.458 277.297 193.062 277.297 193.797C277.297 194.401 277.188 194.906 276.969 195.312C276.75 195.714 276.464 196.039 276.109 196.289C275.755 196.539 275.378 196.732 274.977 196.867L278.109 202H276.562L273.766 197.234H271.391V202H270.062V190.578H273.148ZM273.07 191.727H271.391V196.109H273.203C274.135 196.109 274.82 195.919 275.258 195.539C275.701 195.159 275.922 194.599 275.922 193.859C275.922 193.083 275.688 192.534 275.219 192.211C274.755 191.888 274.039 191.727 273.07 191.727ZM283.039 193.281C283.768 193.281 284.393 193.443 284.914 193.766C285.435 194.089 285.833 194.542 286.109 195.125C286.385 195.703 286.523 196.38 286.523 197.156V197.961H280.609C280.625 198.966 280.875 199.732 281.359 200.258C281.844 200.784 282.526 201.047 283.406 201.047C283.948 201.047 284.427 200.997 284.844 200.898C285.26 200.799 285.693 200.654 286.141 200.461V201.602C285.708 201.794 285.279 201.935 284.852 202.023C284.43 202.112 283.93 202.156 283.352 202.156C282.529 202.156 281.81 201.99 281.195 201.656C280.586 201.318 280.112 200.823 279.773 200.172C279.435 199.521 279.266 198.724 279.266 197.781C279.266 196.859 279.419 196.062 279.727 195.391C280.039 194.714 280.477 194.193 281.039 193.828C281.607 193.464 282.273 193.281 283.039 193.281ZM283.023 194.344C282.331 194.344 281.779 194.57 281.367 195.023C280.956 195.477 280.711 196.109 280.633 196.922H285.164C285.159 196.411 285.078 195.964 284.922 195.578C284.771 195.188 284.539 194.885 284.227 194.672C283.914 194.453 283.513 194.344 283.023 194.344ZM291.492 201.094C291.706 201.094 291.924 201.076 292.148 201.039C292.372 201.003 292.555 200.958 292.695 200.906V201.914C292.544 201.982 292.333 202.039 292.062 202.086C291.797 202.133 291.536 202.156 291.281 202.156C290.828 202.156 290.417 202.078 290.047 201.922C289.677 201.76 289.38 201.49 289.156 201.109C288.938 200.729 288.828 200.203 288.828 199.531V194.453H287.609V193.82L288.836 193.312L289.352 191.453H290.133V193.438H292.641V194.453H290.133V199.492C290.133 200.029 290.255 200.43 290.5 200.695C290.75 200.961 291.081 201.094 291.492 201.094ZM301.5 193.438V202H300.438L300.25 200.797H300.18C300.003 201.094 299.773 201.344 299.492 201.547C299.211 201.75 298.893 201.901 298.539 202C298.19 202.104 297.818 202.156 297.422 202.156C296.745 202.156 296.177 202.047 295.719 201.828C295.26 201.609 294.914 201.271 294.68 200.812C294.451 200.354 294.336 199.766 294.336 199.047V193.438H295.648V198.953C295.648 199.667 295.81 200.201 296.133 200.555C296.456 200.904 296.948 201.078 297.609 201.078C298.245 201.078 298.75 200.958 299.125 200.719C299.505 200.479 299.779 200.128 299.945 199.664C300.112 199.195 300.195 198.622 300.195 197.945V193.438H301.5ZM308.133 193.281C308.305 193.281 308.484 193.292 308.672 193.312C308.859 193.328 309.026 193.352 309.172 193.383L309.008 194.586C308.867 194.549 308.711 194.521 308.539 194.5C308.367 194.479 308.206 194.469 308.055 194.469C307.711 194.469 307.385 194.539 307.078 194.68C306.776 194.815 306.51 195.013 306.281 195.273C306.052 195.529 305.872 195.839 305.742 196.203C305.612 196.562 305.547 196.964 305.547 197.406V202H304.242V193.438H305.32L305.461 195.016H305.516C305.693 194.698 305.906 194.409 306.156 194.148C306.406 193.883 306.695 193.672 307.023 193.516C307.357 193.359 307.727 193.281 308.133 193.281ZM314.844 193.281C315.859 193.281 316.628 193.531 317.148 194.031C317.669 194.526 317.93 195.323 317.93 196.422V202H316.648V196.508C316.648 195.794 316.484 195.26 316.156 194.906C315.833 194.552 315.336 194.375 314.664 194.375C313.716 194.375 313.049 194.643 312.664 195.18C312.279 195.716 312.086 196.495 312.086 197.516V202H310.789V193.438H311.836L312.031 194.672H312.102C312.284 194.37 312.516 194.117 312.797 193.914C313.078 193.706 313.393 193.549 313.742 193.445C314.091 193.336 314.458 193.281 314.844 193.281Z" fill="black" fill-opacity="0.2" />
    <path d="M273.148 190.578C274.086 190.578 274.859 190.695 275.469 190.93C276.083 191.159 276.542 191.51 276.844 191.984C277.146 192.458 277.297 193.062 277.297 193.797C277.297 194.401 277.188 194.906 276.969 195.312C276.75 195.714 276.464 196.039 276.109 196.289C275.755 196.539 275.378 196.732 274.977 196.867L278.109 202H276.562L273.766 197.234H271.391V202H270.062V190.578H273.148ZM273.07 191.727H271.391V196.109H273.203C274.135 196.109 274.82 195.919 275.258 195.539C275.701 195.159 275.922 194.599 275.922 193.859C275.922 193.083 275.688 192.534 275.219 192.211C274.755 191.888 274.039 191.727 273.07 191.727ZM283.039 193.281C283.768 193.281 284.393 193.443 284.914 193.766C285.435 194.089 285.833 194.542 286.109 195.125C286.385 195.703 286.523 196.38 286.523 197.156V197.961H280.609C280.625 198.966 280.875 199.732 281.359 200.258C281.844 200.784 282.526 201.047 283.406 201.047C283.948 201.047 284.427 200.997 284.844 200.898C285.26 200.799 285.693 200.654 286.141 200.461V201.602C285.708 201.794 285.279 201.935 284.852 202.023C284.43 202.112 283.93 202.156 283.352 202.156C282.529 202.156 281.81 201.99 281.195 201.656C280.586 201.318 280.112 200.823 279.773 200.172C279.435 199.521 279.266 198.724 279.266 197.781C279.266 196.859 279.419 196.062 279.727 195.391C280.039 194.714 280.477 194.193 281.039 193.828C281.607 193.464 282.273 193.281 283.039 193.281ZM283.023 194.344C282.331 194.344 281.779 194.57 281.367 195.023C280.956 195.477 280.711 196.109 280.633 196.922H285.164C285.159 196.411 285.078 195.964 284.922 195.578C284.771 195.188 284.539 194.885 284.227 194.672C283.914 194.453 283.513 194.344 283.023 194.344ZM291.492 201.094C291.706 201.094 291.924 201.076 292.148 201.039C292.372 201.003 292.555 200.958 292.695 200.906V201.914C292.544 201.982 292.333 202.039 292.062 202.086C291.797 202.133 291.536 202.156 291.281 202.156C290.828 202.156 290.417 202.078 290.047 201.922C289.677 201.76 289.38 201.49 289.156 201.109C288.938 200.729 288.828 200.203 288.828 199.531V194.453H287.609V193.82L288.836 193.312L289.352 191.453H290.133V193.438H292.641V194.453H290.133V199.492C290.133 200.029 290.255 200.43 290.5 200.695C290.75 200.961 291.081 201.094 291.492 201.094ZM301.5 193.438V202H300.438L300.25 200.797H300.18C300.003 201.094 299.773 201.344 299.492 201.547C299.211 201.75 298.893 201.901 298.539 202C298.19 202.104 297.818 202.156 297.422 202.156C296.745 202.156 296.177 202.047 295.719 201.828C295.26 201.609 294.914 201.271 294.68 200.812C294.451 200.354 294.336 199.766 294.336 199.047V193.438H295.648V198.953C295.648 199.667 295.81 200.201 296.133 200.555C296.456 200.904 296.948 201.078 297.609 201.078C298.245 201.078 298.75 200.958 299.125 200.719C299.505 200.479 299.779 200.128 299.945 199.664C300.112 199.195 300.195 198.622 300.195 197.945V193.438H301.5ZM308.133 193.281C308.305 193.281 308.484 193.292 308.672 193.312C308.859 193.328 309.026 193.352 309.172 193.383L309.008 194.586C308.867 194.549 308.711 194.521 308.539 194.5C308.367 194.479 308.206 194.469 308.055 194.469C307.711 194.469 307.385 194.539 307.078 194.68C306.776 194.815 306.51 195.013 306.281 195.273C306.052 195.529 305.872 195.839 305.742 196.203C305.612 196.562 305.547 196.964 305.547 197.406V202H304.242V193.438H305.32L305.461 195.016H305.516C305.693 194.698 305.906 194.409 306.156 194.148C306.406 193.883 306.695 193.672 307.023 193.516C307.357 193.359 307.727 193.281 308.133 193.281ZM314.844 193.281C315.859 193.281 316.628 193.531 317.148 194.031C317.669 194.526 317.93 195.323 317.93 196.422V202H316.648V196.508C316.648 195.794 316.484 195.26 316.156 194.906C315.833 194.552 315.336 194.375 314.664 194.375C313.716 194.375 313.049 194.643 312.664 195.18C312.279 195.716 312.086 196.495 312.086 197.516V202H310.789V193.438H311.836L312.031 194.672H312.102C312.284 194.37 312.516 194.117 312.797 193.914C313.078 193.706 313.393 193.549 313.742 193.445C314.091 193.336 314.458 193.281 314.844 193.281Z" fill="black" fill-opacity="0.2" />
    <path d="M487.57 140H486.234V129.75H482.641V128.578H491.148V129.75H487.57V140ZM501.945 134.18C501.945 135.466 501.711 136.542 501.242 137.406C500.773 138.266 500.094 138.914 499.203 139.352C498.318 139.784 497.242 140 495.977 140H492.875V128.578H496.32C497.482 128.578 498.482 128.792 499.32 129.219C500.159 129.641 500.805 130.268 501.258 131.102C501.716 131.93 501.945 132.956 501.945 134.18ZM500.547 134.227C500.547 133.201 500.375 132.354 500.031 131.688C499.693 131.021 499.193 130.526 498.531 130.203C497.875 129.875 497.07 129.711 496.117 129.711H494.203V138.859H495.82C497.393 138.859 498.573 138.471 499.359 137.695C500.151 136.919 500.547 135.763 500.547 134.227ZM510.93 136.961C510.93 137.638 510.76 138.216 510.422 138.695C510.089 139.169 509.62 139.531 509.016 139.781C508.411 140.031 507.701 140.156 506.883 140.156C506.451 140.156 506.042 140.135 505.656 140.094C505.271 140.052 504.917 139.992 504.594 139.914C504.271 139.836 503.987 139.74 503.742 139.625V138.352C504.133 138.513 504.609 138.664 505.172 138.805C505.734 138.94 506.323 139.008 506.938 139.008C507.51 139.008 507.995 138.932 508.391 138.781C508.786 138.625 509.086 138.404 509.289 138.117C509.497 137.826 509.602 137.477 509.602 137.07C509.602 136.68 509.516 136.354 509.344 136.094C509.172 135.828 508.885 135.589 508.484 135.375C508.089 135.156 507.547 134.924 506.859 134.68C506.375 134.508 505.948 134.32 505.578 134.117C505.208 133.909 504.898 133.674 504.648 133.414C504.398 133.154 504.208 132.852 504.078 132.508C503.953 132.164 503.891 131.771 503.891 131.328C503.891 130.719 504.044 130.198 504.352 129.766C504.664 129.328 505.094 128.995 505.641 128.766C506.193 128.531 506.826 128.414 507.539 128.414C508.148 128.414 508.711 128.471 509.227 128.586C509.747 128.701 510.224 128.854 510.656 129.047L510.242 130.188C509.831 130.016 509.393 129.872 508.93 129.758C508.471 129.643 507.997 129.586 507.508 129.586C507.018 129.586 506.604 129.659 506.266 129.805C505.932 129.945 505.677 130.146 505.5 130.406C505.323 130.667 505.234 130.977 505.234 131.336C505.234 131.737 505.318 132.07 505.484 132.336C505.656 132.602 505.927 132.839 506.297 133.047C506.672 133.25 507.167 133.464 507.781 133.688C508.453 133.932 509.023 134.193 509.492 134.469C509.961 134.74 510.318 135.073 510.562 135.469C510.807 135.859 510.93 136.357 510.93 136.961ZM517.398 128.578L513.148 140H511.867L516.125 128.578H517.398ZM522.648 140H521.312V129.75H517.719V128.578H526.227V129.75H522.648V140ZM532.836 129.586C532.206 129.586 531.638 129.695 531.133 129.914C530.633 130.128 530.206 130.44 529.852 130.852C529.503 131.258 529.234 131.75 529.047 132.328C528.859 132.906 528.766 133.557 528.766 134.281C528.766 135.24 528.914 136.073 529.211 136.781C529.513 137.484 529.961 138.029 530.555 138.414C531.154 138.799 531.901 138.992 532.797 138.992C533.307 138.992 533.786 138.951 534.234 138.867C534.688 138.779 535.128 138.669 535.555 138.539V139.695C535.138 139.852 534.701 139.966 534.242 140.039C533.784 140.117 533.24 140.156 532.609 140.156C531.448 140.156 530.477 139.917 529.695 139.438C528.919 138.953 528.336 138.271 527.945 137.391C527.56 136.51 527.367 135.471 527.367 134.273C527.367 133.409 527.487 132.62 527.727 131.906C527.971 131.188 528.326 130.568 528.789 130.047C529.258 129.526 529.831 129.125 530.508 128.844C531.19 128.557 531.971 128.414 532.852 128.414C533.43 128.414 533.987 128.471 534.523 128.586C535.06 128.701 535.544 128.865 535.977 129.078L535.445 130.203C535.081 130.036 534.68 129.893 534.242 129.773C533.81 129.648 533.341 129.586 532.836 129.586ZM544.477 136.961C544.477 137.638 544.307 138.216 543.969 138.695C543.635 139.169 543.167 139.531 542.562 139.781C541.958 140.031 541.247 140.156 540.43 140.156C539.997 140.156 539.589 140.135 539.203 140.094C538.818 140.052 538.464 139.992 538.141 139.914C537.818 139.836 537.534 139.74 537.289 139.625V138.352C537.68 138.513 538.156 138.664 538.719 138.805C539.281 138.94 539.87 139.008 540.484 139.008C541.057 139.008 541.542 138.932 541.938 138.781C542.333 138.625 542.633 138.404 542.836 138.117C543.044 137.826 543.148 137.477 543.148 137.07C543.148 136.68 543.062 136.354 542.891 136.094C542.719 135.828 542.432 135.589 542.031 135.375C541.635 135.156 541.094 134.924 540.406 134.68C539.922 134.508 539.495 134.32 539.125 134.117C538.755 133.909 538.445 133.674 538.195 133.414C537.945 133.154 537.755 132.852 537.625 132.508C537.5 132.164 537.438 131.771 537.438 131.328C537.438 130.719 537.591 130.198 537.898 129.766C538.211 129.328 538.641 128.995 539.188 128.766C539.74 128.531 540.372 128.414 541.086 128.414C541.695 128.414 542.258 128.471 542.773 128.586C543.294 128.701 543.771 128.854 544.203 129.047L543.789 130.188C543.378 130.016 542.94 129.872 542.477 129.758C542.018 129.643 541.544 129.586 541.055 129.586C540.565 129.586 540.151 129.659 539.812 129.805C539.479 129.945 539.224 130.146 539.047 130.406C538.87 130.667 538.781 130.977 538.781 131.336C538.781 131.737 538.865 132.07 539.031 132.336C539.203 132.602 539.474 132.839 539.844 133.047C540.219 133.25 540.714 133.464 541.328 133.688C542 133.932 542.57 134.193 543.039 134.469C543.508 134.74 543.865 135.073 544.109 135.469C544.354 135.859 544.477 136.357 544.477 136.961ZM554.055 128.578C554.992 128.578 555.766 128.695 556.375 128.93C556.99 129.159 557.448 129.51 557.75 129.984C558.052 130.458 558.203 131.062 558.203 131.797C558.203 132.401 558.094 132.906 557.875 133.312C557.656 133.714 557.37 134.039 557.016 134.289C556.661 134.539 556.284 134.732 555.883 134.867L559.016 140H557.469L554.672 135.234H552.297V140H550.969V128.578H554.055ZM553.977 129.727H552.297V134.109H554.109C555.042 134.109 555.727 133.919 556.164 133.539C556.607 133.159 556.828 132.599 556.828 131.859C556.828 131.083 556.594 130.534 556.125 130.211C555.661 129.888 554.945 129.727 553.977 129.727ZM563.945 131.281C564.674 131.281 565.299 131.443 565.82 131.766C566.341 132.089 566.74 132.542 567.016 133.125C567.292 133.703 567.43 134.38 567.43 135.156V135.961H561.516C561.531 136.966 561.781 137.732 562.266 138.258C562.75 138.784 563.432 139.047 564.312 139.047C564.854 139.047 565.333 138.997 565.75 138.898C566.167 138.799 566.599 138.654 567.047 138.461V139.602C566.615 139.794 566.185 139.935 565.758 140.023C565.336 140.112 564.836 140.156 564.258 140.156C563.435 140.156 562.716 139.99 562.102 139.656C561.492 139.318 561.018 138.823 560.68 138.172C560.341 137.521 560.172 136.724 560.172 135.781C560.172 134.859 560.326 134.062 560.633 133.391C560.945 132.714 561.383 132.193 561.945 131.828C562.513 131.464 563.18 131.281 563.945 131.281ZM563.93 132.344C563.237 132.344 562.685 132.57 562.273 133.023C561.862 133.477 561.617 134.109 561.539 134.922H566.07C566.065 134.411 565.984 133.964 565.828 133.578C565.677 133.188 565.445 132.885 565.133 132.672C564.82 132.453 564.419 132.344 563.93 132.344ZM572.398 139.094C572.612 139.094 572.831 139.076 573.055 139.039C573.279 139.003 573.461 138.958 573.602 138.906V139.914C573.451 139.982 573.24 140.039 572.969 140.086C572.703 140.133 572.443 140.156 572.188 140.156C571.734 140.156 571.323 140.078 570.953 139.922C570.583 139.76 570.286 139.49 570.062 139.109C569.844 138.729 569.734 138.203 569.734 137.531V132.453H568.516V131.82L569.742 131.312L570.258 129.453H571.039V131.438H573.547V132.453H571.039V137.492C571.039 138.029 571.161 138.43 571.406 138.695C571.656 138.961 571.987 139.094 572.398 139.094ZM582.406 131.438V140H581.344L581.156 138.797H581.086C580.909 139.094 580.68 139.344 580.398 139.547C580.117 139.75 579.799 139.901 579.445 140C579.096 140.104 578.724 140.156 578.328 140.156C577.651 140.156 577.083 140.047 576.625 139.828C576.167 139.609 575.82 139.271 575.586 138.812C575.357 138.354 575.242 137.766 575.242 137.047V131.438H576.555V136.953C576.555 137.667 576.716 138.201 577.039 138.555C577.362 138.904 577.854 139.078 578.516 139.078C579.151 139.078 579.656 138.958 580.031 138.719C580.411 138.479 580.685 138.128 580.852 137.664C581.018 137.195 581.102 136.622 581.102 135.945V131.438H582.406ZM589.039 131.281C589.211 131.281 589.391 131.292 589.578 131.312C589.766 131.328 589.932 131.352 590.078 131.383L589.914 132.586C589.773 132.549 589.617 132.521 589.445 132.5C589.273 132.479 589.112 132.469 588.961 132.469C588.617 132.469 588.292 132.539 587.984 132.68C587.682 132.815 587.417 133.013 587.188 133.273C586.958 133.529 586.779 133.839 586.648 134.203C586.518 134.562 586.453 134.964 586.453 135.406V140H585.148V131.438H586.227L586.367 133.016H586.422C586.599 132.698 586.812 132.409 587.062 132.148C587.312 131.883 587.602 131.672 587.93 131.516C588.263 131.359 588.633 131.281 589.039 131.281ZM595.75 131.281C596.766 131.281 597.534 131.531 598.055 132.031C598.576 132.526 598.836 133.323 598.836 134.422V140H597.555V134.508C597.555 133.794 597.391 133.26 597.062 132.906C596.74 132.552 596.242 132.375 595.57 132.375C594.622 132.375 593.956 132.643 593.57 133.18C593.185 133.716 592.992 134.495 592.992 135.516V140H591.695V131.438H592.742L592.938 132.672H593.008C593.19 132.37 593.422 132.117 593.703 131.914C593.984 131.706 594.299 131.549 594.648 131.445C594.997 131.336 595.365 131.281 595.75 131.281Z" fill="#0F0F0F" />
    <path d="M487.57 140H486.234V129.75H482.641V128.578H491.148V129.75H487.57V140ZM501.945 134.18C501.945 135.466 501.711 136.542 501.242 137.406C500.773 138.266 500.094 138.914 499.203 139.352C498.318 139.784 497.242 140 495.977 140H492.875V128.578H496.32C497.482 128.578 498.482 128.792 499.32 129.219C500.159 129.641 500.805 130.268 501.258 131.102C501.716 131.93 501.945 132.956 501.945 134.18ZM500.547 134.227C500.547 133.201 500.375 132.354 500.031 131.688C499.693 131.021 499.193 130.526 498.531 130.203C497.875 129.875 497.07 129.711 496.117 129.711H494.203V138.859H495.82C497.393 138.859 498.573 138.471 499.359 137.695C500.151 136.919 500.547 135.763 500.547 134.227ZM510.93 136.961C510.93 137.638 510.76 138.216 510.422 138.695C510.089 139.169 509.62 139.531 509.016 139.781C508.411 140.031 507.701 140.156 506.883 140.156C506.451 140.156 506.042 140.135 505.656 140.094C505.271 140.052 504.917 139.992 504.594 139.914C504.271 139.836 503.987 139.74 503.742 139.625V138.352C504.133 138.513 504.609 138.664 505.172 138.805C505.734 138.94 506.323 139.008 506.938 139.008C507.51 139.008 507.995 138.932 508.391 138.781C508.786 138.625 509.086 138.404 509.289 138.117C509.497 137.826 509.602 137.477 509.602 137.07C509.602 136.68 509.516 136.354 509.344 136.094C509.172 135.828 508.885 135.589 508.484 135.375C508.089 135.156 507.547 134.924 506.859 134.68C506.375 134.508 505.948 134.32 505.578 134.117C505.208 133.909 504.898 133.674 504.648 133.414C504.398 133.154 504.208 132.852 504.078 132.508C503.953 132.164 503.891 131.771 503.891 131.328C503.891 130.719 504.044 130.198 504.352 129.766C504.664 129.328 505.094 128.995 505.641 128.766C506.193 128.531 506.826 128.414 507.539 128.414C508.148 128.414 508.711 128.471 509.227 128.586C509.747 128.701 510.224 128.854 510.656 129.047L510.242 130.188C509.831 130.016 509.393 129.872 508.93 129.758C508.471 129.643 507.997 129.586 507.508 129.586C507.018 129.586 506.604 129.659 506.266 129.805C505.932 129.945 505.677 130.146 505.5 130.406C505.323 130.667 505.234 130.977 505.234 131.336C505.234 131.737 505.318 132.07 505.484 132.336C505.656 132.602 505.927 132.839 506.297 133.047C506.672 133.25 507.167 133.464 507.781 133.688C508.453 133.932 509.023 134.193 509.492 134.469C509.961 134.74 510.318 135.073 510.562 135.469C510.807 135.859 510.93 136.357 510.93 136.961ZM517.398 128.578L513.148 140H511.867L516.125 128.578H517.398ZM522.648 140H521.312V129.75H517.719V128.578H526.227V129.75H522.648V140ZM532.836 129.586C532.206 129.586 531.638 129.695 531.133 129.914C530.633 130.128 530.206 130.44 529.852 130.852C529.503 131.258 529.234 131.75 529.047 132.328C528.859 132.906 528.766 133.557 528.766 134.281C528.766 135.24 528.914 136.073 529.211 136.781C529.513 137.484 529.961 138.029 530.555 138.414C531.154 138.799 531.901 138.992 532.797 138.992C533.307 138.992 533.786 138.951 534.234 138.867C534.688 138.779 535.128 138.669 535.555 138.539V139.695C535.138 139.852 534.701 139.966 534.242 140.039C533.784 140.117 533.24 140.156 532.609 140.156C531.448 140.156 530.477 139.917 529.695 139.438C528.919 138.953 528.336 138.271 527.945 137.391C527.56 136.51 527.367 135.471 527.367 134.273C527.367 133.409 527.487 132.62 527.727 131.906C527.971 131.188 528.326 130.568 528.789 130.047C529.258 129.526 529.831 129.125 530.508 128.844C531.19 128.557 531.971 128.414 532.852 128.414C533.43 128.414 533.987 128.471 534.523 128.586C535.06 128.701 535.544 128.865 535.977 129.078L535.445 130.203C535.081 130.036 534.68 129.893 534.242 129.773C533.81 129.648 533.341 129.586 532.836 129.586ZM544.477 136.961C544.477 137.638 544.307 138.216 543.969 138.695C543.635 139.169 543.167 139.531 542.562 139.781C541.958 140.031 541.247 140.156 540.43 140.156C539.997 140.156 539.589 140.135 539.203 140.094C538.818 140.052 538.464 139.992 538.141 139.914C537.818 139.836 537.534 139.74 537.289 139.625V138.352C537.68 138.513 538.156 138.664 538.719 138.805C539.281 138.94 539.87 139.008 540.484 139.008C541.057 139.008 541.542 138.932 541.938 138.781C542.333 138.625 542.633 138.404 542.836 138.117C543.044 137.826 543.148 137.477 543.148 137.07C543.148 136.68 543.062 136.354 542.891 136.094C542.719 135.828 542.432 135.589 542.031 135.375C541.635 135.156 541.094 134.924 540.406 134.68C539.922 134.508 539.495 134.32 539.125 134.117C538.755 133.909 538.445 133.674 538.195 133.414C537.945 133.154 537.755 132.852 537.625 132.508C537.5 132.164 537.438 131.771 537.438 131.328C537.438 130.719 537.591 130.198 537.898 129.766C538.211 129.328 538.641 128.995 539.188 128.766C539.74 128.531 540.372 128.414 541.086 128.414C541.695 128.414 542.258 128.471 542.773 128.586C543.294 128.701 543.771 128.854 544.203 129.047L543.789 130.188C543.378 130.016 542.94 129.872 542.477 129.758C542.018 129.643 541.544 129.586 541.055 129.586C540.565 129.586 540.151 129.659 539.812 129.805C539.479 129.945 539.224 130.146 539.047 130.406C538.87 130.667 538.781 130.977 538.781 131.336C538.781 131.737 538.865 132.07 539.031 132.336C539.203 132.602 539.474 132.839 539.844 133.047C540.219 133.25 540.714 133.464 541.328 133.688C542 133.932 542.57 134.193 543.039 134.469C543.508 134.74 543.865 135.073 544.109 135.469C544.354 135.859 544.477 136.357 544.477 136.961ZM554.055 128.578C554.992 128.578 555.766 128.695 556.375 128.93C556.99 129.159 557.448 129.51 557.75 129.984C558.052 130.458 558.203 131.062 558.203 131.797C558.203 132.401 558.094 132.906 557.875 133.312C557.656 133.714 557.37 134.039 557.016 134.289C556.661 134.539 556.284 134.732 555.883 134.867L559.016 140H557.469L554.672 135.234H552.297V140H550.969V128.578H554.055ZM553.977 129.727H552.297V134.109H554.109C555.042 134.109 555.727 133.919 556.164 133.539C556.607 133.159 556.828 132.599 556.828 131.859C556.828 131.083 556.594 130.534 556.125 130.211C555.661 129.888 554.945 129.727 553.977 129.727ZM563.945 131.281C564.674 131.281 565.299 131.443 565.82 131.766C566.341 132.089 566.74 132.542 567.016 133.125C567.292 133.703 567.43 134.38 567.43 135.156V135.961H561.516C561.531 136.966 561.781 137.732 562.266 138.258C562.75 138.784 563.432 139.047 564.312 139.047C564.854 139.047 565.333 138.997 565.75 138.898C566.167 138.799 566.599 138.654 567.047 138.461V139.602C566.615 139.794 566.185 139.935 565.758 140.023C565.336 140.112 564.836 140.156 564.258 140.156C563.435 140.156 562.716 139.99 562.102 139.656C561.492 139.318 561.018 138.823 560.68 138.172C560.341 137.521 560.172 136.724 560.172 135.781C560.172 134.859 560.326 134.062 560.633 133.391C560.945 132.714 561.383 132.193 561.945 131.828C562.513 131.464 563.18 131.281 563.945 131.281ZM563.93 132.344C563.237 132.344 562.685 132.57 562.273 133.023C561.862 133.477 561.617 134.109 561.539 134.922H566.07C566.065 134.411 565.984 133.964 565.828 133.578C565.677 133.188 565.445 132.885 565.133 132.672C564.82 132.453 564.419 132.344 563.93 132.344ZM572.398 139.094C572.612 139.094 572.831 139.076 573.055 139.039C573.279 139.003 573.461 138.958 573.602 138.906V139.914C573.451 139.982 573.24 140.039 572.969 140.086C572.703 140.133 572.443 140.156 572.188 140.156C571.734 140.156 571.323 140.078 570.953 139.922C570.583 139.76 570.286 139.49 570.062 139.109C569.844 138.729 569.734 138.203 569.734 137.531V132.453H568.516V131.82L569.742 131.312L570.258 129.453H571.039V131.438H573.547V132.453H571.039V137.492C571.039 138.029 571.161 138.43 571.406 138.695C571.656 138.961 571.987 139.094 572.398 139.094ZM582.406 131.438V140H581.344L581.156 138.797H581.086C580.909 139.094 580.68 139.344 580.398 139.547C580.117 139.75 579.799 139.901 579.445 140C579.096 140.104 578.724 140.156 578.328 140.156C577.651 140.156 577.083 140.047 576.625 139.828C576.167 139.609 575.82 139.271 575.586 138.812C575.357 138.354 575.242 137.766 575.242 137.047V131.438H576.555V136.953C576.555 137.667 576.716 138.201 577.039 138.555C577.362 138.904 577.854 139.078 578.516 139.078C579.151 139.078 579.656 138.958 580.031 138.719C580.411 138.479 580.685 138.128 580.852 137.664C581.018 137.195 581.102 136.622 581.102 135.945V131.438H582.406ZM589.039 131.281C589.211 131.281 589.391 131.292 589.578 131.312C589.766 131.328 589.932 131.352 590.078 131.383L589.914 132.586C589.773 132.549 589.617 132.521 589.445 132.5C589.273 132.479 589.112 132.469 588.961 132.469C588.617 132.469 588.292 132.539 587.984 132.68C587.682 132.815 587.417 133.013 587.188 133.273C586.958 133.529 586.779 133.839 586.648 134.203C586.518 134.562 586.453 134.964 586.453 135.406V140H585.148V131.438H586.227L586.367 133.016H586.422C586.599 132.698 586.812 132.409 587.062 132.148C587.312 131.883 587.602 131.672 587.93 131.516C588.263 131.359 588.633 131.281 589.039 131.281ZM595.75 131.281C596.766 131.281 597.534 131.531 598.055 132.031C598.576 132.526 598.836 133.323 598.836 134.422V140H597.555V134.508C597.555 133.794 597.391 133.26 597.062 132.906C596.74 132.552 596.242 132.375 595.57 132.375C594.622 132.375 593.956 132.643 593.57 133.18C593.185 133.716 592.992 134.495 592.992 135.516V140H591.695V131.438H592.742L592.938 132.672H593.008C593.19 132.37 593.422 132.117 593.703 131.914C593.984 131.706 594.299 131.549 594.648 131.445C594.997 131.336 595.365 131.281 595.75 131.281Z" fill="black" fill-opacity="0.2" />
    <path d="M487.57 140H486.234V129.75H482.641V128.578H491.148V129.75H487.57V140ZM501.945 134.18C501.945 135.466 501.711 136.542 501.242 137.406C500.773 138.266 500.094 138.914 499.203 139.352C498.318 139.784 497.242 140 495.977 140H492.875V128.578H496.32C497.482 128.578 498.482 128.792 499.32 129.219C500.159 129.641 500.805 130.268 501.258 131.102C501.716 131.93 501.945 132.956 501.945 134.18ZM500.547 134.227C500.547 133.201 500.375 132.354 500.031 131.688C499.693 131.021 499.193 130.526 498.531 130.203C497.875 129.875 497.07 129.711 496.117 129.711H494.203V138.859H495.82C497.393 138.859 498.573 138.471 499.359 137.695C500.151 136.919 500.547 135.763 500.547 134.227ZM510.93 136.961C510.93 137.638 510.76 138.216 510.422 138.695C510.089 139.169 509.62 139.531 509.016 139.781C508.411 140.031 507.701 140.156 506.883 140.156C506.451 140.156 506.042 140.135 505.656 140.094C505.271 140.052 504.917 139.992 504.594 139.914C504.271 139.836 503.987 139.74 503.742 139.625V138.352C504.133 138.513 504.609 138.664 505.172 138.805C505.734 138.94 506.323 139.008 506.938 139.008C507.51 139.008 507.995 138.932 508.391 138.781C508.786 138.625 509.086 138.404 509.289 138.117C509.497 137.826 509.602 137.477 509.602 137.07C509.602 136.68 509.516 136.354 509.344 136.094C509.172 135.828 508.885 135.589 508.484 135.375C508.089 135.156 507.547 134.924 506.859 134.68C506.375 134.508 505.948 134.32 505.578 134.117C505.208 133.909 504.898 133.674 504.648 133.414C504.398 133.154 504.208 132.852 504.078 132.508C503.953 132.164 503.891 131.771 503.891 131.328C503.891 130.719 504.044 130.198 504.352 129.766C504.664 129.328 505.094 128.995 505.641 128.766C506.193 128.531 506.826 128.414 507.539 128.414C508.148 128.414 508.711 128.471 509.227 128.586C509.747 128.701 510.224 128.854 510.656 129.047L510.242 130.188C509.831 130.016 509.393 129.872 508.93 129.758C508.471 129.643 507.997 129.586 507.508 129.586C507.018 129.586 506.604 129.659 506.266 129.805C505.932 129.945 505.677 130.146 505.5 130.406C505.323 130.667 505.234 130.977 505.234 131.336C505.234 131.737 505.318 132.07 505.484 132.336C505.656 132.602 505.927 132.839 506.297 133.047C506.672 133.25 507.167 133.464 507.781 133.688C508.453 133.932 509.023 134.193 509.492 134.469C509.961 134.74 510.318 135.073 510.562 135.469C510.807 135.859 510.93 136.357 510.93 136.961ZM517.398 128.578L513.148 140H511.867L516.125 128.578H517.398ZM522.648 140H521.312V129.75H517.719V128.578H526.227V129.75H522.648V140ZM532.836 129.586C532.206 129.586 531.638 129.695 531.133 129.914C530.633 130.128 530.206 130.44 529.852 130.852C529.503 131.258 529.234 131.75 529.047 132.328C528.859 132.906 528.766 133.557 528.766 134.281C528.766 135.24 528.914 136.073 529.211 136.781C529.513 137.484 529.961 138.029 530.555 138.414C531.154 138.799 531.901 138.992 532.797 138.992C533.307 138.992 533.786 138.951 534.234 138.867C534.688 138.779 535.128 138.669 535.555 138.539V139.695C535.138 139.852 534.701 139.966 534.242 140.039C533.784 140.117 533.24 140.156 532.609 140.156C531.448 140.156 530.477 139.917 529.695 139.438C528.919 138.953 528.336 138.271 527.945 137.391C527.56 136.51 527.367 135.471 527.367 134.273C527.367 133.409 527.487 132.62 527.727 131.906C527.971 131.188 528.326 130.568 528.789 130.047C529.258 129.526 529.831 129.125 530.508 128.844C531.19 128.557 531.971 128.414 532.852 128.414C533.43 128.414 533.987 128.471 534.523 128.586C535.06 128.701 535.544 128.865 535.977 129.078L535.445 130.203C535.081 130.036 534.68 129.893 534.242 129.773C533.81 129.648 533.341 129.586 532.836 129.586ZM544.477 136.961C544.477 137.638 544.307 138.216 543.969 138.695C543.635 139.169 543.167 139.531 542.562 139.781C541.958 140.031 541.247 140.156 540.43 140.156C539.997 140.156 539.589 140.135 539.203 140.094C538.818 140.052 538.464 139.992 538.141 139.914C537.818 139.836 537.534 139.74 537.289 139.625V138.352C537.68 138.513 538.156 138.664 538.719 138.805C539.281 138.94 539.87 139.008 540.484 139.008C541.057 139.008 541.542 138.932 541.938 138.781C542.333 138.625 542.633 138.404 542.836 138.117C543.044 137.826 543.148 137.477 543.148 137.07C543.148 136.68 543.062 136.354 542.891 136.094C542.719 135.828 542.432 135.589 542.031 135.375C541.635 135.156 541.094 134.924 540.406 134.68C539.922 134.508 539.495 134.32 539.125 134.117C538.755 133.909 538.445 133.674 538.195 133.414C537.945 133.154 537.755 132.852 537.625 132.508C537.5 132.164 537.438 131.771 537.438 131.328C537.438 130.719 537.591 130.198 537.898 129.766C538.211 129.328 538.641 128.995 539.188 128.766C539.74 128.531 540.372 128.414 541.086 128.414C541.695 128.414 542.258 128.471 542.773 128.586C543.294 128.701 543.771 128.854 544.203 129.047L543.789 130.188C543.378 130.016 542.94 129.872 542.477 129.758C542.018 129.643 541.544 129.586 541.055 129.586C540.565 129.586 540.151 129.659 539.812 129.805C539.479 129.945 539.224 130.146 539.047 130.406C538.87 130.667 538.781 130.977 538.781 131.336C538.781 131.737 538.865 132.07 539.031 132.336C539.203 132.602 539.474 132.839 539.844 133.047C540.219 133.25 540.714 133.464 541.328 133.688C542 133.932 542.57 134.193 543.039 134.469C543.508 134.74 543.865 135.073 544.109 135.469C544.354 135.859 544.477 136.357 544.477 136.961ZM554.055 128.578C554.992 128.578 555.766 128.695 556.375 128.93C556.99 129.159 557.448 129.51 557.75 129.984C558.052 130.458 558.203 131.062 558.203 131.797C558.203 132.401 558.094 132.906 557.875 133.312C557.656 133.714 557.37 134.039 557.016 134.289C556.661 134.539 556.284 134.732 555.883 134.867L559.016 140H557.469L554.672 135.234H552.297V140H550.969V128.578H554.055ZM553.977 129.727H552.297V134.109H554.109C555.042 134.109 555.727 133.919 556.164 133.539C556.607 133.159 556.828 132.599 556.828 131.859C556.828 131.083 556.594 130.534 556.125 130.211C555.661 129.888 554.945 129.727 553.977 129.727ZM563.945 131.281C564.674 131.281 565.299 131.443 565.82 131.766C566.341 132.089 566.74 132.542 567.016 133.125C567.292 133.703 567.43 134.38 567.43 135.156V135.961H561.516C561.531 136.966 561.781 137.732 562.266 138.258C562.75 138.784 563.432 139.047 564.312 139.047C564.854 139.047 565.333 138.997 565.75 138.898C566.167 138.799 566.599 138.654 567.047 138.461V139.602C566.615 139.794 566.185 139.935 565.758 140.023C565.336 140.112 564.836 140.156 564.258 140.156C563.435 140.156 562.716 139.99 562.102 139.656C561.492 139.318 561.018 138.823 560.68 138.172C560.341 137.521 560.172 136.724 560.172 135.781C560.172 134.859 560.326 134.062 560.633 133.391C560.945 132.714 561.383 132.193 561.945 131.828C562.513 131.464 563.18 131.281 563.945 131.281ZM563.93 132.344C563.237 132.344 562.685 132.57 562.273 133.023C561.862 133.477 561.617 134.109 561.539 134.922H566.07C566.065 134.411 565.984 133.964 565.828 133.578C565.677 133.188 565.445 132.885 565.133 132.672C564.82 132.453 564.419 132.344 563.93 132.344ZM572.398 139.094C572.612 139.094 572.831 139.076 573.055 139.039C573.279 139.003 573.461 138.958 573.602 138.906V139.914C573.451 139.982 573.24 140.039 572.969 140.086C572.703 140.133 572.443 140.156 572.188 140.156C571.734 140.156 571.323 140.078 570.953 139.922C570.583 139.76 570.286 139.49 570.062 139.109C569.844 138.729 569.734 138.203 569.734 137.531V132.453H568.516V131.82L569.742 131.312L570.258 129.453H571.039V131.438H573.547V132.453H571.039V137.492C571.039 138.029 571.161 138.43 571.406 138.695C571.656 138.961 571.987 139.094 572.398 139.094ZM582.406 131.438V140H581.344L581.156 138.797H581.086C580.909 139.094 580.68 139.344 580.398 139.547C580.117 139.75 579.799 139.901 579.445 140C579.096 140.104 578.724 140.156 578.328 140.156C577.651 140.156 577.083 140.047 576.625 139.828C576.167 139.609 575.82 139.271 575.586 138.812C575.357 138.354 575.242 137.766 575.242 137.047V131.438H576.555V136.953C576.555 137.667 576.716 138.201 577.039 138.555C577.362 138.904 577.854 139.078 578.516 139.078C579.151 139.078 579.656 138.958 580.031 138.719C580.411 138.479 580.685 138.128 580.852 137.664C581.018 137.195 581.102 136.622 581.102 135.945V131.438H582.406ZM589.039 131.281C589.211 131.281 589.391 131.292 589.578 131.312C589.766 131.328 589.932 131.352 590.078 131.383L589.914 132.586C589.773 132.549 589.617 132.521 589.445 132.5C589.273 132.479 589.112 132.469 588.961 132.469C588.617 132.469 588.292 132.539 587.984 132.68C587.682 132.815 587.417 133.013 587.188 133.273C586.958 133.529 586.779 133.839 586.648 134.203C586.518 134.562 586.453 134.964 586.453 135.406V140H585.148V131.438H586.227L586.367 133.016H586.422C586.599 132.698 586.812 132.409 587.062 132.148C587.312 131.883 587.602 131.672 587.93 131.516C588.263 131.359 588.633 131.281 589.039 131.281ZM595.75 131.281C596.766 131.281 597.534 131.531 598.055 132.031C598.576 132.526 598.836 133.323 598.836 134.422V140H597.555V134.508C597.555 133.794 597.391 133.26 597.062 132.906C596.74 132.552 596.242 132.375 595.57 132.375C594.622 132.375 593.956 132.643 593.57 133.18C593.185 133.716 592.992 134.495 592.992 135.516V140H591.695V131.438H592.742L592.938 132.672H593.008C593.19 132.37 593.422 132.117 593.703 131.914C593.984 131.706 594.299 131.549 594.648 131.445C594.997 131.336 595.365 131.281 595.75 131.281Z" fill="black" fill-opacity="0.2" />
    <path d="M487.57 140H486.234V129.75H482.641V128.578H491.148V129.75H487.57V140ZM501.945 134.18C501.945 135.466 501.711 136.542 501.242 137.406C500.773 138.266 500.094 138.914 499.203 139.352C498.318 139.784 497.242 140 495.977 140H492.875V128.578H496.32C497.482 128.578 498.482 128.792 499.32 129.219C500.159 129.641 500.805 130.268 501.258 131.102C501.716 131.93 501.945 132.956 501.945 134.18ZM500.547 134.227C500.547 133.201 500.375 132.354 500.031 131.688C499.693 131.021 499.193 130.526 498.531 130.203C497.875 129.875 497.07 129.711 496.117 129.711H494.203V138.859H495.82C497.393 138.859 498.573 138.471 499.359 137.695C500.151 136.919 500.547 135.763 500.547 134.227ZM510.93 136.961C510.93 137.638 510.76 138.216 510.422 138.695C510.089 139.169 509.62 139.531 509.016 139.781C508.411 140.031 507.701 140.156 506.883 140.156C506.451 140.156 506.042 140.135 505.656 140.094C505.271 140.052 504.917 139.992 504.594 139.914C504.271 139.836 503.987 139.74 503.742 139.625V138.352C504.133 138.513 504.609 138.664 505.172 138.805C505.734 138.94 506.323 139.008 506.938 139.008C507.51 139.008 507.995 138.932 508.391 138.781C508.786 138.625 509.086 138.404 509.289 138.117C509.497 137.826 509.602 137.477 509.602 137.07C509.602 136.68 509.516 136.354 509.344 136.094C509.172 135.828 508.885 135.589 508.484 135.375C508.089 135.156 507.547 134.924 506.859 134.68C506.375 134.508 505.948 134.32 505.578 134.117C505.208 133.909 504.898 133.674 504.648 133.414C504.398 133.154 504.208 132.852 504.078 132.508C503.953 132.164 503.891 131.771 503.891 131.328C503.891 130.719 504.044 130.198 504.352 129.766C504.664 129.328 505.094 128.995 505.641 128.766C506.193 128.531 506.826 128.414 507.539 128.414C508.148 128.414 508.711 128.471 509.227 128.586C509.747 128.701 510.224 128.854 510.656 129.047L510.242 130.188C509.831 130.016 509.393 129.872 508.93 129.758C508.471 129.643 507.997 129.586 507.508 129.586C507.018 129.586 506.604 129.659 506.266 129.805C505.932 129.945 505.677 130.146 505.5 130.406C505.323 130.667 505.234 130.977 505.234 131.336C505.234 131.737 505.318 132.07 505.484 132.336C505.656 132.602 505.927 132.839 506.297 133.047C506.672 133.25 507.167 133.464 507.781 133.688C508.453 133.932 509.023 134.193 509.492 134.469C509.961 134.74 510.318 135.073 510.562 135.469C510.807 135.859 510.93 136.357 510.93 136.961ZM517.398 128.578L513.148 140H511.867L516.125 128.578H517.398ZM522.648 140H521.312V129.75H517.719V128.578H526.227V129.75H522.648V140ZM532.836 129.586C532.206 129.586 531.638 129.695 531.133 129.914C530.633 130.128 530.206 130.44 529.852 130.852C529.503 131.258 529.234 131.75 529.047 132.328C528.859 132.906 528.766 133.557 528.766 134.281C528.766 135.24 528.914 136.073 529.211 136.781C529.513 137.484 529.961 138.029 530.555 138.414C531.154 138.799 531.901 138.992 532.797 138.992C533.307 138.992 533.786 138.951 534.234 138.867C534.688 138.779 535.128 138.669 535.555 138.539V139.695C535.138 139.852 534.701 139.966 534.242 140.039C533.784 140.117 533.24 140.156 532.609 140.156C531.448 140.156 530.477 139.917 529.695 139.438C528.919 138.953 528.336 138.271 527.945 137.391C527.56 136.51 527.367 135.471 527.367 134.273C527.367 133.409 527.487 132.62 527.727 131.906C527.971 131.188 528.326 130.568 528.789 130.047C529.258 129.526 529.831 129.125 530.508 128.844C531.19 128.557 531.971 128.414 532.852 128.414C533.43 128.414 533.987 128.471 534.523 128.586C535.06 128.701 535.544 128.865 535.977 129.078L535.445 130.203C535.081 130.036 534.68 129.893 534.242 129.773C533.81 129.648 533.341 129.586 532.836 129.586ZM544.477 136.961C544.477 137.638 544.307 138.216 543.969 138.695C543.635 139.169 543.167 139.531 542.562 139.781C541.958 140.031 541.247 140.156 540.43 140.156C539.997 140.156 539.589 140.135 539.203 140.094C538.818 140.052 538.464 139.992 538.141 139.914C537.818 139.836 537.534 139.74 537.289 139.625V138.352C537.68 138.513 538.156 138.664 538.719 138.805C539.281 138.94 539.87 139.008 540.484 139.008C541.057 139.008 541.542 138.932 541.938 138.781C542.333 138.625 542.633 138.404 542.836 138.117C543.044 137.826 543.148 137.477 543.148 137.07C543.148 136.68 543.062 136.354 542.891 136.094C542.719 135.828 542.432 135.589 542.031 135.375C541.635 135.156 541.094 134.924 540.406 134.68C539.922 134.508 539.495 134.32 539.125 134.117C538.755 133.909 538.445 133.674 538.195 133.414C537.945 133.154 537.755 132.852 537.625 132.508C537.5 132.164 537.438 131.771 537.438 131.328C537.438 130.719 537.591 130.198 537.898 129.766C538.211 129.328 538.641 128.995 539.188 128.766C539.74 128.531 540.372 128.414 541.086 128.414C541.695 128.414 542.258 128.471 542.773 128.586C543.294 128.701 543.771 128.854 544.203 129.047L543.789 130.188C543.378 130.016 542.94 129.872 542.477 129.758C542.018 129.643 541.544 129.586 541.055 129.586C540.565 129.586 540.151 129.659 539.812 129.805C539.479 129.945 539.224 130.146 539.047 130.406C538.87 130.667 538.781 130.977 538.781 131.336C538.781 131.737 538.865 132.07 539.031 132.336C539.203 132.602 539.474 132.839 539.844 133.047C540.219 133.25 540.714 133.464 541.328 133.688C542 133.932 542.57 134.193 543.039 134.469C543.508 134.74 543.865 135.073 544.109 135.469C544.354 135.859 544.477 136.357 544.477 136.961ZM554.055 128.578C554.992 128.578 555.766 128.695 556.375 128.93C556.99 129.159 557.448 129.51 557.75 129.984C558.052 130.458 558.203 131.062 558.203 131.797C558.203 132.401 558.094 132.906 557.875 133.312C557.656 133.714 557.37 134.039 557.016 134.289C556.661 134.539 556.284 134.732 555.883 134.867L559.016 140H557.469L554.672 135.234H552.297V140H550.969V128.578H554.055ZM553.977 129.727H552.297V134.109H554.109C555.042 134.109 555.727 133.919 556.164 133.539C556.607 133.159 556.828 132.599 556.828 131.859C556.828 131.083 556.594 130.534 556.125 130.211C555.661 129.888 554.945 129.727 553.977 129.727ZM563.945 131.281C564.674 131.281 565.299 131.443 565.82 131.766C566.341 132.089 566.74 132.542 567.016 133.125C567.292 133.703 567.43 134.38 567.43 135.156V135.961H561.516C561.531 136.966 561.781 137.732 562.266 138.258C562.75 138.784 563.432 139.047 564.312 139.047C564.854 139.047 565.333 138.997 565.75 138.898C566.167 138.799 566.599 138.654 567.047 138.461V139.602C566.615 139.794 566.185 139.935 565.758 140.023C565.336 140.112 564.836 140.156 564.258 140.156C563.435 140.156 562.716 139.99 562.102 139.656C561.492 139.318 561.018 138.823 560.68 138.172C560.341 137.521 560.172 136.724 560.172 135.781C560.172 134.859 560.326 134.062 560.633 133.391C560.945 132.714 561.383 132.193 561.945 131.828C562.513 131.464 563.18 131.281 563.945 131.281ZM563.93 132.344C563.237 132.344 562.685 132.57 562.273 133.023C561.862 133.477 561.617 134.109 561.539 134.922H566.07C566.065 134.411 565.984 133.964 565.828 133.578C565.677 133.188 565.445 132.885 565.133 132.672C564.82 132.453 564.419 132.344 563.93 132.344ZM572.398 139.094C572.612 139.094 572.831 139.076 573.055 139.039C573.279 139.003 573.461 138.958 573.602 138.906V139.914C573.451 139.982 573.24 140.039 572.969 140.086C572.703 140.133 572.443 140.156 572.188 140.156C571.734 140.156 571.323 140.078 570.953 139.922C570.583 139.76 570.286 139.49 570.062 139.109C569.844 138.729 569.734 138.203 569.734 137.531V132.453H568.516V131.82L569.742 131.312L570.258 129.453H571.039V131.438H573.547V132.453H571.039V137.492C571.039 138.029 571.161 138.43 571.406 138.695C571.656 138.961 571.987 139.094 572.398 139.094ZM582.406 131.438V140H581.344L581.156 138.797H581.086C580.909 139.094 580.68 139.344 580.398 139.547C580.117 139.75 579.799 139.901 579.445 140C579.096 140.104 578.724 140.156 578.328 140.156C577.651 140.156 577.083 140.047 576.625 139.828C576.167 139.609 575.82 139.271 575.586 138.812C575.357 138.354 575.242 137.766 575.242 137.047V131.438H576.555V136.953C576.555 137.667 576.716 138.201 577.039 138.555C577.362 138.904 577.854 139.078 578.516 139.078C579.151 139.078 579.656 138.958 580.031 138.719C580.411 138.479 580.685 138.128 580.852 137.664C581.018 137.195 581.102 136.622 581.102 135.945V131.438H582.406ZM589.039 131.281C589.211 131.281 589.391 131.292 589.578 131.312C589.766 131.328 589.932 131.352 590.078 131.383L589.914 132.586C589.773 132.549 589.617 132.521 589.445 132.5C589.273 132.479 589.112 132.469 588.961 132.469C588.617 132.469 588.292 132.539 587.984 132.68C587.682 132.815 587.417 133.013 587.188 133.273C586.958 133.529 586.779 133.839 586.648 134.203C586.518 134.562 586.453 134.964 586.453 135.406V140H585.148V131.438H586.227L586.367 133.016H586.422C586.599 132.698 586.812 132.409 587.062 132.148C587.312 131.883 587.602 131.672 587.93 131.516C588.263 131.359 588.633 131.281 589.039 131.281ZM595.75 131.281C596.766 131.281 597.534 131.531 598.055 132.031C598.576 132.526 598.836 133.323 598.836 134.422V140H597.555V134.508C597.555 133.794 597.391 133.26 597.062 132.906C596.74 132.552 596.242 132.375 595.57 132.375C594.622 132.375 593.956 132.643 593.57 133.18C593.185 133.716 592.992 134.495 592.992 135.516V140H591.695V131.438H592.742L592.938 132.672H593.008C593.19 132.37 593.422 132.117 593.703 131.914C593.984 131.706 594.299 131.549 594.648 131.445C594.997 131.336 595.365 131.281 595.75 131.281Z" fill="black" fill-opacity="0.2" />
    <path d="M487.57 140H486.234V129.75H482.641V128.578H491.148V129.75H487.57V140ZM501.945 134.18C501.945 135.466 501.711 136.542 501.242 137.406C500.773 138.266 500.094 138.914 499.203 139.352C498.318 139.784 497.242 140 495.977 140H492.875V128.578H496.32C497.482 128.578 498.482 128.792 499.32 129.219C500.159 129.641 500.805 130.268 501.258 131.102C501.716 131.93 501.945 132.956 501.945 134.18ZM500.547 134.227C500.547 133.201 500.375 132.354 500.031 131.688C499.693 131.021 499.193 130.526 498.531 130.203C497.875 129.875 497.07 129.711 496.117 129.711H494.203V138.859H495.82C497.393 138.859 498.573 138.471 499.359 137.695C500.151 136.919 500.547 135.763 500.547 134.227ZM510.93 136.961C510.93 137.638 510.76 138.216 510.422 138.695C510.089 139.169 509.62 139.531 509.016 139.781C508.411 140.031 507.701 140.156 506.883 140.156C506.451 140.156 506.042 140.135 505.656 140.094C505.271 140.052 504.917 139.992 504.594 139.914C504.271 139.836 503.987 139.74 503.742 139.625V138.352C504.133 138.513 504.609 138.664 505.172 138.805C505.734 138.94 506.323 139.008 506.938 139.008C507.51 139.008 507.995 138.932 508.391 138.781C508.786 138.625 509.086 138.404 509.289 138.117C509.497 137.826 509.602 137.477 509.602 137.07C509.602 136.68 509.516 136.354 509.344 136.094C509.172 135.828 508.885 135.589 508.484 135.375C508.089 135.156 507.547 134.924 506.859 134.68C506.375 134.508 505.948 134.32 505.578 134.117C505.208 133.909 504.898 133.674 504.648 133.414C504.398 133.154 504.208 132.852 504.078 132.508C503.953 132.164 503.891 131.771 503.891 131.328C503.891 130.719 504.044 130.198 504.352 129.766C504.664 129.328 505.094 128.995 505.641 128.766C506.193 128.531 506.826 128.414 507.539 128.414C508.148 128.414 508.711 128.471 509.227 128.586C509.747 128.701 510.224 128.854 510.656 129.047L510.242 130.188C509.831 130.016 509.393 129.872 508.93 129.758C508.471 129.643 507.997 129.586 507.508 129.586C507.018 129.586 506.604 129.659 506.266 129.805C505.932 129.945 505.677 130.146 505.5 130.406C505.323 130.667 505.234 130.977 505.234 131.336C505.234 131.737 505.318 132.07 505.484 132.336C505.656 132.602 505.927 132.839 506.297 133.047C506.672 133.25 507.167 133.464 507.781 133.688C508.453 133.932 509.023 134.193 509.492 134.469C509.961 134.74 510.318 135.073 510.562 135.469C510.807 135.859 510.93 136.357 510.93 136.961ZM517.398 128.578L513.148 140H511.867L516.125 128.578H517.398ZM522.648 140H521.312V129.75H517.719V128.578H526.227V129.75H522.648V140ZM532.836 129.586C532.206 129.586 531.638 129.695 531.133 129.914C530.633 130.128 530.206 130.44 529.852 130.852C529.503 131.258 529.234 131.75 529.047 132.328C528.859 132.906 528.766 133.557 528.766 134.281C528.766 135.24 528.914 136.073 529.211 136.781C529.513 137.484 529.961 138.029 530.555 138.414C531.154 138.799 531.901 138.992 532.797 138.992C533.307 138.992 533.786 138.951 534.234 138.867C534.688 138.779 535.128 138.669 535.555 138.539V139.695C535.138 139.852 534.701 139.966 534.242 140.039C533.784 140.117 533.24 140.156 532.609 140.156C531.448 140.156 530.477 139.917 529.695 139.438C528.919 138.953 528.336 138.271 527.945 137.391C527.56 136.51 527.367 135.471 527.367 134.273C527.367 133.409 527.487 132.62 527.727 131.906C527.971 131.188 528.326 130.568 528.789 130.047C529.258 129.526 529.831 129.125 530.508 128.844C531.19 128.557 531.971 128.414 532.852 128.414C533.43 128.414 533.987 128.471 534.523 128.586C535.06 128.701 535.544 128.865 535.977 129.078L535.445 130.203C535.081 130.036 534.68 129.893 534.242 129.773C533.81 129.648 533.341 129.586 532.836 129.586ZM544.477 136.961C544.477 137.638 544.307 138.216 543.969 138.695C543.635 139.169 543.167 139.531 542.562 139.781C541.958 140.031 541.247 140.156 540.43 140.156C539.997 140.156 539.589 140.135 539.203 140.094C538.818 140.052 538.464 139.992 538.141 139.914C537.818 139.836 537.534 139.74 537.289 139.625V138.352C537.68 138.513 538.156 138.664 538.719 138.805C539.281 138.94 539.87 139.008 540.484 139.008C541.057 139.008 541.542 138.932 541.938 138.781C542.333 138.625 542.633 138.404 542.836 138.117C543.044 137.826 543.148 137.477 543.148 137.07C543.148 136.68 543.062 136.354 542.891 136.094C542.719 135.828 542.432 135.589 542.031 135.375C541.635 135.156 541.094 134.924 540.406 134.68C539.922 134.508 539.495 134.32 539.125 134.117C538.755 133.909 538.445 133.674 538.195 133.414C537.945 133.154 537.755 132.852 537.625 132.508C537.5 132.164 537.438 131.771 537.438 131.328C537.438 130.719 537.591 130.198 537.898 129.766C538.211 129.328 538.641 128.995 539.188 128.766C539.74 128.531 540.372 128.414 541.086 128.414C541.695 128.414 542.258 128.471 542.773 128.586C543.294 128.701 543.771 128.854 544.203 129.047L543.789 130.188C543.378 130.016 542.94 129.872 542.477 129.758C542.018 129.643 541.544 129.586 541.055 129.586C540.565 129.586 540.151 129.659 539.812 129.805C539.479 129.945 539.224 130.146 539.047 130.406C538.87 130.667 538.781 130.977 538.781 131.336C538.781 131.737 538.865 132.07 539.031 132.336C539.203 132.602 539.474 132.839 539.844 133.047C540.219 133.25 540.714 133.464 541.328 133.688C542 133.932 542.57 134.193 543.039 134.469C543.508 134.74 543.865 135.073 544.109 135.469C544.354 135.859 544.477 136.357 544.477 136.961ZM554.055 128.578C554.992 128.578 555.766 128.695 556.375 128.93C556.99 129.159 557.448 129.51 557.75 129.984C558.052 130.458 558.203 131.062 558.203 131.797C558.203 132.401 558.094 132.906 557.875 133.312C557.656 133.714 557.37 134.039 557.016 134.289C556.661 134.539 556.284 134.732 555.883 134.867L559.016 140H557.469L554.672 135.234H552.297V140H550.969V128.578H554.055ZM553.977 129.727H552.297V134.109H554.109C555.042 134.109 555.727 133.919 556.164 133.539C556.607 133.159 556.828 132.599 556.828 131.859C556.828 131.083 556.594 130.534 556.125 130.211C555.661 129.888 554.945 129.727 553.977 129.727ZM563.945 131.281C564.674 131.281 565.299 131.443 565.82 131.766C566.341 132.089 566.74 132.542 567.016 133.125C567.292 133.703 567.43 134.38 567.43 135.156V135.961H561.516C561.531 136.966 561.781 137.732 562.266 138.258C562.75 138.784 563.432 139.047 564.312 139.047C564.854 139.047 565.333 138.997 565.75 138.898C566.167 138.799 566.599 138.654 567.047 138.461V139.602C566.615 139.794 566.185 139.935 565.758 140.023C565.336 140.112 564.836 140.156 564.258 140.156C563.435 140.156 562.716 139.99 562.102 139.656C561.492 139.318 561.018 138.823 560.68 138.172C560.341 137.521 560.172 136.724 560.172 135.781C560.172 134.859 560.326 134.062 560.633 133.391C560.945 132.714 561.383 132.193 561.945 131.828C562.513 131.464 563.18 131.281 563.945 131.281ZM563.93 132.344C563.237 132.344 562.685 132.57 562.273 133.023C561.862 133.477 561.617 134.109 561.539 134.922H566.07C566.065 134.411 565.984 133.964 565.828 133.578C565.677 133.188 565.445 132.885 565.133 132.672C564.82 132.453 564.419 132.344 563.93 132.344ZM572.398 139.094C572.612 139.094 572.831 139.076 573.055 139.039C573.279 139.003 573.461 138.958 573.602 138.906V139.914C573.451 139.982 573.24 140.039 572.969 140.086C572.703 140.133 572.443 140.156 572.188 140.156C571.734 140.156 571.323 140.078 570.953 139.922C570.583 139.76 570.286 139.49 570.062 139.109C569.844 138.729 569.734 138.203 569.734 137.531V132.453H568.516V131.82L569.742 131.312L570.258 129.453H571.039V131.438H573.547V132.453H571.039V137.492C571.039 138.029 571.161 138.43 571.406 138.695C571.656 138.961 571.987 139.094 572.398 139.094ZM582.406 131.438V140H581.344L581.156 138.797H581.086C580.909 139.094 580.68 139.344 580.398 139.547C580.117 139.75 579.799 139.901 579.445 140C579.096 140.104 578.724 140.156 578.328 140.156C577.651 140.156 577.083 140.047 576.625 139.828C576.167 139.609 575.82 139.271 575.586 138.812C575.357 138.354 575.242 137.766 575.242 137.047V131.438H576.555V136.953C576.555 137.667 576.716 138.201 577.039 138.555C577.362 138.904 577.854 139.078 578.516 139.078C579.151 139.078 579.656 138.958 580.031 138.719C580.411 138.479 580.685 138.128 580.852 137.664C581.018 137.195 581.102 136.622 581.102 135.945V131.438H582.406ZM589.039 131.281C589.211 131.281 589.391 131.292 589.578 131.312C589.766 131.328 589.932 131.352 590.078 131.383L589.914 132.586C589.773 132.549 589.617 132.521 589.445 132.5C589.273 132.479 589.112 132.469 588.961 132.469C588.617 132.469 588.292 132.539 587.984 132.68C587.682 132.815 587.417 133.013 587.188 133.273C586.958 133.529 586.779 133.839 586.648 134.203C586.518 134.562 586.453 134.964 586.453 135.406V140H585.148V131.438H586.227L586.367 133.016H586.422C586.599 132.698 586.812 132.409 587.062 132.148C587.312 131.883 587.602 131.672 587.93 131.516C588.263 131.359 588.633 131.281 589.039 131.281ZM595.75 131.281C596.766 131.281 597.534 131.531 598.055 132.031C598.576 132.526 598.836 133.323 598.836 134.422V140H597.555V134.508C597.555 133.794 597.391 133.26 597.062 132.906C596.74 132.552 596.242 132.375 595.57 132.375C594.622 132.375 593.956 132.643 593.57 133.18C593.185 133.716 592.992 134.495 592.992 135.516V140H591.695V131.438H592.742L592.938 132.672H593.008C593.19 132.37 593.422 132.117 593.703 131.914C593.984 131.706 594.299 131.549 594.648 131.445C594.997 131.336 595.365 131.281 595.75 131.281Z" fill="black" fill-opacity="0.2" />
    <path d="M487.57 140H486.234V129.75H482.641V128.578H491.148V129.75H487.57V140ZM501.945 134.18C501.945 135.466 501.711 136.542 501.242 137.406C500.773 138.266 500.094 138.914 499.203 139.352C498.318 139.784 497.242 140 495.977 140H492.875V128.578H496.32C497.482 128.578 498.482 128.792 499.32 129.219C500.159 129.641 500.805 130.268 501.258 131.102C501.716 131.93 501.945 132.956 501.945 134.18ZM500.547 134.227C500.547 133.201 500.375 132.354 500.031 131.688C499.693 131.021 499.193 130.526 498.531 130.203C497.875 129.875 497.07 129.711 496.117 129.711H494.203V138.859H495.82C497.393 138.859 498.573 138.471 499.359 137.695C500.151 136.919 500.547 135.763 500.547 134.227ZM510.93 136.961C510.93 137.638 510.76 138.216 510.422 138.695C510.089 139.169 509.62 139.531 509.016 139.781C508.411 140.031 507.701 140.156 506.883 140.156C506.451 140.156 506.042 140.135 505.656 140.094C505.271 140.052 504.917 139.992 504.594 139.914C504.271 139.836 503.987 139.74 503.742 139.625V138.352C504.133 138.513 504.609 138.664 505.172 138.805C505.734 138.94 506.323 139.008 506.938 139.008C507.51 139.008 507.995 138.932 508.391 138.781C508.786 138.625 509.086 138.404 509.289 138.117C509.497 137.826 509.602 137.477 509.602 137.07C509.602 136.68 509.516 136.354 509.344 136.094C509.172 135.828 508.885 135.589 508.484 135.375C508.089 135.156 507.547 134.924 506.859 134.68C506.375 134.508 505.948 134.32 505.578 134.117C505.208 133.909 504.898 133.674 504.648 133.414C504.398 133.154 504.208 132.852 504.078 132.508C503.953 132.164 503.891 131.771 503.891 131.328C503.891 130.719 504.044 130.198 504.352 129.766C504.664 129.328 505.094 128.995 505.641 128.766C506.193 128.531 506.826 128.414 507.539 128.414C508.148 128.414 508.711 128.471 509.227 128.586C509.747 128.701 510.224 128.854 510.656 129.047L510.242 130.188C509.831 130.016 509.393 129.872 508.93 129.758C508.471 129.643 507.997 129.586 507.508 129.586C507.018 129.586 506.604 129.659 506.266 129.805C505.932 129.945 505.677 130.146 505.5 130.406C505.323 130.667 505.234 130.977 505.234 131.336C505.234 131.737 505.318 132.07 505.484 132.336C505.656 132.602 505.927 132.839 506.297 133.047C506.672 133.25 507.167 133.464 507.781 133.688C508.453 133.932 509.023 134.193 509.492 134.469C509.961 134.74 510.318 135.073 510.562 135.469C510.807 135.859 510.93 136.357 510.93 136.961ZM517.398 128.578L513.148 140H511.867L516.125 128.578H517.398ZM522.648 140H521.312V129.75H517.719V128.578H526.227V129.75H522.648V140ZM532.836 129.586C532.206 129.586 531.638 129.695 531.133 129.914C530.633 130.128 530.206 130.44 529.852 130.852C529.503 131.258 529.234 131.75 529.047 132.328C528.859 132.906 528.766 133.557 528.766 134.281C528.766 135.24 528.914 136.073 529.211 136.781C529.513 137.484 529.961 138.029 530.555 138.414C531.154 138.799 531.901 138.992 532.797 138.992C533.307 138.992 533.786 138.951 534.234 138.867C534.688 138.779 535.128 138.669 535.555 138.539V139.695C535.138 139.852 534.701 139.966 534.242 140.039C533.784 140.117 533.24 140.156 532.609 140.156C531.448 140.156 530.477 139.917 529.695 139.438C528.919 138.953 528.336 138.271 527.945 137.391C527.56 136.51 527.367 135.471 527.367 134.273C527.367 133.409 527.487 132.62 527.727 131.906C527.971 131.188 528.326 130.568 528.789 130.047C529.258 129.526 529.831 129.125 530.508 128.844C531.19 128.557 531.971 128.414 532.852 128.414C533.43 128.414 533.987 128.471 534.523 128.586C535.06 128.701 535.544 128.865 535.977 129.078L535.445 130.203C535.081 130.036 534.68 129.893 534.242 129.773C533.81 129.648 533.341 129.586 532.836 129.586ZM544.477 136.961C544.477 137.638 544.307 138.216 543.969 138.695C543.635 139.169 543.167 139.531 542.562 139.781C541.958 140.031 541.247 140.156 540.43 140.156C539.997 140.156 539.589 140.135 539.203 140.094C538.818 140.052 538.464 139.992 538.141 139.914C537.818 139.836 537.534 139.74 537.289 139.625V138.352C537.68 138.513 538.156 138.664 538.719 138.805C539.281 138.94 539.87 139.008 540.484 139.008C541.057 139.008 541.542 138.932 541.938 138.781C542.333 138.625 542.633 138.404 542.836 138.117C543.044 137.826 543.148 137.477 543.148 137.07C543.148 136.68 543.062 136.354 542.891 136.094C542.719 135.828 542.432 135.589 542.031 135.375C541.635 135.156 541.094 134.924 540.406 134.68C539.922 134.508 539.495 134.32 539.125 134.117C538.755 133.909 538.445 133.674 538.195 133.414C537.945 133.154 537.755 132.852 537.625 132.508C537.5 132.164 537.438 131.771 537.438 131.328C537.438 130.719 537.591 130.198 537.898 129.766C538.211 129.328 538.641 128.995 539.188 128.766C539.74 128.531 540.372 128.414 541.086 128.414C541.695 128.414 542.258 128.471 542.773 128.586C543.294 128.701 543.771 128.854 544.203 129.047L543.789 130.188C543.378 130.016 542.94 129.872 542.477 129.758C542.018 129.643 541.544 129.586 541.055 129.586C540.565 129.586 540.151 129.659 539.812 129.805C539.479 129.945 539.224 130.146 539.047 130.406C538.87 130.667 538.781 130.977 538.781 131.336C538.781 131.737 538.865 132.07 539.031 132.336C539.203 132.602 539.474 132.839 539.844 133.047C540.219 133.25 540.714 133.464 541.328 133.688C542 133.932 542.57 134.193 543.039 134.469C543.508 134.74 543.865 135.073 544.109 135.469C544.354 135.859 544.477 136.357 544.477 136.961ZM554.055 128.578C554.992 128.578 555.766 128.695 556.375 128.93C556.99 129.159 557.448 129.51 557.75 129.984C558.052 130.458 558.203 131.062 558.203 131.797C558.203 132.401 558.094 132.906 557.875 133.312C557.656 133.714 557.37 134.039 557.016 134.289C556.661 134.539 556.284 134.732 555.883 134.867L559.016 140H557.469L554.672 135.234H552.297V140H550.969V128.578H554.055ZM553.977 129.727H552.297V134.109H554.109C555.042 134.109 555.727 133.919 556.164 133.539C556.607 133.159 556.828 132.599 556.828 131.859C556.828 131.083 556.594 130.534 556.125 130.211C555.661 129.888 554.945 129.727 553.977 129.727ZM563.945 131.281C564.674 131.281 565.299 131.443 565.82 131.766C566.341 132.089 566.74 132.542 567.016 133.125C567.292 133.703 567.43 134.38 567.43 135.156V135.961H561.516C561.531 136.966 561.781 137.732 562.266 138.258C562.75 138.784 563.432 139.047 564.312 139.047C564.854 139.047 565.333 138.997 565.75 138.898C566.167 138.799 566.599 138.654 567.047 138.461V139.602C566.615 139.794 566.185 139.935 565.758 140.023C565.336 140.112 564.836 140.156 564.258 140.156C563.435 140.156 562.716 139.99 562.102 139.656C561.492 139.318 561.018 138.823 560.68 138.172C560.341 137.521 560.172 136.724 560.172 135.781C560.172 134.859 560.326 134.062 560.633 133.391C560.945 132.714 561.383 132.193 561.945 131.828C562.513 131.464 563.18 131.281 563.945 131.281ZM563.93 132.344C563.237 132.344 562.685 132.57 562.273 133.023C561.862 133.477 561.617 134.109 561.539 134.922H566.07C566.065 134.411 565.984 133.964 565.828 133.578C565.677 133.188 565.445 132.885 565.133 132.672C564.82 132.453 564.419 132.344 563.93 132.344ZM572.398 139.094C572.612 139.094 572.831 139.076 573.055 139.039C573.279 139.003 573.461 138.958 573.602 138.906V139.914C573.451 139.982 573.24 140.039 572.969 140.086C572.703 140.133 572.443 140.156 572.188 140.156C571.734 140.156 571.323 140.078 570.953 139.922C570.583 139.76 570.286 139.49 570.062 139.109C569.844 138.729 569.734 138.203 569.734 137.531V132.453H568.516V131.82L569.742 131.312L570.258 129.453H571.039V131.438H573.547V132.453H571.039V137.492C571.039 138.029 571.161 138.43 571.406 138.695C571.656 138.961 571.987 139.094 572.398 139.094ZM582.406 131.438V140H581.344L581.156 138.797H581.086C580.909 139.094 580.68 139.344 580.398 139.547C580.117 139.75 579.799 139.901 579.445 140C579.096 140.104 578.724 140.156 578.328 140.156C577.651 140.156 577.083 140.047 576.625 139.828C576.167 139.609 575.82 139.271 575.586 138.812C575.357 138.354 575.242 137.766 575.242 137.047V131.438H576.555V136.953C576.555 137.667 576.716 138.201 577.039 138.555C577.362 138.904 577.854 139.078 578.516 139.078C579.151 139.078 579.656 138.958 580.031 138.719C580.411 138.479 580.685 138.128 580.852 137.664C581.018 137.195 581.102 136.622 581.102 135.945V131.438H582.406ZM589.039 131.281C589.211 131.281 589.391 131.292 589.578 131.312C589.766 131.328 589.932 131.352 590.078 131.383L589.914 132.586C589.773 132.549 589.617 132.521 589.445 132.5C589.273 132.479 589.112 132.469 588.961 132.469C588.617 132.469 588.292 132.539 587.984 132.68C587.682 132.815 587.417 133.013 587.188 133.273C586.958 133.529 586.779 133.839 586.648 134.203C586.518 134.562 586.453 134.964 586.453 135.406V140H585.148V131.438H586.227L586.367 133.016H586.422C586.599 132.698 586.812 132.409 587.062 132.148C587.312 131.883 587.602 131.672 587.93 131.516C588.263 131.359 588.633 131.281 589.039 131.281ZM595.75 131.281C596.766 131.281 597.534 131.531 598.055 132.031C598.576 132.526 598.836 133.323 598.836 134.422V140H597.555V134.508C597.555 133.794 597.391 133.26 597.062 132.906C596.74 132.552 596.242 132.375 595.57 132.375C594.622 132.375 593.956 132.643 593.57 133.18C593.185 133.716 592.992 134.495 592.992 135.516V140H591.695V131.438H592.742L592.938 132.672H593.008C593.19 132.37 593.422 132.117 593.703 131.914C593.984 131.706 594.299 131.549 594.648 131.445C594.997 131.336 595.365 131.281 595.75 131.281Z" fill="black" fill-opacity="0.2" />
    <path d="M346 305L351.774 295L340.226 295L346 305ZM345 264L345 296L347 296L347 264L345 264Z" fill="black" />
    <path d="M345 216L350.774 206L339.226 206L345 216ZM344 175L344 207L346 207L346 175L344 175Z" fill="black" />
  </svg>

)